(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[889],{

/***/ 33174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ settingsActions; }
/* harmony export */ });
/* unused harmony export settingsActionsConstants */
/* harmony import */ var _shared_store_settings_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58538);


const settingsActionsConstants = (/* unused pure expression or super */ null && (_sharedActionsConstantsSettings));
const settingsActions = _shared_store_settings_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsSettings */ .a;


/***/ }),

/***/ 43889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Reader_Reader; },
  "n": function() { return /* binding */ useReaderContext; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(56253);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ./src/next/store/actions/index.js + 6 modules
var actions = __webpack_require__(62013);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ./src/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(37462);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
// EXTERNAL MODULE: ../shared/utils/contact-us/constants.js
var constants = __webpack_require__(45884);
// EXTERNAL MODULE: ../shared/utils/reader/constants.js
var reader_constants = __webpack_require__(16484);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ./src/next/components/index.js + 9 modules
var components = __webpack_require__(78239);
// EXTERNAL MODULE: ./src/next/components/Reader/ParaList/para-list.module.scss
var para_list_module = __webpack_require__(48928);
var para_list_module_default = /*#__PURE__*/__webpack_require__.n(para_list_module);
;// CONCATENATED MODULE: ./src/next/components/Reader/ParaList/BookInfoInReader.js







var getTranslationByKeys = function getTranslationByKeys(_ref) {
  var t = _ref.t,
      i18n = _ref.i18n;

  for (var index = 0; index < (arguments.length <= 1 ? 0 : arguments.length - 1); index++) {
    var key = index + 1 < 1 || arguments.length <= index + 1 ? undefined : arguments[index + 1];

    if (i18n.exists(key)) {
      return t(key);
    }
  }

  return "";
};

function BookInfoInReader(_ref2) {
  var book = _ref2.book,
      offsetTop = _ref2.offsetTop;
  var i18n = (0,esm/* useTranslation */.$G)();
  var id = book.book_id;
  var bookDescTranslation = getTranslationByKeys(i18n, "books:info".concat(id), "books:desc".concat(id));
  var bookDesc = bookDescTranslation || (book === null || book === void 0 ? void 0 : book.description) || "";
  return /*#__PURE__*/react.createElement("div", {
    style: {
      marginTop: offsetTop
    }
  }, /*#__PURE__*/react.createElement("img", {
    src: (0,url/* getBookCover */.Ow)(book, true),
    style: {
      float: "left",
      paddingRight: "0.5rem",
      maxWidth: "100%",
      marginBottom: "2rem"
    }
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: (para_list_module_default())["info-bookDesc"]
  }, /*#__PURE__*/react.createElement("h2", null, book.title), book.author.length > 0 && /*#__PURE__*/react.createElement("div", {
    className: "bookInfoAuthor " + book.realType
  }, "By ".concat(book.author)), /*#__PURE__*/react.createElement("p", {
    className: "bookInfoDescription",
    dangerouslySetInnerHTML: {
      __html: book.description
    }
  }), book.code && /*#__PURE__*/react.createElement("p", {
    className: "bookInfoSmallMargin book-code"
  }, "".concat(i18n.t("book_code"), ": ").concat(book.code)), book.publisher && /*#__PURE__*/react.createElement("p", {
    className: "bookInfoBigMargin"
  }, i18n.t("publishedBy", {
    publisher: ""
  }), /*#__PURE__*/react.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: book.publisher
    }
  })), book.isbn && /*#__PURE__*/react.createElement("p", {
    className: "bookInfoSmallMargin"
  }, "ISBN: ".concat(book.isbn)), book.cite && /*#__PURE__*/react.createElement("p", {
    className: "bookInfoBigMargin"
  }, i18n.t("citation", {
    cite: ""
  }), /*#__PURE__*/react.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: book.cite
    }
  })), bookDesc && /*#__PURE__*/react.createElement("div", {
    className: (para_list_module_default())["book-info"],
    dangerouslySetInnerHTML: {
      __html: bookDesc
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: (para_list_module_default())["info-buttons"]
  }, /*#__PURE__*/react.createElement(components/* BookActions */.i$, {
    isLanding: true,
    book: book,
    isBookInfoActions: true
  }))));
}

BookInfoInReader.propTypes = {
  book: (prop_types_default()).object,
  offsetTop: (prop_types_default()).any
};
/* harmony default export */ var ParaList_BookInfoInReader = (BookInfoInReader);
;// CONCATENATED MODULE: ./src/next/components/Reader/ParaList/ParaList.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var isSkipRenderPara = function isSkipRenderPara(para) {
  return para.element_type === "h1";
};

var isParaPicture = function isParaPicture(para) {
  return para.content.indexOf("Picture:") > -1;
};

var ParaList = function ParaList(_ref) {
  var firstParaOffsetTop = _ref.firstParaOffsetTop,
      showTranslations = _ref.showTranslations,
      showRefCodes = _ref.showRefCodes,
      activeId = _ref.activeId,
      items = _ref.items,
      onClickTranslate = _ref.onClickTranslate,
      onClickAnchor = _ref.onClickAnchor;

  if (!items.paras) {
    return null;
  }

  if (items.paras[0].isBookInfo) {
    var _items$paras$2 = items.paras[0],
        book = _items$paras$2.book,
        para_id = _items$paras$2.para_id;
    return /*#__PURE__*/react.createElement(ParaList_BookInfoInReader, {
      book: book,
      offsetTop: firstParaOffsetTop
    });
  }

  var hasChapterImage = items.paras.some(function (para) {
    return isParaPicture(para);
  });
  return items.paras.map(function (item, index, arr) {
    var style;

    if (!hasChapterImage && (index === 0 || index === 1 && isSkipRenderPara(arr[0]) && firstParaOffsetTop)) {
      style = {
        paddingTop: firstParaOffsetTop
      };
    }

    var Element = item.element_type;
    var id = item["para_id"];

    if (isSkipRenderPara(item)) {
      return null;
    }

    if (isParaPicture(item)) {
      return /*#__PURE__*/react.createElement("img", {
        key: index,
        className: (para_list_module_default())[content_constants/* CONTENT_CLASSES.PICTURE */.J8.PICTURE],
        style: {
          paddingTop: firstParaOffsetTop
        },
        src: item.content.match(constants/* paraPictureRegExp */.zn)[2]
      });
    }

    if (Element === "p") {
      var _item$translations;

      var btnTranslation;

      if (showTranslations && item !== null && item !== void 0 && (_item$translations = item.translations) !== null && _item$translations !== void 0 && _item$translations.length) {
        btnTranslation = /*#__PURE__*/react.createElement(IconView/* default */.Z, {
          icon: EgwWebFont/* default.translation */.Z.translation,
          onClick: function onClick(e) {
            onClickTranslate(e, item);
          },
          className: classnames_default()("reader-translate-icon", content_constants/* CONTENT_CLASSES.ICON_TRANSLATE */.J8.ICON_TRANSLATE),
          "data-translations": id
        });
      }

      return /*#__PURE__*/react.createElement(Element, _extends({
        className: classnames_default()((para_list_module_default()).para, reader_constants/* READER_VIEW_CLASS_NAME_PARA_WRAP */.IJ, content_constants/* CONTENT_CLASSES.PARAGRAPH */.J8.PARAGRAPH, item.element_subtype, {
          active: activeId === id
        }),
        style: style,
        id: id
      }, _defineProperty({}, reader_constants/* DATA_ATTR_PARA_ID */.vl, id), {
        key: index
      }), /*#__PURE__*/react.createElement("span", {
        className: reader_constants/* READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY */.Lt,
        dangerouslySetInnerHTML: {
          __html: item.content
        }
      }), "\xA0", item.refcode_short && showRefCodes && /*#__PURE__*/react.createElement("span", {
        className: classnames_default()((para_list_module_default()).refCode, content_constants/* CONTENT_CLASSES.REF_CODE */.J8.REF_CODE),
        onClick: function onClick(e) {
          return onClickAnchor(e, item);
        }
      }, item.refcode_short, /*#__PURE__*/react.createElement("span", {
        className: "anchor-link"
      }, /*#__PURE__*/react.createElement("i", {
        className: "icon-anchor"
      }))), btnTranslation);
    }

    return /*#__PURE__*/react.createElement(Element, _extends({
      key: index,
      id: id
    }, _defineProperty({}, reader_constants/* DATA_ATTR_PARA_ID */.vl, id), {
      className: classnames_default()((para_list_module_default()).para, reader_constants/* READER_VIEW_CLASS_NAME_PARA_WRAP */.IJ, reader_constants/* READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY */.Lt, item.element_type, item.element_subtype, {
        active: activeId === id
      }),
      style: style // an empty space to not glue the text to the next paragraph on print/copy
      ,
      dangerouslySetInnerHTML: {
        __html: item.content + " "
      }
    }));
  });
};

ParaList.propTypes = {
  showTranslations: (prop_types_default()).bool,
  showRefCodes: (prop_types_default()).bool,
  activeId: (prop_types_default()).string,
  items: (prop_types_default()).object,
  onClick: (prop_types_default()).func,
  onClickAnchor: (prop_types_default()).func,
  onClickTranslate: (prop_types_default()).func
};
/* harmony default export */ var ParaList_ParaList = (ParaList);
// EXTERNAL MODULE: ../shared/utils/reader/reader.js
var reader = __webpack_require__(18664);
// EXTERNAL MODULE: ../shared/contexts/AudioContext.js
var AudioContext = __webpack_require__(77926);
;// CONCATENATED MODULE: ./src/assets/ReaderIcons.js
function ReaderIcons_extends() { ReaderIcons_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ReaderIcons_extends.apply(this, arguments); }

/* eslint-disable max-len */

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", ReaderIcons_extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM9.99982 6.85299C11.0689 6.85299 11.9356 5.98632 11.9356 4.91723C11.9356 3.84814 11.0689 2.98147 9.99982 2.98147C8.93073 2.98147 8.06406 3.84814 8.06406 4.91723C8.06406 5.98632 8.93073 6.85299 9.99982 6.85299ZM8.04744 8.83809C8.04744 8.19763 8.92208 7.97699 9.99976 7.97699C11.0774 7.97699 11.9521 8.19763 11.9521 8.83809V16.1574C11.9521 16.8261 11.0774 17.0185 9.99976 17.0185C8.92208 17.0185 8.04744 16.8338 8.04744 16.1574V8.83809Z"
  }));
};
var LayoutsIcon = function LayoutsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", ReaderIcons_extends({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 0H1.5C0.67 0 0 0.67 0 1.5V16C0 16.83 0.67 17.5 1.5 17.5H16C16.83 17.5 17.5 16.83 17.5 16V1.5C17.5 0.67 16.83 0 16 0ZM15.48 3.61H2.02C1.74 3.61 1.52 3.39 1.52 3.11V2.02C1.52 1.74 1.74 1.52 2.02 1.52H15.49C15.77 1.52 15.99 1.74 15.99 2.02V3.11C15.98 3.39 15.76 3.61 15.48 3.61ZM1.52 5.62C1.52 5.34 1.74 5.12 2.02 5.12H4.92C5.2 5.12 5.42 5.34 5.42 5.62V15.48C5.42 15.76 5.2 15.98 4.92 15.98H2.02C1.74 15.98 1.52 15.76 1.52 15.48V5.62ZM6.93 5.62C6.93 5.34 7.15 5.12 7.43 5.12H15.48C15.76 5.12 15.98 5.34 15.98 5.62V15.48C15.98 15.76 15.76 15.98 15.48 15.98H7.43C7.15 15.98 6.93 15.76 6.93 15.48V5.62Z"
  }));
};
var PdfIcon = function PdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", ReaderIcons_extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.0499 11.31V9.76001H13.9299V19H15.7999V15.23H18.6999V13.68H15.7999V11.31H19.0499Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93999 9.76001H7.48999V19H9.87999C11.01 19 11.89 18.66 12.53 17.97C13.17 17.28 13.49 16.32 13.49 15.11V13.61C13.48 12.42 13.15 11.48 12.51 10.79C11.87 10.1 11.01 9.76001 9.93999 9.76001ZM11.63 15.26C11.62 16.06 11.48 16.63 11.23 16.96C10.98 17.29 10.54 17.45 9.91999 17.45H9.35999V11.31H10.04C10.62 11.33 11.03 11.51 11.27 11.85C11.51 12.19 11.63 12.79 11.63 13.65V15.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15 9.76001H1V19H2.87V15.75H4.11C5.06 15.75 5.81 15.49 6.34 14.96C6.88 14.44 7.15 13.72 7.15 12.81C7.15 11.9 6.88 11.17 6.33 10.6C5.79 10.04 5.06 9.76001 4.15 9.76001ZM4.97 13.85C4.78 14.08 4.5 14.2 4.14 14.2H2.87V11.32H4.17C4.5 11.32 4.77 11.46 4.97 11.74C5.17 12.01 5.27 12.38 5.27 12.84C5.27 13.27 5.17 13.61 4.97 13.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58006 1.82C8.41006 1.9 9.34006 3.73 9.46006 4.03V9H10.1601V4.03C10.2901 3.7 11.2501 1.9 16.0401 1.82V9H17.8101V1.98H17.2801C17.0601 1.98 16.8501 1.98 16.6301 1.99V1H16.4001C11.8401 1 10.3101 2.51 9.81006 3.32C9.32006 2.51 7.79006 1 3.23006 1H2.99006V1.99C2.78006 1.98 2.57006 1.98 2.35006 1.98H1.81006V9H3.58006V1.82Z"
  }));
};
var EpubIcon = function EpubIcon(props) {
  return /*#__PURE__*/React.createElement("svg", ReaderIcons_extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.46019 9V4.03C9.37632 3.82033 8.89681 2.86333 6.9668 2.27871L7.1219 1.5C8.77228 2.01313 9.49984 2.80697 9.81019 3.32C10.3102 2.51 11.8402 1 16.4002 1H16.6302V1.99C16.8502 1.98 17.0602 1.98 17.2802 1.98H17.8102V9H16.0402V1.82C11.2502 1.9 10.2902 3.7 10.1602 4.03V9H9.46019Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96117 8.93432C3.02979 8.93432 2.30349 8.6665 1.78227 8.13088C1.26104 7.59525 1.00043 6.82889 1.00043 5.8318V5.30029C1.00043 4.24552 1.23968 3.43177 1.71818 2.85906C2.19669 2.28635 2.8824 2 3.77532 2C4.64688 2 5.30268 2.26987 5.74274 2.80962C6.18279 3.34525 6.40709 4.14045 6.41563 5.19522V6.05429H2.80763C2.83327 6.54871 2.94648 6.91129 3.14728 7.14202C3.34808 7.36864 3.65783 7.48194 4.07652 7.48194C4.68319 7.48194 5.18947 7.28211 5.59534 6.88245L6.30669 7.93929C6.08452 8.23594 5.76196 8.47697 5.339 8.66238C4.91604 8.84367 4.45676 8.93432 3.96117 8.93432ZM2.82045 4.83059H4.63406V4.6699C4.62552 4.27024 4.55716 3.9674 4.42899 3.76139C4.30082 3.55538 4.07866 3.45237 3.7625 3.45237C3.44635 3.45237 3.21564 3.56156 3.07038 3.77993C2.92939 3.9983 2.84608 4.34852 2.82045 4.83059Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88411 15.7121V18.8764H1V9.87785H4.17863C5.10146 9.87785 5.8363 10.1539 6.38316 10.706C6.9343 11.2581 7.20986 11.975 7.20986 12.8568C7.20986 13.7385 6.93857 14.4348 6.39598 14.9457C5.85339 15.4566 5.10146 15.7121 4.14018 15.7121H2.88411ZM2.88411 14.1979H4.17863C4.53751 14.1979 4.81521 14.0846 5.01174 13.858C5.20827 13.6314 5.30653 13.3017 5.30653 12.8691C5.30653 12.42 5.20613 12.0636 5.00533 11.7999C4.80453 11.5321 4.53537 11.3961 4.19785 11.392H2.88411V14.1979Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5569 9.87785V16.1076C13.5483 17.0429 13.2813 17.7598 12.7558 18.2584C12.2303 18.7528 11.4762 19 10.4936 19C9.49386 19 8.72911 18.7487 8.19934 18.246C7.67384 17.7433 7.41109 17.0161 7.41109 16.0643V9.87785H9.30801V16.0705C9.30801 16.5814 9.39346 16.9461 9.56435 17.1644C9.73525 17.3828 10.045 17.492 10.4936 17.492C10.9422 17.492 11.2498 17.3849 11.4164 17.1706C11.583 16.9523 11.6685 16.5959 11.6728 16.1014V9.87785H13.5569Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0016 18.8764V9.87785H16.8855C17.8596 9.87785 18.5987 10.088 19.1028 10.5082C19.6112 10.9244 19.8654 11.5362 19.8654 12.3438C19.8654 12.8011 19.7607 13.1946 19.5514 13.5242C19.3421 13.8539 19.0558 14.0949 18.6927 14.2473C19.1113 14.3627 19.4339 14.5955 19.6603 14.9457C19.8868 15.2918 20 15.7203 20 16.2312C20 17.1047 19.7501 17.7639 19.2502 18.2089C18.7546 18.6539 18.0347 18.8764 17.0905 18.8764H14.0016ZM15.8857 14.9643V17.3684H17.0905C17.428 17.3684 17.6844 17.2675 17.8596 17.0656C18.0347 16.8637 18.1223 16.5773 18.1223 16.2065C18.1223 15.3989 17.819 14.9849 17.2123 14.9643H15.8857ZM15.8857 13.6417H16.8662C17.6053 13.6417 17.9749 13.2729 17.9749 12.5354C17.9749 12.1275 17.8895 11.8349 17.7186 11.6578C17.5477 11.4806 17.27 11.392 16.8855 11.392H15.8857V13.6417Z"
  }));
};
var CopyIcon = function CopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", ReaderIcons_extends({
    width: "19",
    height: "18",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.10523 14.6361V1.44922H1.75963C0.786659 1.44922 0 2.03921 0 2.75342V16.6959C0 17.4205 0.786659 18.0001 1.75963 18.0001H14.812C15.7849 18.0001 16.5612 17.4101 16.5612 16.6959V15.9403H4.75101C3.73663 15.9403 3.10523 15.2572 3.10523 14.6361Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9052 4.6682C13.6113 4.49224 12.5659 3.70558 12.214 2.6705C12.1312 2.43243 12.069 2.17366 12.069 1.91489V0H4.75105C4.0886 0 3.72632 0.40368 3.72632 0.693502V1.44911V14.636C3.72632 14.9258 4.0886 15.3191 4.75105 15.3191H16.5613H16.9857C17.2858 15.3191 17.5653 15.2363 17.762 15.0707C17.9172 14.9465 18.0104 14.7809 18.0104 14.636V4.7096H15.4434C15.2571 4.7096 15.0811 4.6889 14.9052 4.6682Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4429 2.90852H16.9748L14.1077 0.631348V1.90449C14.1077 2.40133 14.6356 2.90852 15.4429 2.90852Z"
  }));
};
var PrintIcon = function PrintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", ReaderIcons_extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 14.3333H6.00008C5.81575 14.3333 5.66675 14.4823 5.66675 14.6666C5.66675 14.8509 5.81575 14.9999 6.00008 14.9999H14.0001C14.1844 14.9999 14.3334 14.8509 14.3334 14.6666C14.3334 14.4823 14.1844 14.3333 14.0001 14.3333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 16H6.00008C5.81575 16 5.66675 16.149 5.66675 16.3333C5.66675 16.5177 5.81575 16.6667 6.00008 16.6667H14.0001C14.1844 16.6667 14.3334 16.5177 14.3334 16.3333C14.3334 16.149 14.1844 16 14.0001 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5.66667V0.999999C17 0.447715 16.5523 0 16 0H4C3.44772 0 3 0.447715 3 1V5.66667H2C0.895431 5.66667 0 6.5621 0 7.66667V15C0 16.1046 0.895431 17 2 17C2 17.5523 2.44772 18 3 18V19C3 19.5523 3.44772 20 4 20H16C16.5523 20 17 19.5523 17 19V18C17.5523 18 18 17.5523 18 17C19.1046 17 20 16.1046 20 15V7.66667C20 6.5621 19.1046 5.66667 18 5.66667H17ZM3.66667 1.66667C3.66667 1.11438 4.11438 0.666667 4.66667 0.666667H15.3333C15.8856 0.666667 16.3333 1.11438 16.3333 1.66667V5.66667H3.66667V1.66667ZM16.3333 18V18.3333C16.3333 18.8856 15.8856 19.3333 15.3333 19.3333H4.66667C4.11438 19.3333 3.66667 18.8856 3.66667 18.3333V18V12.3333H16.3333V18ZM16.6667 10.6667C15.7477 10.6667 15 9.919 15 9C15 8.081 15.7477 7.33333 16.6667 7.33333C17.5857 7.33333 18.3333 8.081 18.3333 9C18.3333 9.919 17.5857 10.6667 16.6667 10.6667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10C17.219 10 17.6667 9.55228 17.6667 9C17.6667 8.44772 17.219 8 16.6667 8C16.1145 8 15.6667 8.44772 15.6667 9C15.6667 9.55228 16.1145 10 16.6667 10Z"
  }));
};
var ReaderArrowIcon = function ReaderArrowIcon(props) {
  return /*#__PURE__*/react.createElement("svg", ReaderIcons_extends({
    width: "10",
    height: "12",
    viewBox: "0 0 10 12"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M8.57084 5.14251C9.21818 5.53091 9.21818 6.46909 8.57084 6.85749L1.5145 11.0913C0.847972 11.4912 4.72364e-07 11.0111 5.0634e-07 10.2338L8.76472e-07 1.76619C9.10448e-07 0.988895 0.847972 0.508782 1.5145 0.908697L8.57084 5.14251Z"
  }));
};
var NewTabIcon = function NewTabIcon(props) {
  return /*#__PURE__*/React.createElement("svg", ReaderIcons_extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.5V17.5H2.5V6.5H5.5V5H2C1.45 5 1 5.45 1 6V18C1 18.55 1.45 19 2 19H14C14.55 19 15 18.55 15 18V14.5H13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5L11 15.5L11 14L8.75 14L5.5 14L5.5 2.5L17.5 2.5L17.5 14L11 14L11 15.5L18 15.5C18.55 15.5 19 15.05 19 14.5L19 2C19 1.45 18.55 1 18 1L5 1C4.45 1 4 1.45 4 2L4 14.5C4 15.05 4.45 15.5 5 15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29547 12.0743C8.58538 12.3642 9.06621 12.3642 9.35613 12.0743L14.7938 6.63663L14.7938 8.36197C14.7938 8.77209 15.1332 9.1115 15.5433 9.1115C15.9534 9.1115 16.2928 8.77209 16.2928 8.36197L16.2928 4.82643C16.2928 4.72744 16.2787 4.62844 16.2363 4.54359C16.2009 4.45167 16.1444 4.36681 16.0736 4.2961C16.0029 4.22539 15.9181 4.16882 15.8262 4.13347C15.7342 4.09811 15.6423 4.0769 15.5433 4.0769L12.0078 4.0769C11.5977 4.0769 11.2582 4.41631 11.2582 4.82643C11.2582 5.23655 11.5977 5.57596 12.0078 5.57596L13.7331 5.57597L8.29547 11.0136C8.00555 11.3035 8.00555 11.7844 8.29547 12.0743Z"
  }));
};
// EXTERNAL MODULE: ../shared/store/system/selectors.js
var selectors = __webpack_require__(91809);
// EXTERNAL MODULE: ../shared/components/ReaderModeOnlyElement.module.scss
var ReaderModeOnlyElement_module = __webpack_require__(37741);
var ReaderModeOnlyElement_module_default = /*#__PURE__*/__webpack_require__.n(ReaderModeOnlyElement_module);
;// CONCATENATED MODULE: ../shared/components/ReaderModeOnlyElement.js



var ReaderModeOnlyElement = function ReaderModeOnlyElement(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react.createElement("div", {
    className: (ReaderModeOnlyElement_module_default()).root
  }, children);
};

/* harmony default export */ var components_ReaderModeOnlyElement = (ReaderModeOnlyElement);
// EXTERNAL MODULE: ../shared/utils/number/number.js
var number = __webpack_require__(50150);
// EXTERNAL MODULE: ../shared/components/Select/SelectVariantIconButton.js
var SelectVariantIconButton = __webpack_require__(66158);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/store/mainTree/selectors.js
var mainTree_selectors = __webpack_require__(47725);
// EXTERNAL MODULE: ../shared/store/search/selectors.js
var search_selectors = __webpack_require__(24803);
// EXTERNAL MODULE: ../shared/store/search/constants.js
var search_constants = __webpack_require__(76713);
;// CONCATENATED MODULE: ../shared/hooks/useDisableOverscroll.js


/**
 * @see: https://stackoverflow.com/a/36096145/7689963
 */

var useDisableOverscroll = function useDisableOverscroll(classname) {
  (0,react.useEffect)(function () {
    if (!lib/* isFirefox */.vU) {
      return undefined;
    }

    var scroll = function scroll(event) {
      if (event.target && event.target.classList.contains(classname)) {
        var element = event.target;
        var delta = event.type === "mousewheel" ? event.wheelDelta : event.detail * -40;

        if (delta < 0 && element.scrollHeight - element.offsetHeight - element.scrollTop <= 0) {
          element.scrollTop = element.scrollHeight;
          event.preventDefault();
        } else if (delta > 0 && delta > element.scrollTop) {
          element.scrollTop = 0;
          event.preventDefault();
        }
      }
    };

    document.addEventListener("mousewheel", scroll);
    document.addEventListener("DOMMouseScroll", scroll);
    return function () {
      document.removeEventListener("mousewheel", scroll);
      document.removeEventListener("DOMMouseScroll", scroll);
    };
  }, [classname]);
};

/* harmony default export */ var hooks_useDisableOverscroll = (useDisableOverscroll);
// EXTERNAL MODULE: ../shared/store/settings/selectors.js
var settings_selectors = __webpack_require__(4787);
// EXTERNAL MODULE: ./src/next/store/actions/settings.actions.js
var settings_actions = __webpack_require__(90487);
// EXTERNAL MODULE: ../shared/hooks/useRefData.js
var useRefData = __webpack_require__(40462);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var settings_constants = __webpack_require__(20467);
// EXTERNAL MODULE: ./src/next/components/Reader/DictionaryPopup/dictionary-popup.module.scss
var dictionary_popup_module = __webpack_require__(87592);
var dictionary_popup_module_default = /*#__PURE__*/__webpack_require__.n(dictionary_popup_module);
;// CONCATENATED MODULE: ./src/next/components/Reader/DictionaryPopup/DictionaryPopup.js























var Popup = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4701));
}, {
  ssr: false
});
var DICTIONARY_POPUP_CLASSNAME = "dictionary-popup";

var DictionaryPopup = function DictionaryPopup(_ref) {
  var search = _ref.search,
      isShown = _ref.isShown,
      anchorEl = _ref.anchorEl,
      contentWrapElRect = _ref.contentWrapElRect,
      onHidePopup = _ref.onHidePopup,
      className = _ref.className;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var dictionaries = (0,es/* useSelector */.v9)(mainTree_selectors/* selectorMainTreeDictionaries */.CL);
  var searchDictionary = (0,es/* useSelector */.v9)(search_selectors/* selectorSearchResultsDictionary */.RH);
  var dictionaryFilter = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.dictionaryFilter.id */.Fy.dictionaryFilter.id));
  var isLoading = (0,es/* useSelector */.v9)(function (state) {
    return (0,selectors/* selectorLoaderById */.Uw)(state, search_constants/* LOADER_ID_DICTIONARY_LOAD */.RR);
  });
  hooks_useDisableOverscroll(DICTIONARY_POPUP_CLASSNAME);

  var _useReaderContext = useReaderContext(),
      updatePanel = _useReaderContext.updatePanel,
      scrollParaIntoView = _useReaderContext.scrollParaIntoView,
      panelsIds = _useReaderContext.panelsIds;

  var refData = (0,useRefData/* default */.Z)({
    panelsIds: panelsIds
  }); // Search for a word on {search} change.

  (0,react.useEffect)(function () {
    if (!search) {
      return;
    }

    dispatch(actions/* searchActions.searchDictionary */.RR.searchDictionary(search, dictionaryFilter));
  }, [search, dictionaryFilter]);
  var changeDictionaryFilter = (0,react.useCallback)(function (key) {
    dispatch(settings_actions/* settingsActions.updateSettings */.f.updateSettings(settings_constants/* SETTING.dictionaryFilter.id */.Fy.dictionaryFilter.id, key));
  }, []);

  var handleClickDictionaryItem = function handleClickDictionaryItem(event, item) {
    event.preventDefault();
    var panelsIds = refData.current.panelsIds;
    var idItem = item.para_id;
    var indexPanelWithItem = panelsIds.findIndex(function (p) {
      return (0,content/* isSameBook */.fr)(p, idItem);
    });

    if (indexPanelWithItem === -1) {
      updatePanel(1, idItem);
    } else {
      if (panelsIds[indexPanelWithItem] === idItem) {
        scrollParaIntoView(indexPanelWithItem, idItem);
      } else {
        updatePanel(indexPanelWithItem, idItem);
      }
    }

    onHidePopup();
  };

  var handleMouseUp = function handleMouseUp(event) {
    event.stopPropagation();
  };

  var renderResults = function renderResults() {
    if (isLoading) {
      return /*#__PURE__*/react.createElement(Typography/* default */.Z, {
        variant: "body4",
        color: "default"
      }, t("loading"), "\u2026");
    }

    if (!searchDictionary.length) {
      return /*#__PURE__*/react.createElement(Typography/* default */.Z, {
        variant: "body4",
        color: "default"
      }, t("word_not_found_in_dictionary"));
    }

    return searchDictionary.map(function (item) {
      return /*#__PURE__*/react.createElement("span", {
        key: item.para_id,
        onClick: function onClick(event) {
          return handleClickDictionaryItem(event, item);
        },
        className: (dictionary_popup_module_default())["dictionary-item-wrap"]
      }, /*#__PURE__*/react.createElement(Typography/* default */.Z, {
        color: (0,reader/* isParaHeader */.E1)(item) ? null : "default",
        variant: "body4",
        className: (dictionary_popup_module_default())[item.element_subtype],
        dangerouslySetInnerHTML: {
          __html: item.content
        }
      }));
    });
  };

  return /*#__PURE__*/react.createElement(Popup, {
    contentProps: {
      className: classnames_default()(className, "reference", (dictionary_popup_module_default())["dictionary-popup-wrap"]),
      onMouseUp: handleMouseUp,
      onTouchEnd: handleMouseUp
    },
    isContentDynamic: true,
    isShown: isShown,
    anchorEl: anchorEl,
    boundaryRect: contentWrapElRect,
    onHide: onHidePopup
  }, /*#__PURE__*/react.createElement("div", {
    className: (dictionary_popup_module_default())[DICTIONARY_POPUP_CLASSNAME]
  }, /*#__PURE__*/react.createElement("div", {
    className: (dictionary_popup_module_default())["popup-header"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (dictionary_popup_module_default())["header-input"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (dictionary_popup_module_default())["input-title"]
  }, t("dictionary")), /*#__PURE__*/react.createElement("div", {
    className: (dictionary_popup_module_default())["input-tools"]
  }, /*#__PURE__*/react.createElement(SelectVariantIconButton/* default */.Z, {
    icon: EgwWebFont/* default.dictionary */.Z.dictionary,
    value: parseInt(dictionaryFilter) || dictionaryFilter,
    options: dictionaries,
    onChange: changeDictionaryFilter
  }))), /*#__PURE__*/react.createElement("hr", null)), /*#__PURE__*/react.createElement("div", {
    className: (dictionary_popup_module_default())["content-wrap"]
  }, renderResults())));
};

DictionaryPopup.propTypes = {
  isShown: (prop_types_default()).bool,
  anchorEl: (prop_types_default()).any,
  contentWrapElRect: (prop_types_default()).object,
  onHidePopup: (prop_types_default()).func,
  listTranslations: (prop_types_default()).array,
  search: (prop_types_default()).string,
  className: (prop_types_default()).string
};
/* harmony default export */ var DictionaryPopup_DictionaryPopup = (DictionaryPopup);
// EXTERNAL MODULE: ../shared/utils/viewmode.js
var viewmode = __webpack_require__(24064);
// EXTERNAL MODULE: ./src/next/styles/variables.module.scss
var variables_module = __webpack_require__(25136);
var variables_module_default = /*#__PURE__*/__webpack_require__.n(variables_module);
;// CONCATENATED MODULE: ./src/next/components/Reader/TranslationsPopup/TranslationsPopup.js













var TranslationsPopup_Popup = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4701));
}, {
  ssr: false
});

var TranslationsPopup = function TranslationsPopup(_ref) {
  var indexPanel = _ref.indexPanel,
      isShown = _ref.isShown,
      anchorEl = _ref.anchorEl,
      contentWrapElRect = _ref.contentWrapElRect,
      onHidePopup = _ref.onHidePopup,
      listTranslations = _ref.listTranslations,
      className = _ref.className;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var langMap = (0,es/* useSelector */.v9)(mainTree_selectors/* selectorMainTreeLangMap */.Qu);
  var bibles = (0,es/* useSelector */.v9)(mainTree_selectors/* selectorMainTreeBibleVersions */.Q5);

  var _useReaderContext = useReaderContext(),
      openSecondPanel = _useReaderContext.openSecondPanel;

  return /*#__PURE__*/react.createElement(TranslationsPopup_Popup, {
    contentProps: {
      className: className
    },
    maxHeight: (0,viewmode/* remToPx */.cv)((variables_module_default()).readerTranslationsPopupHeight),
    isShown: isShown,
    anchorEl: anchorEl,
    boundaryRect: contentWrapElRect,
    onHide: onHidePopup
  }, function (_ref2) {
    var hide = _ref2.hide;
    return /*#__PURE__*/react.createElement("ul", null, listTranslations !== null && listTranslations !== void 0 && listTranslations.length ? listTranslations.map(function (_ref3) {
      var paraId = _ref3.para_id,
          refcode = _ref3.refcode,
          lang = _ref3.lang;
      var langLabel = langMap[lang] || lang;
      var bookId = (0,content/* getBookIdWithPrefix */.NR)(paraId);
      var book = bibles.find(function (bible) {
        return bible.id === bookId;
      });
      var refcodeLabel = refcode || (book ? book.code + " —" : "");
      return /*#__PURE__*/react.createElement("li", {
        onClick: function onClick(e) {
          openSecondPanel(paraId);

          if (indexPanel === 0) {
            dispatch(actions/* settingsActions.updateSettings */.ff.updateSettings(settings_constants/* SETTING.syncReader.id */.Fy.syncReader.id, false));
          }

          hide(e);
        },
        key: paraId
      }, refcodeLabel, "\xA0", langLabel);
    }) : /*#__PURE__*/react.createElement(Typography/* default */.Z, {
      variant: Typography/* default.variant.body4 */.Z.variant.body4
    }, t("placeholderForMyLangs")));
  });
};

TranslationsPopup.propTypes = {
  isShown: (prop_types_default()).bool,
  anchorEl: (prop_types_default()).any,
  contentWrapElRect: (prop_types_default()).object,
  onHidePopup: (prop_types_default()).func,
  listTranslations: (prop_types_default()).array,
  className: (prop_types_default()).string
};
/* harmony default export */ var TranslationsPopup_TranslationsPopup = (TranslationsPopup);
// EXTERNAL MODULE: ./src/next/contexts/auth.js
var auth = __webpack_require__(89284);
// EXTERNAL MODULE: ./src/next/components/Reader/Panel.constants.js
var Panel_constants = __webpack_require__(78430);
// EXTERNAL MODULE: ../shared/utils/console.js
var utils_console = __webpack_require__(65795);
// EXTERNAL MODULE: ../shared/utils/dom.js
var dom = __webpack_require__(62330);
;// CONCATENATED MODULE: ../shared/hooks/reader/useReaderPanelLink.js






var useReaderPanelLink = function useReaderPanelLink(view, link, classNameActive) {
  var enabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var onScrollLinkIntoView = arguments.length > 4 ? arguments[4] : undefined;
  var refIsMountScrollToLinkPassed = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var elLink;

    if (view && link && enabled) {
      var paraIdFrom = link.paraIdFrom,
          idOriginal = link.idOriginal,
          indexInPara = link.indexInPara;

      if (idOriginal && paraIdFrom) {
        var paraSuitable = view.querySelector(".".concat(reader_constants/* READER_VIEW_CLASS_NAME_PARA_WRAP */.IJ, "[").concat(reader_constants/* DATA_ATTR_PARA_ID */.vl, "=\"").concat(paraIdFrom, "\"]"));

        if (!paraSuitable) {
          return;
        }

        if (indexInPara !== undefined && indexInPara !== -1) {
          var _paraSuitable$querySe;

          elLink = (_paraSuitable$querySe = paraSuitable.querySelectorAll("." + content_constants/* CONTENT_CLASSES.EGW_LINK */.J8.EGW_LINK)) === null || _paraSuitable$querySe === void 0 ? void 0 : _paraSuitable$querySe[indexInPara];
        }

        if (!elLink) {
          elLink = paraSuitable.querySelector(".".concat(content_constants/* CONTENT_CLASSES.EGW_LINK */.J8.EGW_LINK, "[data-link=\"").concat(idOriginal, "\"]"));
        }

        if (elLink) {
          elLink.classList.add(classNameActive);
          var computedStyle = window.getComputedStyle(elLink);
          var heightTextLine;

          if (computedStyle) {
            var floatFontSize = parseFloat(computedStyle.fontSize);
            var floatLineHeight = parseFloat(computedStyle.lineHeight);
            heightTextLine = floatFontSize * (floatLineHeight / floatFontSize);
          }

          var paddingVisibilityVertical = heightTextLine / 2;
          var isLinkInViewRect = (0,dom/* inRect */.ul)(view.getBoundingClientRect(), elLink.getBoundingClientRect(), {
            fully: !refIsMountScrollToLinkPassed.current,
            paddingVertical: paddingVisibilityVertical
          });

          if (!isLinkInViewRect) {
            elLink.scrollIntoView({
              block: "center"
            });

            if (onScrollLinkIntoView) {
              onScrollLinkIntoView();
            }
          }
        }
      } else {
        (0,utils_console/* consoleLogError */.aw)("Reader panel", "Active link object is invalid", link);
      }
    }

    if (view) {
      refIsMountScrollToLinkPassed.current = true;
    }

    return function () {
      if (elLink) {
        elLink.classList.remove(classNameActive);
      }
    };
  }, [view, link, classNameActive, enabled, onScrollLinkIntoView]);
};

/* harmony default export */ var reader_useReaderPanelLink = (useReaderPanelLink);
// EXTERNAL MODULE: ../shared/components/SwipeArrows/SwipeArrows.js
var SwipeArrows = __webpack_require__(26309);
// EXTERNAL MODULE: ../shared/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(38295);
// EXTERNAL MODULE: ../shared/utils/reader/reader-notes.js
var reader_notes = __webpack_require__(41674);
;// CONCATENATED MODULE: ../shared/hooks/reader/useHighlightContainingMarkNoteElements.js



var useHighlightContainingMarkNoteElements = function useHighlightContainingMarkNoteElements(elContainer) {
  for (var _len = arguments.length, additionalTriggers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    additionalTriggers[_key - 1] = arguments[_key];
  }

  (0,react.useEffect)(function () {
    if (elContainer) {
      (0,reader_notes/* highlightContainingMarkNoteElements */.V)(elContainer);
    }
  }, [elContainer].concat(additionalTriggers));
};

/* harmony default export */ var reader_useHighlightContainingMarkNoteElements = (useHighlightContainingMarkNoteElements);
// EXTERNAL MODULE: ../shared/what-input/useWhatInput.js
var useWhatInput = __webpack_require__(83951);
;// CONCATENATED MODULE: ../shared/utils/selection.js
var ATTR_NAME_SELECTION_START_POS = 'selectionStartPos';
var getSelectionCrossBrowser = function getSelectionCrossBrowser() {
  return __webpack_require__.g && window.getSelection ? window.getSelection() : document.getSelection ? document.getSelection() : null;
}; // Re-selects current active selection.
// Is used to hide the mobile native callout, e.g. IOS.

var toggleSelectionRanges = function toggleSelectionRanges() {
  setTimeout(function () {
    var s = getSelection();

    if (((s === null || s === void 0 ? void 0 : s.rangeCount) || 0) > 0) {
      var r = s === null || s === void 0 ? void 0 : s.getRangeAt(0);

      if (s.toString()) {
        s === null || s === void 0 ? void 0 : s.removeAllRanges();
        setTimeout(function () {
          s === null || s === void 0 ? void 0 : s.addRange(r);
        }, 50);
      }
    }
  }, 50);
};
var clearSelection = function clearSelection() {
  if ( true && window.getSelection) {
    if (window.getSelection().empty) {
      // Chrome
      window.getSelection().empty();
    } else if (window.getSelection().removeAllRanges) {
      // Firefox
      window.getSelection().removeAllRanges();
    }
  } else if (document.selection) {
    // IE?
    document.selection.empty();
  }
};
// EXTERNAL MODULE: ./src/next/contexts/swipeable.js
var swipeable = __webpack_require__(33021);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.js
var routes = __webpack_require__(69994);
// EXTERNAL MODULE: ./src/next/contexts/pageProps.js
var pageProps = __webpack_require__(2978);
// EXTERNAL MODULE: ../shared/components/Scroll/Scroll.js
var Scroll = __webpack_require__(95793);
// EXTERNAL MODULE: ../shared/api/analitics.js
var analitics = __webpack_require__(82287);
;// CONCATENATED MODULE: ../shared/utils/animation.js

var linear = function linear(timeFraction) {
  return timeFraction;
};
var animate = function animate(_ref) {
  var _ref$timing = _ref.timing,
      timing = _ref$timing === void 0 ? linear : _ref$timing,
      draw = _ref.draw,
      duration = _ref.duration,
      onEnd = _ref.onEnd;
  var start = performance.now();
  var stopped = false;
  requestAnimationFrame(function animate(time) {
    if (!stopped) {
      var timeDelta = (0,number/* clutch */.Cz)(time - start, 0, duration);
      var timeFraction = timeDelta / duration;
      var progress = timing(timeFraction);
      draw(timeDelta, progress);

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      } else {
        if (onEnd) {
          onEnd();
        }
      }
    }
  });
  return {
    stop: function stop() {
      stopped = true;
    }
  };
};
;// CONCATENATED MODULE: ../shared/hooks/useAnimation.js


var useAnimation = function useAnimation() {
  return (0,react.useCallback)(function (duration, onStep) {
    var onEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    return animate({
      duration: duration,
      draw: onStep,
      onEnd: onEnd
    });
  }, []);
};
// EXTERNAL MODULE: ../shared/store/player/selectors.js
var player_selectors = __webpack_require__(46996);
;// CONCATENATED MODULE: ../shared/utils/reader/reader-content.js


var getClosestReaderPanel = function getClosestReaderPanel(element) {
  if (element) {
    var nonTextNode = element.nodeType === Element.TEXT_NODE ? element.parentElement : element;

    if (!nonTextNode) {
      return;
    }

    return nonTextNode.classList.contains(ClassNameReaderPanel) ? nonTextNode : nonTextNode.closest("." + ClassNameReaderPanel);
  }

  return null;
};
var getClosestParaWrapElement = function getClosestParaWrapElement(childNode) {
  if (childNode) {
    var nonTextNode = childNode.nodeType === Node.TEXT_NODE ? childNode.parentElement : childNode;

    if (nonTextNode) {
      if (nonTextNode.classList.contains(reader_constants/* READER_VIEW_CLASS_NAME_PARA_WRAP */.IJ)) {
        return nonTextNode;
      }

      return nonTextNode.closest("." + reader_constants/* READER_VIEW_CLASS_NAME_PARA_WRAP */.IJ);
    }
  }

  return null;
};
var getParaContentOnlyElement = function getParaContentOnlyElement(node) {
  if (node) {
    var nonTextNode = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;

    if (nonTextNode) {
      if (nonTextNode.classList.contains(reader_constants/* READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY */.Lt)) {
        return nonTextNode;
      }

      var paraContentOnlyEl = nonTextNode.querySelector("." + reader_constants/* READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY */.Lt);

      if (paraContentOnlyEl) {
        return paraContentOnlyEl;
      }

      var nearestParaWrapElement = nonTextNode.closest("." + reader_constants/* READER_VIEW_CLASS_NAME_PARA_WRAP */.IJ);

      if (nearestParaWrapElement) {
        var _nearestParaWrapEleme;

        if ((_nearestParaWrapEleme = nearestParaWrapElement.classList) !== null && _nearestParaWrapEleme !== void 0 && _nearestParaWrapEleme.contains(reader_constants/* READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY */.Lt)) {
          return nearestParaWrapElement;
        }

        return nearestParaWrapElement.querySelector("." + reader_constants/* READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY */.Lt);
      }
    }
  }

  return null;
};
var getParaWrapElementByIdAndView = function getParaWrapElementByIdAndView(id, scrollerView) {
  if (!id || !scrollerView) {
    return null;
  }

  return scrollerView.querySelector("." + reader_constants/* READER_VIEW_CLASS_NAME_PARA_WRAP */.IJ + "[" + reader_constants/* DATA_ATTR_PARA_ID */.vl + "=\"" + id + "\"]");
};
var getTopMiddleOfParaContentFirstLine = function getTopMiddleOfParaContentFirstLine(paraWrap, paraContentOnly) {
  var paraContentComputedStyle = window.getComputedStyle(paraContentOnly);
  var fontSize = parseFloat(paraContentComputedStyle["font-size"]);
  var lineHeight = parseFloat(paraContentComputedStyle["line-height"]);
  var deltaParaContentTopToParaWrapTop, lineCount;

  if (paraWrap === paraContentOnly) {
    var paddingTop = parseFloat(window.getComputedStyle(paraWrap)["padding-top"]);
    deltaParaContentTopToParaWrapTop = paddingTop;
    lineCount = Math.ceil(Math.floor(paraWrap.offsetHeight - paddingTop - parseFloat(window.getComputedStyle(paraWrap)["padding-bottom"])) / lineHeight);
  } else {
    // {offsetTop}, because:
    // Firstly, "inline" elements have offset regarding "block" parent
    // Secondly, it comprises top padding of the parent
    //   and elements heights before content like para headers (Main App only)
    deltaParaContentTopToParaWrapTop = paraContentOnly.offsetTop;
    lineCount = Math.ceil(paraContentOnly.offsetHeight / lineHeight);
  }

  var isSingleLineOfTextContent = lineCount === 1;
  var middleTop = deltaParaContentTopToParaWrapTop // to be centered regarding the first text line
  + (isSingleLineOfTextContent ? lineHeight / 2 : fontSize / 2);
  return {
    middleTop: middleTop,
    fontSize: fontSize,
    isSingleLineOfTextContent: isSingleLineOfTextContent
  };
};
var getParaWrapAndContentElementsByIdAndView = function getParaWrapAndContentElementsByIdAndView(id, scrollerView) {
  if (!id || !scrollerView) {
    return null;
  }

  var paraWrap = getParaWrapElementByIdAndView(id, scrollerView);
  return {
    paraWrap: paraWrap,
    paraContentOnly: getParaContentOnlyElement(paraWrap)
  };
};
var getParaIdByParaElement = function getParaIdByParaElement(paraElement) {
  if (!paraElement) {
    return null;
  }

  return paraElement.getAttribute(reader_constants/* DATA_ATTR_PARA_ID */.vl);
};
var getClosestLinkElement = function getClosestLinkElement(element) {
  if (element) {
    var nonTextNode = element.nodeType === Element.TEXT_NODE ? element.parentElement : element;

    if (!nonTextNode) {
      return;
    }

    return nonTextNode.classList.contains(CONTENT_CLASSES.EGW_LINK) ? nonTextNode : nonTextNode.closest("." + CONTENT_CLASSES.EGW_LINK);
  }

  return null;
};
var getLinkIdByLinkElement = function getLinkIdByLinkElement(element) {
  if (!element) {
    return null;
  }

  return element.getAttribute(DATA_ATTR_LINK_ID);
};
var getClosestPanelElement = function getClosestPanelElement(element) {
  if (element) {
    var nonTextNode = element.nodeType === Element.TEXT_NODE ? element.parentElement : element;

    if (!nonTextNode) {
      return;
    }

    return nonTextNode.classList.contains(ClassNameReaderPanel) ? nonTextNode : nonTextNode.closest("." + ClassNameReaderPanel);
  }

  return null;
};
var getPanelIndexByPanelElement = function getPanelIndexByPanelElement(element) {
  if (!element) {
    return null;
  }

  return element.getAttribute(DATA_ATTR_PANEL_INDEX);
};
;// CONCATENATED MODULE: ../shared/hooks/reader/useReaderLiveReading.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }













var useReaderLiveReading = function useReaderLiveReading(_ref) {
  var _waveformsDictionary$;

  var _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      refScrollView = _ref.refScrollView,
      triggerRestart1 = _ref.triggerRestart1,
      triggerRestart2 = _ref.triggerRestart2,
      currentPlayingPara = _ref.currentPlayingPara,
      getArrowPosition = _ref.getArrowPosition,
      onUpdateArrowPosition = _ref.onUpdateArrowPosition,
      onUpdatePanel = _ref.onUpdatePanel,
      onAnimationStopped = _ref.onAnimationStopped;
  var refOnAnimationStopped = (0,react.useRef)(onAnimationStopped);
  refOnAnimationStopped.current = onAnimationStopped;
  var refStepLiveRead = (0,react.useRef)(undefined);
  var currentPlayingParaId = currentPlayingPara === null || currentPlayingPara === void 0 ? void 0 : currentPlayingPara.id;

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      audioChapterId = _useAudioContext.audioChapterId,
      playbackRate = _useAudioContext.playbackRate,
      getPlayerCurrentTime = _useAudioContext.getPlayerCurrentTime,
      subscribeToPlayerEvents = _useAudioContext.subscribeToPlayerEvents,
      unsubscribeFromPlayerEvents = _useAudioContext.unsubscribeFromPlayerEvents,
      isPlaying = _useAudioContext.isPlaying;

  var animate = useAnimation();
  var syncPlayerAndReader = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id));
  var readerFontSize = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.readerFontSize.id */.Fy.readerFontSize.id));
  var readerFontFamily = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.readerFontFamily.id */.Fy.readerFontFamily.id));
  var zoom = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.zoom.id */.Fy.zoom.id));
  var waveformsDictionary = (0,es/* useSelector */.v9)(player_selectors/* selectorPlayerWaveformsDictionary */.cc);
  var parasPositionInAudio = (_waveformsDictionary$ = waveformsDictionary[audioChapterId]) === null || _waveformsDictionary$ === void 0 ? void 0 : _waveformsDictionary$.paragraphsAudioPositions;

  var _useState = (0,react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLiveReading = _useState2[0],
      setIsLiveReading = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      triggerLiveReadRestart = _useState4[0],
      setTriggerLiveReadRestart = _useState4[1];

  var isReadyAndWaitingToLiveRead = isPlaying && !!syncPlayerAndReader && !!audioChapterId && !!currentPlayingParaId;

  var openCurrentPara = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var activeValueNew;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (currentPlayingPara) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            activeValueNew = currentPlayingParaId;
            _context.next = 5;
            return onUpdatePanel(activeValueNew);

          case 5:
            return _context.abrupt("return", activeValueNew);

          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function openCurrentPara() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getElementScrollerView = function getElementScrollerView() {
    var _refScrollView$curren;

    return (_refScrollView$curren = refScrollView.current) === null || _refScrollView$curren === void 0 ? void 0 : _refScrollView$curren.view;
  };

  var getReadOffset = function getReadOffset() {
    var elView = getElementScrollerView();

    if (!elView) {
      return undefined;
    }

    var value = elView.offsetHeight / 3;

    if (value < 165) {
      // Mobile UX
      return elView.offsetHeight / 2.5;
    }

    return value;
  };

  var getParaWrapAndContentElementsBy = function getParaWrapAndContentElementsBy(id) {
    var scrollerView = getElementScrollerView();
    return getParaWrapAndContentElementsByIdAndView(id, scrollerView);
  };

  var _scrollView = function _scrollView(scrollTop, styleTop) {
    var elView = getElementScrollerView();

    if (elView) {
      elView.scrollTop = scrollTop;
      elView.style.top = styleTop;
    }
  };

  var scrollByValues = function scrollByValues(arrowStyleTop, viewScrollTop, viewStyleTop) {
    _scrollView(viewScrollTop, viewStyleTop);

    onUpdateArrowPosition(arrowStyleTop);
  };

  var getStartToEndAnimationInfo = function getStartToEndAnimationInfo() {
    var timeStart = currentPlayingPara.start,
        timeEnd = currentPlayingPara.end,
        id = currentPlayingPara.id;
    var durationFull = timeEnd - timeStart;
    var paraElementObj = getParaWrapAndContentElementsBy(id);

    if (!paraElementObj || !paraElementObj.paraWrap || !paraElementObj.paraContentOnly) {
      return null;
    }

    var paraWrap = paraElementObj.paraWrap,
        paraContentOnly = paraElementObj.paraContentOnly;

    var _getTopMiddleOfParaCo = getTopMiddleOfParaContentFirstLine(paraWrap, paraContentOnly),
        isSingleLineOfTextContent = _getTopMiddleOfParaCo.isSingleLineOfTextContent,
        middleTop = _getTopMiddleOfParaCo.middleTop,
        fontSize = _getTopMiddleOfParaCo.fontSize;

    var scrollTopPara = paraWrap.offsetTop + middleTop;
    var distanceFull = isSingleLineOfTextContent ? 0 : paraContentOnly.offsetHeight - fontSize;
    var timeListened = Math.max(getPlayerCurrentTime() - timeStart, 0.1);
    var time = durationFull - timeListened;
    var offsetListened = timeListened * distanceFull / durationFull;
    var scrollTopStart = scrollTopPara + offsetListened;
    var distance = distanceFull - offsetListened;
    var duration = time * 1000 / playbackRate;
    return {
      scrollTopStart: scrollTopStart,
      distance: distance,
      duration: duration
    };
  };

  var getAnimationVariablesForFrame = function getAnimationVariablesForFrame(scrollTop) {
    var elView = getElementScrollerView();
    var readOffset = getReadOffset();
    var scrollTopMax = elView.scrollHeight - elView.offsetHeight;
    var offsetArrow;
    var isMovingArrowInsteadOfScrolling;

    if (scrollTop < readOffset) {
      // Don't scrollByValues, move pointer at the beginning.
      offsetArrow = scrollTop;
      isMovingArrowInsteadOfScrolling = true;
    } else if (scrollTop > scrollTopMax + readOffset) {
      // Don't scrollByValues, move pointer at the end.
      offsetArrow = scrollTop - scrollTopMax;
      isMovingArrowInsteadOfScrolling = true;
    } else {
      // Scroll view and set pointer at the read zone offset.
      offsetArrow = readOffset;
      isMovingArrowInsteadOfScrolling = false;
    }

    var scrollTopNewFloat = scrollTop - readOffset;
    var scrollTopNewInt = parseInt((0,number/* toFixedWithoutRounding */.Md)(scrollTopNewFloat));
    var deltaScrollTopOldToNew = scrollTopNewFloat - parseInt((0,number/* toFixedWithoutRounding */.Md)(elView.scrollTop));
    var isApplyCSSWorkaroundForSmoothScrolling = !dom/* isBrowserSupportsFloatValueForScrollTop */.$g && !isMovingArrowInsteadOfScrolling && deltaScrollTopOldToNew < 1.3 // if without it, then scrolls with a random content deformation in Firefox 80% zoom
    // but with it – scrolls by jerkily
    && Number.isInteger(devicePixelRatio);
    var viewScrollTop, viewStyleTop;

    if (isApplyCSSWorkaroundForSmoothScrolling) {
      var floatPart = parseFloat((scrollTopNewFloat - scrollTopNewInt).toFixed(1)) >= 0.5 ? 0.5 : 0;
      viewScrollTop = scrollTopNewInt;
      viewStyleTop = -floatPart + "px";
    } else {
      viewScrollTop = scrollTopNewFloat;
      viewStyleTop = "0px";
    }

    return {
      arrowStyleTop: offsetArrow,
      viewScrollTop: viewScrollTop,
      viewStyleTop: viewStyleTop
    };
  };

  var playFromCurrentToStartAnimation = function playFromCurrentToStartAnimation(scrollTopStart, fnCheckIfAnimationActual) {
    return new Promise(function (resolve) {
      var elView = getElementScrollerView();
      var arrowStart = getArrowPosition();
      var viewStart = elView.scrollTop;
      var viewStyleTopStart = elView.style.top;

      var _getAnimationVariable = getAnimationVariablesForFrame(scrollTopStart),
          arrowFinal = _getAnimationVariable.arrowStyleTop,
          viewFinal = _getAnimationVariable.viewScrollTop,
          viewStyleTopFinal = _getAnimationVariable.viewStyleTop;

      var distanceArrow = arrowFinal - arrowStart;
      var distanceView = viewFinal + parseInt(viewStyleTopFinal) - viewStart + parseInt(viewStyleTopStart);
      var distanceArrowABS = Math.abs(arrowFinal - arrowStart);
      var distanceViewABS = Math.abs(viewFinal + parseInt(viewStyleTopFinal) - viewStart + parseInt(viewStyleTopStart));
      var isDistanceArrowGreater = distanceArrowABS > distanceViewABS;
      var distance = isDistanceArrowGreater ? distanceArrowABS : distanceViewABS;

      if ((0,number/* isNumberBetweenEquals */.S5)(distance, 1.5, elView.offsetHeight)) {
        var duration = Math.max(Math.abs(distance * 2), 300);
        return animate(duration, function (timePassed) {
          if (!fnCheckIfAnimationActual()) {
            return;
          }

          var coeff = timePassed / duration;
          scrollByValues(arrowStart + distanceArrow * coeff, viewStart + distanceView * coeff, "0px");
        }, resolve).stop;
      } else {
        scrollByValues(arrowFinal, viewFinal, viewStyleTopFinal);
        resolve();
      }
    });
  };

  var playFromStartToEndAnimation = function playFromStartToEndAnimation(distance, duration, scrollTopStart, checkIfAsyncOperationIsStillActual) {
    var isFirstStepPassed = false;
    var isStepLiveReadDefined = false;
    return animate(duration, /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(timePassed) {
        var newScrollTop, _getAnimationVariable2, arrowStyleTop, viewScrollTop, viewStyleTop;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (checkIfAsyncOperationIsStillActual()) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (!isFirstStepPassed && timePassed) {
                isFirstStepPassed = true;
              }

              if (isFirstStepPassed && !isStepLiveReadDefined) {
                refStepLiveRead.current = distance * timePassed / duration;
                isStepLiveReadDefined = true;
              }

              newScrollTop = scrollTopStart + distance * timePassed / duration;
              _getAnimationVariable2 = getAnimationVariablesForFrame(newScrollTop), arrowStyleTop = _getAnimationVariable2.arrowStyleTop, viewScrollTop = _getAnimationVariable2.viewScrollTop, viewStyleTop = _getAnimationVariable2.viewStyleTop;
              scrollByValues(arrowStyleTop, viewScrollTop, viewStyleTop);

            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()).stop;
  }; // Main algorithm


  (0,react.useEffect)(function () {
    var fnStopAnimation, isEffectCallbackCalled, isLiveReadingWasEnabled;

    if (isReadyAndWaitingToLiveRead && currentPlayingPara && isEnabled) {
      openCurrentPara().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var variables, duration, distance, scrollTopStart, isOperationActual;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              (0,analitics/* logOtherEvent */.iW)(analitics/* OtherLogEvents.READER_ACTION */.b$.READER_ACTION, {
                id: "auto_read_while_listen"
              });

              if (!isEffectCallbackCalled) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              variables = getStartToEndAnimationInfo();

              if (variables) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return");

            case 6:
              duration = variables.duration, distance = variables.distance, scrollTopStart = variables.scrollTopStart;

              isOperationActual = function isOperationActual() {
                return !isEffectCallbackCalled;
              };

              _context3.next = 10;
              return playFromCurrentToStartAnimation(scrollTopStart, isOperationActual);

            case 10:
              fnStopAnimation = _context3.sent;
              fnStopAnimation = playFromStartToEndAnimation(distance, duration, scrollTopStart, isOperationActual);
              setIsLiveReading(function () {
                isLiveReadingWasEnabled = true;
                return true;
              });

            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })));
    }

    return function () {
      isEffectCallbackCalled = true;
      refStepLiveRead.current = undefined;

      if (fnStopAnimation) {
        fnStopAnimation();
      }

      if (isLiveReadingWasEnabled) {
        setIsLiveReading(false);
      }

      if (refOnAnimationStopped.current) {
        refOnAnimationStopped.current();
      }
    };
  }, [isEnabled, triggerLiveReadRestart, isReadyAndWaitingToLiveRead, audioChapterId, currentPlayingPara, parasPositionInAudio, triggerRestart1, triggerRestart2, playbackRate, zoom, readerFontSize, readerFontFamily, animate]); // Trigger live reading restart on player skip.

  (0,react.useEffect)(function () {
    var listener = function listener(e) {
      if (e.event === AudioContext/* PLAYER_EVENTS.SKIP */.mL.SKIP) {
        setTriggerLiveReadRestart(Math.random());
      }
    };

    subscribeToPlayerEvents(listener);
    return function () {
      unsubscribeFromPlayerEvents(listener);
    };
  }, []);
  return {
    refStepLiveRead: refStepLiveRead,
    isReadyAndWaitingToLiveRead: isReadyAndWaitingToLiveRead,
    isLiveReading: isLiveReading,
    getReadOffset: getReadOffset
  };
};

/* harmony default export */ var reader_useReaderLiveReading = (useReaderLiveReading);
// EXTERNAL MODULE: ../shared/hooks/usePopup.js
var usePopup = __webpack_require__(98754);
// EXTERNAL MODULE: ./src/next/components/TopPanel/TopPanel.constants.js
var TopPanel_constants = __webpack_require__(19158);
// EXTERNAL MODULE: ./src/next/components/Reader/reader.module.scss
var reader_module = __webpack_require__(69254);
var reader_module_default = /*#__PURE__*/__webpack_require__.n(reader_module);
// EXTERNAL MODULE: ./src/next/hooks/useIsDOMHydratedAfterSSR.js
var useIsDOMHydratedAfterSSR = __webpack_require__(69286);
;// CONCATENATED MODULE: ./src/next/components/Reader/Panel.js
function Panel_extends() { Panel_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Panel_extends.apply(this, arguments); }

function Panel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Panel_slicedToArray(arr, i) { return Panel_arrayWithHoles(arr) || Panel_iterableToArrayLimit(arr, i) || Panel_unsupportedIterableToArray(arr, i) || Panel_nonIterableRest(); }

function Panel_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function Panel_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Panel_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Panel_arrayLikeToArray(o, minLen); }

function Panel_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function Panel_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function Panel_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }












































 // dynamic, to prevent console errors - server content mismatch the client's.

var Loader = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 63975));
}, {
  ssr: false
});


var DELAY_DETECT_FIRST_PARA = 150;
var LOG_TOP_PANEL_VISIBILITY_DEFINER = false;
var Popups = {
  TRANSLATIONS: "TRANSLATIONS",
  DICTIONARY: "DICTIONARY"
};

var Panel = function Panel(_ref) {
  var _refScrollbars$curren, _classNames, _classNames2;

  var className = _ref.className,
      data = _ref.data,
      active = _ref.active,
      currentLayout = _ref.currentLayout,
      fontSize = _ref.fontSize,
      prevChapter = _ref.prevChapter,
      nextChapter = _ref.nextChapter,
      index = _ref.index,
      linkActive = _ref.linkActive;

  var _usePagePropsContext = (0,pageProps/* usePagePropsContext */.b)(),
      isLanding = _usePagePropsContext.isLanding;

  var _useReaderContext = useReaderContext(),
      readerPlayerHookInstance = _useReaderContext.readerPlayerHookInstance,
      syncPanels = _useReaderContext.syncPanels,
      updatePanel = _useReaderContext.updatePanel,
      updateIndexPanelActive = _useReaderContext.updateIndexPanelActive,
      openLink = _useReaderContext.openLink,
      panelsIds = _useReaderContext.panelsIds,
      linksActive = _useReaderContext.linksActive,
      fontSizeFinal = _useReaderContext.fontSizeFinal;

  var id = panelsIds[index];
  var isMainPanel = index === 0;
  var currentPlayingPara = readerPlayerHookInstance.currentPlayingPara,
      stopSyncPlayerAndReader = readerPlayerHookInstance.stopSyncPlayerAndReader,
      indexPanelInPlayer = readerPlayerHookInstance.indexPanelInPlayer;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var book = data.book,
      paraList = data.paraList,
      paraListLoading = data.paraListLoading,
      isLoading = data.isLoading;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useAuthContext = (0,auth/* useAuthContext */.E)(),
      isLogin = _useAuthContext.isLogin,
      login = _useAuthContext.login;

  var _useGlobalSwipeable = (0,swipeable/* useGlobalSwipeable */.S)(),
      addSwipedListener = _useGlobalSwipeable.addSwipedListener,
      removeSwipedListener = _useGlobalSwipeable.removeSwipedListener;

  var _usePagePropsContext2 = (0,pageProps/* usePagePropsContext */.b)(),
      urlOrigin = _usePagePropsContext2.urlOrigin;

  var isMobileOrTablet = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.untilDesktopAndDesktop */.q.untilDesktopAndDesktop);
  var isLastPointerMouse = (0,useWhatInput/* useWhatInputIsLastPointerMouse */.a)();
  var showRefCodes = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.showRefCodes.id */.Fy.showRefCodes.id));
  var showTranslations = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.showTranslations.id */.Fy.showTranslations.id));
  var isDOMHydratedAfterSSR = (0,useIsDOMHydratedAfterSSR/* default */.Z)();
  var refTimeout = (0,react.useRef)();
  var refTimeout2 = (0,react.useRef)();
  var refTimeout3 = (0,react.useRef)();
  var refSwipeArrows = (0,react.useRef)(null);
  var refLastTouchStartScrollTop = (0,react.useRef)(null);
  var refIsScreenTouched = (0,react.useRef)(false);
  var refTopPanelHeight = (0,react.useRef)(null);

  var _useState = (0,react.useState)(undefined),
      _useState2 = Panel_slicedToArray(_useState, 2),
      scrollTopValue = _useState2[0],
      setScrollTopValue = _useState2[1];

  if (isDOMHydratedAfterSSR) {
    var _document$getElementB;

    var height = (_document$getElementB = document.getElementById(TopPanel_constants/* EL_ID_TOP_PANEL */.d)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.offsetHeight;

    if (height) {
      refTopPanelHeight.current = height;
    }
  }

  var isAllowedToggleTopPanel = isDOMHydratedAfterSSR && isMobileOrTablet;
  var isTopPanelCoversPartOfContent = isAllowedToggleTopPanel && (index === 0 || index === 1 && currentLayout === Panel_constants/* layoutIds.l2v */.sO.l2v);
  var readerTopEdgeHeightOccupied = isTopPanelCoversPartOfContent ? refTopPanelHeight.current : 0;
  var refReaderTopEdgeHeightOccupied = (0,react.useRef)();
  refReaderTopEdgeHeightOccupied.current = readerTopEdgeHeightOccupied;
  var refIsPreventDetectFirstVisible = (0,react.useRef)(false);
  var refParaIdLastSyncedOnScrollStop = (0,react.useRef)(null);
  var refLastScrollData = (0,react.useRef)({
    scrollTop: undefined,
    chapterId: undefined
  });
  var refPreventStopSyncReaderAndPlayer = (0,react.useRef)(false);
  var refElArrow = (0,react.useRef)(null);

  var _useState3 = (0,react.useState)(null),
      _useState4 = Panel_slicedToArray(_useState3, 2),
      elNoteActive = _useState4[0],
      setElNoteActive = _useState4[1];

  var refScrollbars = (0,react.useRef)(null);
  var elContentWrap = (_refScrollbars$curren = refScrollbars.current) === null || _refScrollbars$curren === void 0 ? void 0 : _refScrollbars$curren.view;

  var _useState5 = (0,react.useState)(undefined),
      _useState6 = Panel_slicedToArray(_useState5, 2),
      activePopup = _useState6[0],
      setActivePopup = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      _useState8 = Panel_slicedToArray(_useState7, 2),
      dictionarySearch = _useState8[0],
      setDictionarySearch = _useState8[1];

  var isShownMarks = (0,es/* useSelector */.v9)(function (state) {
    return state.search.isShownMarks;
  });
  var totalTextSearch = (0,es/* useSelector */.v9)(search_selectors/* selectorSearchResults */.dx).total;
  var isTopPanelVisible = (0,es/* useSelector */.v9)(selectors/* selectorSystemIsTopPanelVisible */.eq);

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      chapterId = _useAudioContext.chapterId,
      subscribeToPlayerEvents = _useAudioContext.subscribeToPlayerEvents,
      unsubscribeFromPlayerEvents = _useAudioContext.unsubscribeFromPlayerEvents;

  var _useState9 = (0,react.useState)([]),
      _useState10 = Panel_slicedToArray(_useState9, 2),
      listTranslations = _useState10[0],
      setListTranslations = _useState10[1];

  var _usePopup = (0,usePopup/* usePopup */.B)(),
      isShown = _usePopup.isShown,
      anchorEl = _usePopup.anchorEl,
      openPopup = _usePopup.openPopup,
      closePopup = _usePopup.closePopup;

  var paraListIds = (0,react.useMemo)(function () {
    var _paraList$paras;

    return (paraList === null || paraList === void 0 ? void 0 : (_paraList$paras = paraList.paras) === null || _paraList$paras === void 0 ? void 0 : _paraList$paras.map(function (p) {
      return p.para_id;
    })) || [];
  }, [paraList]);
  var indexParaActive = (0,react.useMemo)(function () {
    if (paraList !== null && paraList !== void 0 && paraList.paras) {
      var _paraList$paras2;

      return (_paraList$paras2 = paraList.paras) === null || _paraList$paras2 === void 0 ? void 0 : _paraList$paras2.findIndex(function (p) {
        return p.para_id === id;
      });
    }

    return undefined;
  }, [paraList, id]);
  var idParaHighlighted = (0,react.useMemo)(function () {
    var _paraList$paras3;

    var isActiveIdHeader = indexParaActive !== undefined && (0,reader/* isParaHeader */.E1)(paraList === null || paraList === void 0 ? void 0 : (_paraList$paras3 = paraList.paras) === null || _paraList$paras3 === void 0 ? void 0 : _paraList$paras3[indexParaActive]);

    if (isActiveIdHeader) {
      var _paraList$paras4;

      var firstNextNonHeaderPara = paraList === null || paraList === void 0 ? void 0 : (_paraList$paras4 = paraList.paras) === null || _paraList$paras4 === void 0 ? void 0 : _paraList$paras4.slice(indexParaActive + 1).find(function (p) {
        return !(0,reader/* isParaHeader */.E1)(p);
      });

      if (firstNextNonHeaderPara) {
        return firstNextNonHeaderPara.para_id;
      }
    }

    return id;
  }, [id, paraList, indexParaActive]);
  var percentContentScrolled = elContentWrap ? (0,number/* calcPercentage */.PX)(scrollTopValue, elContentWrap.scrollHeight - elContentWrap.offsetHeight) : 0;
  var isAllowedShowParas = (0,content/* isBookPermissionAuthOK */.dr)(book, isLogin) !== false;
  var isCanShowArrows = isMobileOrTablet && (indexParaActive === paraListIds.length - 1 || percentContentScrolled >= 98.5);
  var rectElContentWrap = (0,react.useMemo)(function () {
    return elContentWrap && elContentWrap.getBoundingClientRect();
  }, [elContentWrap]);
  var preventUpdateActiveIdBasedOnFirstVisible = (0,react.useCallback)(function () {
    clearTimeout(refTimeout.current); // Prevent detect first visible during {DELAY_DETECT_FIRST_PARA + 100ms} after auto-scroll
    // We detect first visible only on user's scroll action.
    // Otherwise, extra detection is fired when navigate through search results in Reader:
    // e.g. search "god", navigate until there is no scroll height
    // for search item para to be th first in the view.

    refIsPreventDetectFirstVisible.current = true;
    refTimeout.current = setTimeout(function () {
      refIsPreventDetectFirstVisible.current = false;
    }, DELAY_DETECT_FIRST_PARA + 250);
  }, []);

  var _useReaderLiveReading = reader_useReaderLiveReading({
    isEnabled: !!(index === indexPanelInPlayer),
    currentPlayingPara: currentPlayingPara,
    refScrollView: refScrollbars,
    getArrowPosition: function getArrowPosition() {
      if (refElArrow.current) {
        return parseFloat(refElArrow.current.style.top);
      }

      return undefined;
    },
    onUpdateArrowPosition: function onUpdateArrowPosition(position) {
      if (refElArrow.current) {
        refElArrow.current.style.top = position + "px";
      }
    },
    onUpdatePanel: function onUpdatePanel(idActiveNew) {
      return updatePanel(index, idActiveNew);
    },
    onAnimationStopped: preventUpdateActiveIdBasedOnFirstVisible
  }),
      refStepLiveRead = _useReaderLiveReading.refStepLiveRead,
      isReadyAndWaitingToLiveRead = _useReaderLiveReading.isReadyAndWaitingToLiveRead,
      isLiveReading = _useReaderLiveReading.isLiveReading;

  var refData = (0,useRefData/* default */.Z)({
    isLastPointerMouse: isLastPointerMouse,
    elContentWrap: elContentWrap,
    isCanShowArrows: isCanShowArrows,
    isAllowedToggleTopPanel: isAllowedToggleTopPanel,
    isTopPanelVisible: isTopPanelVisible,
    isLiveReading: isLiveReading,
    id: id,
    fontSizeFinal: fontSizeFinal,
    currentPlayingPara: currentPlayingPara,
    panelsIds: panelsIds,
    active: active,
    index: index,
    chapterId: chapterId,
    nextChapter: nextChapter,
    prevChapter: prevChapter,
    elNoteActive: elNoteActive,
    linksActive: linksActive,
    paraListIds: paraListIds
  });
  var preventStopSyncReaderAndPlayer = (0,react.useCallback)(function () {
    clearTimeout(refTimeout3.current);
    refPreventStopSyncReaderAndPlayer.current = true;
    refTimeout3.current = setTimeout(function () {
      refPreventStopSyncReaderAndPlayer.current = false;
    }, 100);
  }, []); // TODO: Need to move "PopupContext" of Main app to Next app and use here.
  //  Also, need to move notes logic from "ReaderView.js" to a common hook for these projects.

  var temporary_handleNote = function temporary_handleNote(e) {
    var elNote = (0,reader_notes/* getClosestNoteElement */.o)(e.target);
    setElNoteActive(elNote);

    if (elNote) {
      var elNotePopup = elNote.querySelector('[class$="note"]');

      if (elNotePopup) {
        var rectBoundaries = e.currentTarget.getBoundingClientRect();
        var rectElNote = elNote.getBoundingClientRect();

        var _deprecated_calculate2 = (0,dom/* _deprecated_calculateMaxSizes */.O5)(rectBoundaries, rectElNote),
            maxWidth = _deprecated_calculate2.maxWidth,
            maxHeight = _deprecated_calculate2.maxHeight;

        elNotePopup.style.maxWidth = maxWidth + "px";
        elNotePopup.style.maxHeight = maxHeight + "px";
        var rectElNotePopup = elNotePopup.getBoundingClientRect();

        var _deprecated_calculate4 = (0,dom/* _deprecated_calculateFitPosition */._F)(rectBoundaries, rectElNote, rectElNotePopup.width, rectElNotePopup.height),
            top = _deprecated_calculate4.top,
            left = _deprecated_calculate4.left;

        elNotePopup.style.top = top + "px";
        elNotePopup.style.left = left + "px";
        return true;
      }
    }

    return false;
  }; // Fast-fix for touch devices.


  var unhoverElementNote = (0,react.useCallback)(function () {
    var elNoteActive = refData.current.elNoteActive;

    if (elNoteActive) {
      var elNoteActiveClone = elNoteActive.cloneNode(true);
      elNoteActive.parentNode.replaceChild(elNoteActiveClone, elNoteActive);
      setElNoteActive(null);
    }
  }, []);

  var openLinkByEvent = function openLinkByEvent(e) {
    var linkData = e.target.dataset.link;

    if (linkData) {
      var elPara = getClosestParaWrapElement(e.target);

      if (elPara) {
        openLink(linkData, getParaIdByParaElement(elPara), e.target.classList.contains(content_constants/* CONTENT_CLASSES.EGW_LINK_BIBLE */.J8.EGW_LINK_BIBLE));
        return true;
      }
    }

    return false;
  };

  var openDictionaryPopupByEvent = function openDictionaryPopupByEvent(e) {
    if ((0,dom/* isEventDoubleClick */.oU)(e)) {
      var windowSelection = getSelectionCrossBrowser();
      var selectionText = windowSelection.toString().trim();

      if (selectionText) {
        var range = windowSelection.getRangeAt(0);
        setDictionarySearch(selectionText);
        setActivePopup(Popups.DICTIONARY);
        openPopup({
          detail: {
            target: range
          }
        });
        return true;
      }
    }

    return false;
  };

  var updatePanelParaIdAndActiveStatusByEvent = function updatePanelParaIdAndActiveStatusByEvent(event) {
    var paraId = getParaIdByParaElement(getClosestParaWrapElement(event.target));
    var isParaIdWasUpdated = false;

    if (active) {
      if (paraId && paraId !== id) {
        updatePanel(index, paraId);
        isParaIdWasUpdated = true;
      }
    } else {
      if (!paraId || paraId === id) {
        updateIndexPanelActive(index);
      } else {
        updatePanel(index, paraId);
        isParaIdWasUpdated = true;
      }
    }

    return {
      isParaIdWasUpdated: isParaIdWasUpdated
    };
  };

  var handleClick = function handleClick(e) {
    var _updatePanelParaIdAnd = updatePanelParaIdAndActiveStatusByEvent(e),
        isParaIdWasUpdated = _updatePanelParaIdAnd.isParaIdWasUpdated;

    var isDictionaryPopupWasOpened = openDictionaryPopupByEvent(e);

    if (isDictionaryPopupWasOpened) {
      return;
    }

    var isFootNoteWasOpened = temporary_handleNote(e);

    if (isFootNoteWasOpened) {
      return;
    }

    var isLinkWasOpened = openLinkByEvent(e);

    if (isLinkWasOpened) {
      return;
    }

    if (!isParaIdWasUpdated) {
      setTopPanelVisibility(!isTopPanelVisible, scrollTopValue);

      if (isCanShowArrows && refSwipeArrows.current) {
        refSwipeArrows.current.showArrowsWithAutoHide();
      }
    }
  };

  var handleMouseMove = temporary_handleNote;
  var scroll = (0,react.useCallback)(function (top) {
    var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!elContentWrap) {
      return;
    }

    if (smooth) {
      elContentWrap.scrollTo({
        top: top,
        behavior: "smooth"
      });
    } else {
      elContentWrap.scrollTop = top;
    }
  }, [elContentWrap]);

  var setTopPanelVisibility = function setTopPanelVisibility(flag) {
    dispatch(actions/* systemActions.setTopPanelVisibility */.nm.setTopPanelVisibility(flag));
  };

  var defineTopPanelVisibilityByEvent = function defineTopPanelVisibilityByEvent(e) {
    if (!isAllowedToggleTopPanel) {
      if (LOG_TOP_PANEL_VISIBILITY_DEFINER) {
        console.log("not allowed");
      }

      return;
    }

    var target = e.target;
    var scrollTop = target.scrollTop;
    var height = target.offsetHeight;
    var isScrollDirectionDown = scrollTop > refLastScrollData.current.scrollTop;
    var isRequiredToShowPanel = scrollTop < refTopPanelHeight.current;
    var stateNew;

    if (isRequiredToShowPanel) {
      stateNew = true;
    } else {
      // Prevent toggling Top Panel after user has released the touch,
      // so the panel state won't be changed on a non-user interaction.
      // if (!refIsScreenTouched.current) {
      //   if (LOG_TOP_PANEL_VISIBILITY_DEFINER) {
      //     console.log("not touched");
      //   }
      //   return;
      // }
      // ========================================================================================
      // Prevent toggling Top Panel if it's a scroll debounce.
      var isScrollDebouncing = scrollTop < 0 || scrollTop > height + target.scrollHeight;

      if (isScrollDebouncing) {
        if (LOG_TOP_PANEL_VISIBILITY_DEFINER) {
          console.log("is debouncing");
        }

        return;
      } // ========================================================================================


      stateNew = !isScrollDirectionDown; // // Prevent toggle Top Panel if scrolled only a little.

      var SIZE_SCROLLED_ENOUGH = 24;
      var scrolledDistance = scrollTop - refLastTouchStartScrollTop.current;
      var isScrolledEnough = isScrollDirectionDown ? scrolledDistance >= SIZE_SCROLLED_ENOUGH : scrolledDistance <= -SIZE_SCROLLED_ENOUGH;

      if (!isScrolledEnough) {
        if (LOG_TOP_PANEL_VISIBILITY_DEFINER) {
          console.log("not far away to show: ", scrolledDistance);
        }

        return;
      } // // ========================================================================================

    }

    if (stateNew !== isTopPanelVisible) {
      setTopPanelVisibility(stateNew, scrollTop);
    }
  };

  var goToPrevChapter = (0,react.useCallback)(function () {
    var _refData$current = refData.current,
        prevChapter = _refData$current.prevChapter,
        index = _refData$current.index;

    if (prevChapter !== null && prevChapter !== void 0 && prevChapter.para_id) {
      updatePanel(index, prevChapter.para_id, {
        updatePlayerChapterToo: true
      });
    }
  }, [updatePanel]);
  var goToNextChapter = (0,react.useCallback)(function () {
    var _refData$current2 = refData.current,
        nextChapter = _refData$current2.nextChapter,
        index = _refData$current2.index;

    if (nextChapter !== null && nextChapter !== void 0 && nextChapter.para_id) {
      updatePanel(index, nextChapter.para_id, {
        updatePlayerChapterToo: true
      });
    }
  }, [updatePanel]);

  var handleClickTranslate = function handleClickTranslate(event, _ref2) {
    var translations = _ref2.translations;
    event.preventDefault();
    event.stopPropagation();
    openPopup(event);
    setListTranslations(translations);
    setActivePopup(Popups.TRANSLATIONS);
  };

  var handleClickAnchor = function handleClickAnchor(event, item) {
    event.preventDefault();
    event.stopPropagation();
    dispatch(actions/* systemActions.actionCopy */.nm.actionCopy(urlOrigin + (0,routes/* makeChapterUrl */.ME)(item.para_id), {
      successMessage: t("linkCopied"),
      errorMessage: t("linkNotCopied")
    }));
  };

  var handleHidePopup = function handleHidePopup() {
    clearSelection();
    closePopup();
    setActivePopup(undefined);
  };

  var handleTouchStart = function handleTouchStart() {
    if (!isLastPointerMouse) {
      refIsScreenTouched.current = true;
      refLastTouchStartScrollTop.current = scrollTopValue;
    } else {
      if (refIsScreenTouched.current) {
        refIsScreenTouched.current = false;
      }

      if (refLastTouchStartScrollTop.current) {
        refLastTouchStartScrollTop.current = null;
      }
    }
  };

  var handleTouchEnd = function handleTouchEnd() {
    if (!isLastPointerMouse) {
      refIsScreenTouched.current = false;
    } else {
      if (refIsScreenTouched.current) {
        refIsScreenTouched.current = false;
      }

      if (refLastTouchStartScrollTop.current) {
        refLastTouchStartScrollTop.current = null;
      }
    }
  };
  /* ====================== Scroll hooks =================== */
  // Handles view scroll event.


  var refSyncPanels = (0,react.useRef)(syncPanels);
  refSyncPanels.current = syncPanels;
  var refDefineTopPanelVisibilityByScrollTop = (0,react.useRef)();
  refDefineTopPanelVisibilityByScrollTop.current = defineTopPanelVisibilityByEvent;
  (0,react.useEffect)(function () {
    if (!elContentWrap) {
      return undefined;
    }

    var idTimerDetectFirstPara;
    var idTimerStart, eventTimestampStart;

    var handleScroll = function handleScroll(e) {
      var _global$window, _global$window$docume;

      // ============== BEGIN {eventTimestampStart} logic =============
      var eventTimeStamp = e.timeStamp;

      if (!idTimerStart) {
        eventTimestampStart = eventTimeStamp;
      }

      clearTimeout(idTimerStart);
      idTimerStart = setTimeout(function () {
        idTimerStart = undefined;
      }, 500); // ================ END {eventTimestampStart} logic =================

      unhoverElementNote();
      var _refData$current3 = refData.current,
          isLiveReading = _refData$current3.isLiveReading,
          chapterId = _refData$current3.chapterId,
          active = _refData$current3.active;
      var scrollTop = e.target.scrollTop;

      if (isLiveReading && !refPreventStopSyncReaderAndPlayer.current && refLastScrollData.current.scrollTop !== undefined && refLastScrollData.current.chapterId === chapterId && refStepLiveRead.current && Math.abs(refLastScrollData.current.scrollTop - scrollTop) > Math.max(refStepLiveRead.current * 1.6, 4) && (_global$window = __webpack_require__.g.window) !== null && _global$window !== void 0 && (_global$window$docume = _global$window.document) !== null && _global$window$docume !== void 0 && _global$window$docume.hasFocus()) {
        stopSyncPlayerAndReader();
      }

      if (!refData.current.isLiveReading) {
        if (!refIsPreventDetectFirstVisible.current) {
          var _index = refData.current.index; // Prevent change active panel for instant-scroll,
          // e.g. split is instant-scrolled after top panel shown/hidden and after that
          // the last (2nd) split always becomes active,
          // because scroll events order is always – 1st split, then 2nd split.

          if (eventTimeStamp - eventTimestampStart > 100) {
            if (!active) {
              updateIndexPanelActive(_index);
            }
          } // ====================================================================================


          refDefineTopPanelVisibilityByScrollTop.current(e);
        }

        if (refData.current.isCanShowArrows && refSwipeArrows.current) {
          refSwipeArrows.current.showArrowsWithAutoHide();
        }

        if (active) {
          clearTimeout(idTimerDetectFirstPara);
          idTimerDetectFirstPara = setTimeout(function () {
            if (!refIsPreventDetectFirstVisible.current) {
              var _refData$current5 = refData.current,
                  _id = _refData$current5.id,
                  _currentPlayingPara = _refData$current5.currentPlayingPara,
                  _paraListIds = _refData$current5.paraListIds,
                  _index2 = _refData$current5.index,
                  _fontSizeFinal = _refData$current5.fontSizeFinal;

              var firstVisiblePara = (0,reader/* getReaderFirstVisibleId */.E6)(elContentWrap, false, refReaderTopEdgeHeightOccupied.current) || _paraListIds[_paraListIds.length - 1]; // ==== SPECIAL CASE: Don't update active para ====
              // ==== if it's in the view AND it's in the player ====


              var isPreventUpdateActivePara = false;

              if (_currentPlayingPara && _currentPlayingPara.id === _id) {
                var elParaActive = elContentWrap.querySelector("[".concat(reader_constants/* DATA_ATTR_PARA_ID */.vl, "=\"").concat(_id, "\"]"));

                if (elParaActive) {
                  var elParaActiveTop = elParaActive.offsetTop + _fontSizeFinal;
                  var elParaActiveBottom = elParaActiveTop + elParaActive.offsetHeight - _fontSizeFinal;
                  var viewTop = elContentWrap.scrollTop;
                  var viewBottom = viewTop + elContentWrap.clientHeight;

                  if ((0,number/* isNumberBetweenEquals */.S5)(elParaActiveTop, viewTop, viewBottom - _fontSizeFinal * 1.3) || (0,number/* isNumberBetweenEquals */.S5)(elParaActiveBottom, viewTop, viewBottom - _fontSizeFinal * 1.3)) {
                    isPreventUpdateActivePara = true;
                  }
                }
              } // ========================================================


              if (firstVisiblePara) {
                if (!isPreventUpdateActivePara) {
                  updatePanel(_index2, firstVisiblePara);
                }

                refParaIdLastSyncedOnScrollStop.current = firstVisiblePara;
                refSyncPanels.current(firstVisiblePara);
              }
            }
          }, DELAY_DETECT_FIRST_PARA);
        }
      }

      setScrollTopValue(scrollTop);
      refLastScrollData.current = {
        scrollTop: scrollTop,
        chapterId: refData.current.chapterId
      };
    };

    elContentWrap.addEventListener("scroll", handleScroll);
    return function () {
      clearTimeout(idTimerDetectFirstPara);
      elContentWrap.removeEventListener("scroll", handleScroll);
    };
  }, [isMainPanel, elContentWrap, stopSyncPlayerAndReader, updatePanel, unhoverElementNote, updateIndexPanelActive]); // Scrolls to {id} on location chapter change.

  var refIsFirstTime = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (!elContentWrap || !id || isLiveReading || isLoading) {
      return;
    }

    var elCurrentPara = elContentWrap.querySelector("[".concat(reader_constants/* DATA_ATTR_PARA_ID */.vl, "='").concat(id, "']"));

    if (elCurrentPara) {
      if (refIsFirstTime.current) {
        preventUpdateActiveIdBasedOnFirstVisible();
        scroll(elCurrentPara.offsetTop);
      } else {
        var viewTop = elContentWrap.scrollTop;
        var viewBottom = viewTop + elContentWrap.offsetHeight;
        var elemTop = elCurrentPara.offsetTop;
        var elemBottom = elemTop + elCurrentPara.offsetHeight;

        if (active ? !(0,number/* isNumberBetweenEquals */.S5)(elemTop, viewTop, viewBottom) && !(0,number/* isNumberBetweenEquals */.S5)(elemBottom, viewTop, viewBottom) && !(viewTop >= elemTop && viewBottom <= elemBottom) : !(0,number/* isNumberBetweenEquals */.S5)(elemTop, viewTop, viewBottom) || !(0,number/* isNumberBetweenEquals */.S5)(elemBottom, viewTop, viewBottom)) {
          preventUpdateActiveIdBasedOnFirstVisible();
          scroll(elCurrentPara.offsetTop);
        }
      }
    } else {
      scroll(0);
    }

    refIsFirstTime.current = false;
  }, [isLoading, elContentWrap, id, scroll, preventUpdateActiveIdBasedOnFirstVisible, updatePanel, index]);
  /* ====================================================== */
  // Sync panels on location chapter change.

  (0,react.useEffect)(function () {
    var _paraList$paras5;

    if (!(paraList !== null && paraList !== void 0 && (_paraList$paras5 = paraList.paras) !== null && _paraList$paras5 !== void 0 && _paraList$paras5.length) || !id || isLiveReading) {
      return;
    }

    if (isMainPanel && refParaIdLastSyncedOnScrollStop.current !== id) {
      syncPanels(id);
    }
  }, [elContentWrap, paraList, id, isMainPanel]);
  /* ====================================================== */
  // Handle global swipe.

  (0,react.useEffect)(function () {
    var listener = function listener(e) {
      if (getSelectionCrossBrowser().toString()) {
        // prevent swipe handling if selecting the text.
        return;
      }

      if (e.absX > (0,number/* clutch */.Cz)(window.innerWidth / 5, 75, 150)) {
        if (e.dir === "Left") {
          goToNextChapter();
        }

        if (e.dir === "Right") {
          goToPrevChapter();
        }
      }
    };

    addSwipedListener(listener);
    return function () {
      removeSwipedListener(listener);
    };
  }, [addSwipedListener, removeSwipedListener, goToNextChapter, goToPrevChapter]); // {preventStopSyncReaderAndPlayer} on player skip (+/- 10 seconds)

  (0,react.useEffect)(function () {
    var listener = function listener(_ref3) {
      var event = _ref3.event;

      if (event === AudioContext/* PLAYER_EVENTS.SKIP */.mL.SKIP) {
        preventStopSyncReaderAndPlayer();
      }
    };

    subscribeToPlayerEvents(listener);
    return function () {
      unsubscribeFromPlayerEvents(listener);
    };
  }, [preventStopSyncReaderAndPlayer]); // Clean up timeouts.

  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(refTimeout.current);
      clearTimeout(refTimeout2.current);
      clearTimeout(refTimeout3.current);
    };
  }, []);
  reader_useReaderPanelLink(elContentWrap, linkActive, "link-selected", true, preventUpdateActiveIdBasedOnFirstVisible);
  reader_useHighlightContainingMarkNoteElements(elContentWrap, paraList);
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((reader_module_default()).root, className, (_classNames = {}, Panel_defineProperty(_classNames, (reader_module_default())["live-reading"], isReadyAndWaitingToLiveRead || isLiveReading), Panel_defineProperty(_classNames, (reader_module_default())["ready-syncing-with-player"], isReadyAndWaitingToLiveRead), Panel_defineProperty(_classNames, (reader_module_default())["syncing-with-player"], isLiveReading), _classNames))
  }, /*#__PURE__*/react.createElement(Scroll/* default */.Z, Panel_extends({
    ref: refScrollbars
  }, Panel_defineProperty({}, reader_constants/* DATA_ATTR_PANEL_INDEX */.qg, index), {
    renderViewClassName: classnames_default()((reader_module_default())["reader-list"], "reader-content-wrap", book === null || book === void 0 ? void 0 : book.folder_color_group, (_classNames2 = {}, Panel_defineProperty(_classNames2, (reader_module_default())["reader-panel-hide-marks"], !isShownMarks || !totalTextSearch), Panel_defineProperty(_classNames2, (reader_module_default())["passive-reader"], !active), Panel_defineProperty(_classNames2, "active", active), Panel_defineProperty(_classNames2, (reader_module_default())["is-loading"], isLoading), Panel_defineProperty(_classNames2, (reader_module_default())["disable-interaction"], isLoading && paraListIds.length), _classNames2)),
    isRenderViewFocusable: true,
    style: {
      fontSize: fontSize + "px"
    },
    onClick: handleClick,
    onMouseMove: handleMouseMove,
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd
  }), !isAllowedShowParas && /*#__PURE__*/react.createElement("div", {
    className: (reader_module_default())["reader-buy-book"]
  }, /*#__PURE__*/react.createElement("p", null, t("plsLoginToSeeBookContent")), /*#__PURE__*/react.createElement(components/* Button */.zx, {
    onClick: login
  }, t("signIn"))), !(paraList || paraListLoading) && isLoading && isAllowedShowParas && /*#__PURE__*/react.createElement(Loader, {
    align: "flex-center"
  }), isAllowedShowParas && (paraList || paraListLoading) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(SwipeArrows/* default */.Z, {
    ref: refSwipeArrows,
    className: classnames_default()((reader_module_default())["swipe-arrows"], Panel_constants/* CN_EL_SWIPE_ARROWS */.Jc),
    isCanShowArrowLeft: !!prevChapter,
    isCanShowArrowRight: !!nextChapter,
    onClickArrowLeft: goToPrevChapter,
    onClickArrowRight: goToNextChapter
  }), /*#__PURE__*/react.createElement(components_ReaderModeOnlyElement, null, /*#__PURE__*/react.createElement(components/* Typography */.ZT, {
    className: Panel_constants/* CN_EL_READER_MODE */.i,
    tag: "span",
    variant: "body3"
  }, "(", t("noteBrowserReaderMode"), ")")), /*#__PURE__*/react.createElement(ParaList_ParaList, {
    firstParaOffsetTop: readerTopEdgeHeightOccupied,
    showTranslations: (book === null || book === void 0 ? void 0 : book.book_id) === 2017 ? false : showTranslations,
    showRefCodes: showRefCodes,
    activeId: idParaHighlighted,
    items: paraList || paraListLoading,
    onClickTranslate: handleClickTranslate,
    onClickAnchor: handleClickAnchor
  }), activePopup === Popups.DICTIONARY && /*#__PURE__*/react.createElement(DictionaryPopup_DictionaryPopup, {
    isShown: isShown,
    anchorEl: anchorEl,
    contentWrapElRect: rectElContentWrap,
    onHidePopup: handleHidePopup,
    search: dictionarySearch
  }), activePopup === Popups.TRANSLATIONS && /*#__PURE__*/react.createElement(TranslationsPopup_TranslationsPopup, {
    indexPanel: index,
    isShown: isShown,
    anchorEl: anchorEl,
    contentWrapElRect: rectElContentWrap,
    onHidePopup: handleHidePopup,
    listTranslations: listTranslations,
    className: (reader_module_default())["reader__popup-translations__inner"]
  }))), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((reader_module_default())["arrow-player"], Panel_constants/* CN_EL_ARROW_PLAYER */.rn),
    ref: refElArrow
  }, /*#__PURE__*/react.createElement(ReaderArrowIcon, null)));
};

Panel.propTypes = {
  data: (prop_types_default()).object,
  active: (prop_types_default()).bool,
  activePanel: (prop_types_default()).number,
  showTranslations: (prop_types_default()).bool,
  fontSize: (prop_types_default()).number,
  prevChapter: (prop_types_default()).object,
  nextChapter: (prop_types_default()).object,
  onClick: (prop_types_default()).func,
  isPlayingCurrentBook: (prop_types_default()).bool,
  onScrollContentWrap: (prop_types_default()).func
};
/* harmony default export */ var Reader_Panel = (Panel);
// EXTERNAL MODULE: ../shared/hooks/useCookiesWithOptions.js + 9 modules
var useCookiesWithOptions = __webpack_require__(65482);
// EXTERNAL MODULE: ../shared/utils/print.js
var utils_print = __webpack_require__(77149);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../shared/contexts/AudioContext.hooks.js
var AudioContext_hooks = __webpack_require__(81852);
// EXTERNAL MODULE: ../shared/components/PlayerBehaviourDialog/PlayerBehaviourDialog.js
var PlayerBehaviourDialog = __webpack_require__(8217);
// EXTERNAL MODULE: ../shared/store/settings/actions.js
var store_settings_actions = __webpack_require__(58538);
// EXTERNAL MODULE: ../main/src/redux/settings/actions.js
var redux_settings_actions = __webpack_require__(33174);
// EXTERNAL MODULE: ../main/src/redux/system/system.actions.js
var system_actions = __webpack_require__(42693);
// EXTERNAL MODULE: ../shared/constants.js
var shared_constants = __webpack_require__(75573);
// EXTERNAL MODULE: ../shared/utils/player.js
var player = __webpack_require__(87794);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
;// CONCATENATED MODULE: ../shared/hooks/reader/useReaderPlayer.js
function useReaderPlayer_typeof(obj) { "@babel/helpers - typeof"; return useReaderPlayer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, useReaderPlayer_typeof(obj); }

function useReaderPlayer_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ useReaderPlayer_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == useReaderPlayer_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function useReaderPlayer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function useReaderPlayer_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { useReaderPlayer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { useReaderPlayer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function useReaderPlayer_slicedToArray(arr, i) { return useReaderPlayer_arrayWithHoles(arr) || useReaderPlayer_iterableToArrayLimit(arr, i) || useReaderPlayer_unsupportedIterableToArray(arr, i) || useReaderPlayer_nonIterableRest(); }

function useReaderPlayer_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useReaderPlayer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useReaderPlayer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useReaderPlayer_arrayLikeToArray(o, minLen); }

function useReaderPlayer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function useReaderPlayer_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useReaderPlayer_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





















var READER_PLAYER_DIALOG_ID = "rpl/d";
/**
 * @typedef ReaderPlayerHook

 * @property indexPanelInPlayer: number,

 * @property isInPlayerAnotherBook: boolean | undefined,
 * @property isInPlayerAnotherPara: boolean | undefined,
 * @property isInPlayerAnotherChapter: boolean | undefined,
 * @property isCurrentParaHasAudio: (boolean|undefined),

 * @property waveformsDictionary: {},
 * @property activeChapterAudioChapter: {} | null,
 * @property firstAvailableAudioChapter: {} | null,
 * @property currentPlayingPara: {} | null

 * @property syncPlayerAndReader: boolean,
 * @property enableSyncReaderAndPlayer: () => void,
 * @property stopSyncPlayerAndReader: () => void,
 * @property handlePlayClick: () => void,

 * @property handleOpenPanel: () => void,
 * @property handleClosePanel: () => void,
 * @property handleSwapPanels: () => void,
 */

/**
 * @return {ReaderPlayerHook}
 */

var useReaderPlayer = function useReaderPlayer(_ref) {
  var book = _ref.book,
      toc = _ref.toc,
      index = _ref.index,
      activeChapterId = _ref.activeChapterId,
      activeId = _ref.activeId,
      fromML = _ref.fromML,
      isIgnoreSettings = _ref.isIgnoreSettings,
      bookHistory = _ref.bookHistory,
      isBookAudioHistoryFetching = _ref.isBookAudioHistoryFetching,
      updateActivePanel = _ref.updateActivePanel,
      onShowPlayTypeDialog = _ref.onShowPlayTypeDialog;
  var bookId = (0,content/* getBookIdWithPrefix */.NR)(activeChapterId);
  var bookFirstPara = book ? book.first_para : undefined;
  var refIsPopupShownAfterLiveReadingDesync = (0,react.useRef)(false);

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(index),
      _useState2 = useReaderPlayer_slicedToArray(_useState, 2),
      indexPanelInPlayer = _useState2[0],
      setIndexPanelInPlayer = _useState2[1];

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      _toggleChapterPlaying = _useAudioContext.toggleChapterPlaying,
      _playChapterAndShowPlayer = _useAudioContext.playChapterAndShowPlayer,
      isPlaying = _useAudioContext.isPlaying,
      chapterId = _useAudioContext.chapterId,
      audioChapterId = _useAudioContext.audioChapterId,
      getPlayerCurrentTime = _useAudioContext.getPlayerCurrentTime,
      downloadOrPullFromSWWaveformsData = _useAudioContext.downloadOrPullFromSWWaveformsData;

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      showModal = _useModalContext.showModal,
      hideDialog = _useModalContext.hideDialog,
      checkDialogId = _useModalContext.checkDialogId;

  var toggleChapterPlaying = function toggleChapterPlaying() {
    _toggleChapterPlaying.apply(void 0, arguments);

    if (indexPanelInPlayer !== index) {
      setIndexPanelInPlayer(index);
    }
  };

  var playChapterAndShowPlayer = function playChapterAndShowPlayer() {
    _playChapterAndShowPlayer.apply(void 0, arguments);

    if (indexPanelInPlayer !== index) {
      setIndexPanelInPlayer(index);
    }
  };

  var currentPlayingPara = (0,AudioContext_hooks/* useGetCurrentPlayingPara */.E0)();
  var waveformsDictionary = (0,es/* useSelector */.v9)(player_selectors/* selectorPlayerWaveformsDictionary */.cc);
  var paraChangePlayerBehaviour = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.paraChangePlayerBehaviour.id */.Fy.paraChangePlayerBehaviour.id));
  var isLogin = (0,es/* useSelector */.v9)(selectors/* selectorSystemIsLogin */.wN);
  var isIgnoreSettingsFinal = isIgnoreSettings !== null && isIgnoreSettings !== void 0 ? isIgnoreSettings : !isLogin;
  var bookChangePlayerBehaviour = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.bookChangePlayerBehaviour.id */.Fy.bookChangePlayerBehaviour.id));
  var syncPlayerAndReader = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id));
  var isReaderBehaviourDialogShown = checkDialogId(READER_PLAYER_DIALOG_ID);
  var firstAvailableAudioChapter = (0,react.useMemo)(function () {
    return (0,player/* getFirstAvailableAudioChapter */._g)(toc);
  }, [toc]);
  var activeChapterAudioChapter = (0,react.useMemo)(function () {
    if (activeChapterId === undefined) {
      return undefined;
    }

    if (bookFirstPara && activeChapterId === bookFirstPara) {
      return (0,player/* getFirstAvailableAudioChapter */._g)(toc);
    }

    return (0,reader/* getReaderAudioChapter */.mT)(toc, activeChapterId);
  }, [toc, activeChapterId, bookFirstPara]);
  var activeParaPositions = (0,player/* findWaveformsDictionaryParaById */.Mp)(waveformsDictionary, activeChapterAudioChapter === null || activeChapterAudioChapter === void 0 ? void 0 : activeChapterAudioChapter.id, activeId);
  var isActiveAudioChapterPositionsFetching = activeChapterAudioChapter === undefined;
  var isCurrentParaHasAudio;
  var isCurrentParaAudioPositionsLoading = false;

  if (book && book.is_audiobook && toc !== null && toc !== void 0 && toc.length) {
    isCurrentParaAudioPositionsLoading = isActiveAudioChapterPositionsFetching || !activeParaPositions;
    isCurrentParaHasAudio = !!activeChapterAudioChapter;
  } else {
    isCurrentParaHasAudio = false;
  }

  var isInPlayerAnotherBook = !chapterId || !activeId ? false : !(0,content/* isSameBook */.fr)(chapterId, activeId);
  var isInPlayerAnotherChapter = isActiveAudioChapterPositionsFetching || !chapterId ? false : (activeChapterAudioChapter === null || activeChapterAudioChapter === void 0 ? void 0 : activeChapterAudioChapter.id) !== audioChapterId;
  var isInPlayerAnotherPara = !currentPlayingPara || !activeId || !chapterId ? false : activeId !== currentPlayingPara.id;
  /* TODO: Can be called on the play click, but fetching loader should be implemented then. */
  // Fetches current Reader chapter audio positions.

  (0,react.useEffect)(function () {
    downloadOrPullFromSWWaveformsData(activeChapterAudioChapter);
  }, [activeChapterAudioChapter]);

  var getLibraryBookHistory = function getLibraryBookHistory() {
    if (bookHistory !== null && bookHistory !== void 0 && bookHistory.listenChapterId) {
      return {
        chapter: bookHistory.listenChapterId,
        position: bookHistory.listenPosition
      };
    }

    return null;
  };

  var getBookLastPlayed = function getBookLastPlayed() {
    if (isInPlayerAnotherBook === false && chapterId) {
      return {
        chapter: chapterId,
        audioChapterId: audioChapterId,
        position: getPlayerCurrentTime()
      };
    }

    return null;
  };

  var showToastParaAutoReadingIsNotAvailable = function showToastParaAutoReadingIsNotAvailable() {
    dispatch(system_actions/* systemActions.toast */.n.toast(t("paraAutoReadNotAvailable"), shared_constants/* TOAST_TYPE.warning */["do"].warning));
  };

  var enableSyncReaderAndPlayer = function enableSyncReaderAndPlayer() {
    dispatch(store_settings_actions/* _sharedActionsSettings.updateSettings */.a.updateSettings(settings_constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id, true));
  };

  var stopSyncPlayerAndReader = function stopSyncPlayerAndReader() {
    if (syncPlayerAndReader && isPlaying) {
      dispatch(redux_settings_actions/* settingsActions.updateSettings */.f.updateSettings(settings_constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id, false));
      dispatch(system_actions/* systemActions.toast */.n.toast("@audioSyncDisabled", shared_constants/* TOAST_TYPE.warning */["do"].warning));
    }
  };

  var playAudioFromCurrentPara = /*#__PURE__*/function () {
    var _ref2 = useReaderPlayer_asyncToGenerator( /*#__PURE__*/useReaderPlayer_regeneratorRuntime().mark(function _callee() {
      var para;
      return useReaderPlayer_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!activeChapterAudioChapter) {
              _context.next = 9;
              break;
            }

            para = activeParaPositions !== null && activeParaPositions !== void 0 ? activeParaPositions : activeChapterAudioChapter;
            _context.next = 4;
            return updateActivePanel(para ? para.id : activeChapterAudioChapter.id);

          case 4:
            playChapterAndShowPlayer(activeChapterAudioChapter.id, para ? para.start : 0);
            enableSyncReaderAndPlayer();
            return _context.abrupt("return", true);

          case 9:
            showToastParaAutoReadingIsNotAvailable();
            return _context.abrupt("return", false);

          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function playAudioFromCurrentPara() {
      return _ref2.apply(this, arguments);
    };
  }();

  var playAudioFromHistory = /*#__PURE__*/function () {
    var _ref3 = useReaderPlayer_asyncToGenerator( /*#__PURE__*/useReaderPlayer_regeneratorRuntime().mark(function _callee2() {
      var history;
      return useReaderPlayer_regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            history = getLibraryBookHistory();

            if (!history) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return playAudioFromCurrentPara(history.chapter);

          case 4:
            playChapterAndShowPlayer(history.chapter, history.position, {
              fromML: fromML
            });
            enableSyncReaderAndPlayer();
            return _context2.abrupt("return", true);

          case 7:
            return _context2.abrupt("return", false);

          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function playAudioFromHistory() {
      return _ref3.apply(this, arguments);
    };
  }();

  var playAudioFirstAvailable = /*#__PURE__*/function () {
    var _ref4 = useReaderPlayer_asyncToGenerator( /*#__PURE__*/useReaderPlayer_regeneratorRuntime().mark(function _callee3() {
      return useReaderPlayer_regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!firstAvailableAudioChapter) {
              _context3.next = 6;
              break;
            }

            _context3.next = 3;
            return playAudioFromCurrentPara(firstAvailableAudioChapter.id);

          case 3:
            playChapterAndShowPlayer(firstAvailableAudioChapter.id, 0, {
              fromML: fromML
            });
            enableSyncReaderAndPlayer();
            return _context3.abrupt("return", true);

          case 6:
            return _context3.abrupt("return", false);

          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));

    return function playAudioFirstAvailable() {
      return _ref4.apply(this, arguments);
    };
  }();

  var playAudioContinue = /*#__PURE__*/function () {
    var _ref5 = useReaderPlayer_asyncToGenerator( /*#__PURE__*/useReaderPlayer_regeneratorRuntime().mark(function _callee4() {
      return useReaderPlayer_regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (chapterId) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", playAudioFromCurrentPara());

          case 2:
            if (isPlaying) {
              _context4.next = 7;
              break;
            }

            _context4.next = 5;
            return updateActivePanel((currentPlayingPara === null || currentPlayingPara === void 0 ? void 0 : currentPlayingPara.id) || chapterId);

          case 5:
            toggleChapterPlaying(chapterId);
            return _context4.abrupt("return", true);

          case 7:
            return _context4.abrupt("return", false);

          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));

    return function playAudioContinue() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleReaderPlayerBehaviour = function handleReaderPlayerBehaviour(behaviourType) {
    if (behaviourType === reader_constants/* READER_PLAYER_BEHAVIOURS.CONTINUE */.bn.CONTINUE) {
      return playAudioContinue();
    } else if (behaviourType === reader_constants/* READER_PLAYER_BEHAVIOURS.HISTORY */.bn.HISTORY) {
      return playAudioFromHistory();
    } else if (behaviourType === reader_constants/* READER_PLAYER_BEHAVIOURS.CURRENT_PARA */.bn.CURRENT_PARA) {
      return playAudioFromCurrentPara();
    } else if (behaviourType === reader_constants/* READER_PLAYER_BEHAVIOURS.FIRST_AVAILABLE */.bn.FIRST_AVAILABLE) {
      return playAudioFirstAvailable();
    }

    return false;
  };

  var showPlayTypeDialog = function showPlayTypeDialog() {
    if (onShowPlayTypeDialog) {
      onShowPlayTypeDialog();
    }

    var isShowBtnPlayCurrChapter = !!(activeChapterAudioChapter !== null && activeChapterAudioChapter !== void 0 && activeChapterAudioChapter.mp3);
    var isShowBtnPlayFirstAvailable = isShowBtnPlayCurrChapter ? false : !!firstAvailableAudioChapter;
    var isShowBtnPlayFromHistory = isInPlayerAnotherBook ? !!getLibraryBookHistory() : !!getLibraryBookHistory() && !chapterId;
    var countShownButtons = isShowBtnPlayCurrChapter + isShowBtnPlayFromHistory + isShowBtnPlayFirstAvailable;
    var isShowBtnPlayContinue = !!chapterId && countShownButtons > 0;

    if (isShowBtnPlayContinue) {
      countShownButtons += 1;
    }

    var isShowCheckboxDoNotAskAgain = !isIgnoreSettingsFinal && countShownButtons > 1;
    var isDoNotAskChecked = isInPlayerAnotherBook ? !bookChangePlayerBehaviour === reader_constants/* READER_PLAYER_BEHAVIOURS.ASK */.bn.ASK : !paraChangePlayerBehaviour === reader_constants/* READER_PLAYER_BEHAVIOURS.ASK */.bn.ASK;
    var subtitle;
    var isCanPlayCurrentBook = isShowBtnPlayCurrChapter || isShowBtnPlayFirstAvailable;

    if (isCanPlayCurrentBook) {
      if (isInPlayerAnotherBook) {
        subtitle = t("smthChangedHowToProceed", {
          smth: t("book").toLowerCase()
        });
      } else if (isInPlayerAnotherChapter || isInPlayerAnotherPara) {
        subtitle = t("smthChangedHowToProceed", {
          smth: t(isInPlayerAnotherChapter ? "chapter" : "paragraph").toLowerCase()
        });
      }
    } else {
      subtitle = t("audioNotAvailable");
    }

    showModal( /*#__PURE__*/react.createElement(PlayerBehaviourDialog/* default */.Z, {
      subtitle: subtitle,
      canContinue: isShowBtnPlayContinue,
      canDoNotAskAgain: isShowCheckboxDoNotAskAgain,
      canPlayFromHistory: isShowBtnPlayFromHistory,
      canPlayFirstAvailable: isShowBtnPlayFirstAvailable,
      canPlayFromCurrentPara: isShowBtnPlayCurrChapter,
      isDoNotAskChecked: isDoNotAskChecked,
      onClickBehaviour: function onClickBehaviour(type, doNotAskAgain) {
        if (doNotAskAgain) {
          if (isInPlayerAnotherBook) {
            dispatch(store_settings_actions/* _sharedActionsSettings.updateSettings */.a.updateSettings(settings_constants/* SETTING.bookChangePlayerBehaviour.id */.Fy.bookChangePlayerBehaviour.id, type));
          } else {
            dispatch(store_settings_actions/* _sharedActionsSettings.updateSettings */.a.updateSettings(settings_constants/* SETTING.paraChangePlayerBehaviour.id */.Fy.paraChangePlayerBehaviour.id, type));
          }
        }

        handleReaderPlayerBehaviour(type);
        hideDialog();
      }
    }), {
      dialogId: READER_PLAYER_DIALOG_ID
    });
  };

  var handlePlayClick = /*#__PURE__*/function () {
    var _ref6 = useReaderPlayer_asyncToGenerator( /*#__PURE__*/useReaderPlayer_regeneratorRuntime().mark(function _callee5() {
      var success, bookAudioHistory, chapter, position, activeChapterAudioChapterId, audioChapter, _audioChapterId, _success;

      return useReaderPlayer_regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!isPlaying) {
              _context5.next = 3;
              break;
            }

            toggleChapterPlaying(chapterId);
            return _context5.abrupt("return");

          case 3:
            if (!isInPlayerAnotherBook) {
              _context5.next = 13;
              break;
            }

            if (!(bookChangePlayerBehaviour === reader_constants/* READER_PLAYER_BEHAVIOURS.ASK */.bn.ASK || !bookChangePlayerBehaviour || isIgnoreSettingsFinal)) {
              _context5.next = 8;
              break;
            }

            showPlayTypeDialog();
            _context5.next = 12;
            break;

          case 8:
            _context5.next = 10;
            return handleReaderPlayerBehaviour(bookChangePlayerBehaviour);

          case 10:
            success = _context5.sent;

            if (!success) {
              showPlayTypeDialog();
            }

          case 12:
            return _context5.abrupt("return");

          case 13:
            // ========
            // If isnt playing and Player and Reader books are the same, and book has listen history.
            bookAudioHistory = getBookLastPlayed() || getLibraryBookHistory();

            if (!bookAudioHistory) {
              _context5.next = 32;
              break;
            }

            chapter = bookAudioHistory.chapter, position = bookAudioHistory.position;
            activeChapterAudioChapterId = activeChapterAudioChapter === null || activeChapterAudioChapter === void 0 ? void 0 : activeChapterAudioChapter.id;
            audioChapter = (0,reader/* getReaderAudioChapter */.mT)(toc, chapter);
            _audioChapterId = audioChapter ? audioChapter.id : chapter;

            if (!(_audioChapterId === activeChapterAudioChapterId && (activeParaPositions ? (0,number/* isNumberBetweenEquals */.S5)(position, activeParaPositions.start, activeParaPositions.end) : true))) {
              _context5.next = 23;
              break;
            }

            // If Reader paragraph is the same as listen history paragraph.
            if (chapterId) {
              toggleChapterPlaying(chapter, position);
            } else {
              playChapterAndShowPlayer(_audioChapterId, position, {
                fromML: fromML
              });
              enableSyncReaderAndPlayer();
            }

            _context5.next = 31;
            break;

          case 23:
            if (!(!paraChangePlayerBehaviour || paraChangePlayerBehaviour === reader_constants/* READER_PLAYER_BEHAVIOURS.ASK */.bn.ASK || isIgnoreSettingsFinal)) {
              _context5.next = 27;
              break;
            }

            // Else if not authorized or setting is set to "ASK".
            showPlayTypeDialog();
            _context5.next = 31;
            break;

          case 27:
            _context5.next = 29;
            return handleReaderPlayerBehaviour(paraChangePlayerBehaviour);

          case 29:
            _success = _context5.sent;

            if (!_success) {
              showPlayTypeDialog();
            }

          case 31:
            return _context5.abrupt("return");

          case 32:
            if (!isCurrentParaHasAudio) {
              _context5.next = 37;
              break;
            }

            _context5.next = 35;
            return playAudioFromCurrentPara();

          case 35:
            _context5.next = 43;
            break;

          case 37:
            if (!(activeChapterAudioChapter !== null && activeChapterAudioChapter !== void 0 && activeChapterAudioChapter.mp3)) {
              _context5.next = 42;
              break;
            }

            _context5.next = 40;
            return playAudioFromCurrentPara();

          case 40:
            _context5.next = 43;
            break;

          case 42:
            showPlayTypeDialog();

          case 43:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));

    return function handlePlayClick() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleOpenPanel = function handleOpenPanel(indexNewPanel) {
    if (indexNewPanel === indexPanelInPlayer || indexNewPanel < indexPanelInPlayer) {
      setIndexPanelInPlayer(indexPanelInPlayer + 1);
    }
  };

  var handleClosePanel = function handleClosePanel(indexNewPanel) {
    if (indexNewPanel === indexPanelInPlayer) {
      setIndexPanelInPlayer(null);
    } else if (indexNewPanel < indexPanelInPlayer) {
      setIndexPanelInPlayer(indexPanelInPlayer - 1);
    }
  };

  var handleSwapPanels = function handleSwapPanels(indexPanel1, indexPanel2) {
    if (indexPanel1 === indexPanelInPlayer) {
      setIndexPanelInPlayer(indexPanel2);
    } else if (indexPanel2 === indexPanelInPlayer) {
      setIndexPanelInPlayer(indexPanel1);
    }
  }; // Shows the "Book/chapter/para changed. How to proceed audio?" dialog.


  (0,react.useEffect)(function () {
    if (!isPlaying || isCurrentParaAudioPositionsLoading || isBookAudioHistoryFetching || isReaderBehaviourDialogShown || // prevent show popup more than once after sync is stopped.
    refIsPopupShownAfterLiveReadingDesync.current) {
      if (book && activeId === book.book_id + ".0") {
        stopSyncPlayerAndReader();
      }

      return;
    }

    if (isInPlayerAnotherBook || isInPlayerAnotherChapter || isInPlayerAnotherPara) {
      var settingBehaviour = isInPlayerAnotherBook ? bookChangePlayerBehaviour : paraChangePlayerBehaviour;

      if (isIgnoreSettingsFinal || !settingBehaviour || settingBehaviour === reader_constants/* READER_PLAYER_BEHAVIOURS.ASK */.bn.ASK) {
        stopSyncPlayerAndReader();
        showPlayTypeDialog();
        refIsPopupShownAfterLiveReadingDesync.current = true;
      } else {
        handleReaderPlayerBehaviour(settingBehaviour);
      }
    }
  }, [isCurrentParaAudioPositionsLoading, isBookAudioHistoryFetching, isCurrentParaHasAudio, bookId, activeChapterId, activeId]); // Change Reader chapter on Player chapter change

  (0,react.useEffect)(function () {
    var idCurrentPlayingPara = (currentPlayingPara === null || currentPlayingPara === void 0 ? void 0 : currentPlayingPara.id) || chapterId;

    if (isPlaying && syncPlayerAndReader) {
      updateActivePanel(idCurrentPlayingPara);
    }
  }, [isPlaying, chapterId, currentPlayingPara]);
  var isLiveReadingActive = !!chapterId && syncPlayerAndReader;
  (0,react.useEffect)(function () {
    if (isLiveReadingActive) {
      refIsPopupShownAfterLiveReadingDesync.current = false;
    }
  }, [isLiveReadingActive]);
  return {
    indexPanelInPlayer: indexPanelInPlayer,
    syncPlayerAndReader: syncPlayerAndReader,
    isInPlayerAnotherBook: isInPlayerAnotherBook,
    isInPlayerAnotherChapter: isInPlayerAnotherChapter,
    isInPlayerAnotherPara: isInPlayerAnotherPara,
    waveformsDictionary: waveformsDictionary,
    currentPlayingPara: currentPlayingPara,
    activeChapterAudioChapter: activeChapterAudioChapter,
    firstAvailableAudioChapter: firstAvailableAudioChapter,
    handlePlayClick: handlePlayClick,
    enableSyncReaderAndPlayer: enableSyncReaderAndPlayer,
    stopSyncPlayerAndReader: stopSyncPlayerAndReader,
    handleOpenPanel: handleOpenPanel,
    handleClosePanel: handleClosePanel,
    handleSwapPanels: handleSwapPanels
  };
};

/* harmony default export */ var reader_useReaderPlayer = (useReaderPlayer);
// EXTERNAL MODULE: ../shared/store/selectors.js
var store_selectors = __webpack_require__(31427);
// EXTERNAL MODULE: ./src/next/components/Accordion/Accordion.js
var Accordion = __webpack_require__(98861);
// EXTERNAL MODULE: ../shared/utils/select.js
var utils_select = __webpack_require__(48018);
// EXTERNAL MODULE: ../shared/hooks/pwa/sw.js + 2 modules
var sw = __webpack_require__(69867);
// EXTERNAL MODULE: ../shared/components/modal/ModalActions.js
var ModalActions = __webpack_require__(35727);
// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../shared/utils/sw/sw.js + 1 modules
var sw_sw = __webpack_require__(3359);
// EXTERNAL MODULE: ../shared/utils/time.js
var time = __webpack_require__(82344);
;// CONCATENATED MODULE: ../shared/utils/file.js
var bytesToMb = function bytesToMb(bytes) {
  var kb = bytes / 1024;
  var mb = kb / 1024;
  return mb.toFixed(2);
};
// EXTERNAL MODULE: ../shared/utils/array.js
var array = __webpack_require__(21707);
// EXTERNAL MODULE: ../shared/utils/multilang/constants.js + 1 modules
var multilang_constants = __webpack_require__(90438);
// EXTERNAL MODULE: ./src/next/components/modal/ModalDownload.module.scss
var ModalDownload_module = __webpack_require__(68431);
var ModalDownload_module_default = /*#__PURE__*/__webpack_require__.n(ModalDownload_module);
// EXTERNAL MODULE: ../shared/store/sw/selectorAudiosDownloadedIds.js
var selectorAudiosDownloadedIds = __webpack_require__(8073);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadedBooksIds.js
var selectorDownloadedBooksIds = __webpack_require__(4586);
;// CONCATENATED MODULE: ./src/next/components/modal/ModalDownload.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || ModalDownload_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return ModalDownload_arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = ModalDownload_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function ModalDownload_slicedToArray(arr, i) { return ModalDownload_arrayWithHoles(arr) || ModalDownload_iterableToArrayLimit(arr, i) || ModalDownload_unsupportedIterableToArray(arr, i) || ModalDownload_nonIterableRest(); }

function ModalDownload_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function ModalDownload_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ModalDownload_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ModalDownload_arrayLikeToArray(o, minLen); }

function ModalDownload_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ModalDownload_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function ModalDownload_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



























var BookCover = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 657).then(__webpack_require__.bind(__webpack_require__, 33657));
}, {
  ssr: false
});

var BookItem = function BookItem(_ref) {
  var book = _ref.book,
      toc = _ref.toc,
      isChecked = _ref.isChecked,
      isDownloaded = _ref.isDownloaded,
      onChangeChecked = _ref.onChangeChecked,
      onRemoveBook = _ref.onRemoveBook,
      onRemoveAudio = _ref.onRemoveAudio,
      audioChaptersIds = _ref.audioChaptersIds,
      setAudioChaptersIds = _ref.setAudioChaptersIds;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var downloadedAudiosIds = (0,es/* useSelector */.v9)(selectorAudiosDownloadedIds/* selectorAudiosDownloadedIds */.P);

  var _useMemo = (0,react.useMemo)(function () {
    var audioChapters = (0,player/* filterTOCToAudioChapters */.dm)(toc);
    var map = {};

    if (audioChapters) {
      var _iterator = _createForOfIteratorHelper(audioChapters),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var audioChapter = _step.value;
          map[audioChapter.para_id] = audioChapter;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return [audioChapters.map(function (c) {
      return (0,utils_select/* makeOption */.D)(c.para_id, c.title);
    }), map];
  }, [toc]),
      _useMemo2 = ModalDownload_slicedToArray(_useMemo, 2),
      audioChaptersOptions = _useMemo2[0],
      mapChapterIdToChapter = _useMemo2[1];

  var downloadedChapterIds = (0,react.useMemo)(function () {
    return Object.keys(mapChapterIdToChapter).filter(function (id) {
      return downloadedAudiosIds.includes(id);
    });
  }, [mapChapterIdToChapter, downloadedAudiosIds]);
  return /*#__PURE__*/react.createElement("div", {
    className: (ModalDownload_module_default())["book-item"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (ModalDownload_module_default())["book-item_wrap"]
  }, /*#__PURE__*/react.createElement("div", null, isDownloaded ? /*#__PURE__*/react.createElement(Button/* default */.Z, {
    onClick: function onClick() {
      return onRemoveBook(book);
    }
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.delete */.Z["delete"]
  })) : /*#__PURE__*/react.createElement(components/* Checkbox */.XZ, {
    checked: isChecked,
    onChange: onChangeChecked
  })), /*#__PURE__*/react.createElement("div", {
    className: (ModalDownload_module_default())["book-item_book-content"]
  }, /*#__PURE__*/react.createElement(BookCover, {
    className: (ModalDownload_module_default())["book-item_cover"],
    book: book
  }), /*#__PURE__*/react.createElement("div", {
    className: (ModalDownload_module_default())["book-item_right"]
  }, /*#__PURE__*/react.createElement(components/* Typography */.ZT, {
    variant: "h5",
    color: "inherit",
    fontFamily: "roboto",
    dangerouslySetInnerHTML: {
      __html: book.title
    }
  }), /*#__PURE__*/react.createElement(components/* Typography */.ZT, {
    variant: "body3",
    clamp: 3,
    dangerouslySetInnerHTML: {
      __html: book.description
    }
  })))), !!audioChaptersOptions.length && /*#__PURE__*/react.createElement(Accordion/* default */.Z, {
    head: /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components/* Typography */.ZT, {
      className: (ModalDownload_module_default())["accordion-head_mp3"],
      hoverable: true,
      variant: "h4"
    }, t("mp3"), /*#__PURE__*/react.createElement(components/* ArrowIcon */.e0, {
      className: (ModalDownload_module_default())["arrow-icon"]
    }), "\xA0(", downloadedChapterIds.length, "/", audioChaptersOptions.length, ")")),
    body: /*#__PURE__*/react.createElement("table", {
      className: (ModalDownload_module_default())["table-mp3"]
    }, /*#__PURE__*/react.createElement("thead", null, /*#__PURE__*/react.createElement("tr", null, /*#__PURE__*/react.createElement("th", {
      align: "left"
    }, t("chapter")), /*#__PURE__*/react.createElement("th", {
      align: "left"
    }, t("duration")), /*#__PURE__*/react.createElement("th", {
      align: "right"
    }, t("size"), "(mb)"))), /*#__PURE__*/react.createElement("tbody", null, audioChaptersOptions.map(function (item) {
      var key = (0,utils_select/* getOptionKey */._)(item);
      var audioChapter = mapChapterIdToChapter[key];
      var checkbox = /*#__PURE__*/react.createElement(components/* Checkbox */.XZ, {
        key: key,
        title: item.label,
        checked: audioChaptersIds.includes(key),
        onChange: function onChange() {
          var valueNew = _toConsumableArray(audioChaptersIds);

          (0,array/* toggleInArray */.rO)(valueNew, key);
          setAudioChaptersIds(valueNew);
        }
      });
      var content;

      if (downloadedChapterIds.includes(key)) {
        content = /*#__PURE__*/react.createElement("div", {
          className: (ModalDownload_module_default())["audio-chapter_actions"]
        }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
          onClick: function onClick() {
            return onRemoveAudio(audioChapter);
          }
        }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
          icon: EgwWebFont/* default.delete */.Z["delete"]
        })), /*#__PURE__*/react.createElement(components/* Typography */.ZT // threeDots
        , {
          variant: "body3",
          className: (ModalDownload_module_default()).label,
          color: "inherit"
        }, item.label));
      } else {
        content = checkbox;
      }

      return /*#__PURE__*/react.createElement("tr", {
        className: (ModalDownload_module_default())["audio-chapter-item"],
        key: key
      }, /*#__PURE__*/react.createElement("td", {
        align: "left"
      }, content), /*#__PURE__*/react.createElement("td", {
        align: "left"
      }, (0,time/* msToTimeLabel */.AJ)((0,player/* getFileDuration */.eM)(audioChapter.mp3) * 1000, ":")), /*#__PURE__*/react.createElement("td", {
        align: "right"
      }, bytesToMb((0,player/* getFileSize */.hR)(audioChapter.mp3))));
    })))
  }));
};

var ViewDownloadBook = function ViewDownloadBook(_ref2) {
  var bookId = _ref2.bookId,
      onClickDownload = _ref2.onClickDownload,
      onClickRemove = _ref2.onClickRemove,
      onClose = _ref2.onClose,
      onRemoveAudio = _ref2.onRemoveAudio;

  var _useTranslation2 = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation2.t;

  var _useBookWithSWFallbac = (0,sw/* useBookWithSWFallback */.OK)(bookId),
      book = _useBookWithSWFallbac.book,
      toc = _useBookWithSWFallbac.toc;

  var downloadedBooksIds = (0,es/* useSelector */.v9)(selectorDownloadedBooksIds/* selectorDownloadedBooksIds */.F);
  var bookBaseBible = (0,es/* useSelector */.v9)(store_selectors/* selectorBookBaseBible */.T);

  var _useState = (0,react.useState)([]),
      _useState2 = ModalDownload_slicedToArray(_useState, 2),
      audioChaptersIds = _useState2[0],
      setAudioChaptersIds = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      _useState4 = ModalDownload_slicedToArray(_useState3, 2),
      isDownloadBook = _useState4[0],
      setIsDownloadBook = _useState4[1];

  var _useState5 = (0,react.useState)(true),
      _useState6 = ModalDownload_slicedToArray(_useState5, 2),
      isDownloadSG = _useState6[0],
      setIsDownloadSG = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = ModalDownload_slicedToArray(_useState7, 2),
      isDownloadBible = _useState8[0],
      setIsDownloadBible = _useState8[1];

  var sgBooksMap = (0,es/* useSelector */.v9)(mainTree_selectors/* selectorMainTreeSgBooksMap */.Kw);
  var sgBook = book ? sgBooksMap[book.code] : null;

  if (!book) {
    return null;
  }

  return /*#__PURE__*/react.createElement("div", {
    className: (ModalDownload_module_default()).modal_body
  }, /*#__PURE__*/react.createElement(BookItem, {
    isDownloaded: downloadedBooksIds.includes(book.book_id.toString()),
    book: book,
    toc: toc,
    isChecked: isDownloadBook,
    onChangeChecked: setIsDownloadBook,
    audioChaptersIds: audioChaptersIds,
    setAudioChaptersIds: setAudioChaptersIds,
    onRemoveBook: onClickRemove,
    onRemoveAudio: onRemoveAudio
  }), /*#__PURE__*/react.createElement("div", null, lib/* isIOS */.gn && downloadedBooksIds.length > 9 && /*#__PURE__*/react.createElement(components/* Typography */.ZT, {
    tag: "div",
    className: (ModalDownload_module_default()).note,
    variant: components/* Typography.variant.body4 */.ZT.variant.body4,
    dangerouslySetInnerHTML: {
      __html: t("maxIOSLimit", {
        ns: multilang_constants/* I18N_NAMESPACE.sw */.E3.sw,
        count: downloadedBooksIds.length
      })
    }
  }), /*#__PURE__*/react.createElement("hr", null)), /*#__PURE__*/react.createElement(components/* Typography */.ZT, {
    variant: "h5",
    fontFamily: "roboto"
  }, t("sw:relatedBooks"), ":"), sgBook && /*#__PURE__*/react.createElement(BookItem, {
    isDownloaded: downloadedBooksIds.includes(sgBook.book_id.toString()),
    book: sgBook,
    toc: [],
    isChecked: isDownloadSG,
    onChangeChecked: setIsDownloadSG,
    onRemoveBook: onClickRemove,
    onRemoveAudio: onRemoveAudio
  }), bookBaseBible && /*#__PURE__*/react.createElement(BookItem, {
    isDownloaded: downloadedBooksIds.includes(bookBaseBible.book_id.toString()),
    book: bookBaseBible,
    toc: [],
    isChecked: isDownloadBible,
    onChangeChecked: setIsDownloadBible,
    onRemoveBook: onClickRemove,
    onRemoveAudio: onRemoveAudio
  }), /*#__PURE__*/react.createElement(ModalActions/* default */.Z, {
    className: (ModalDownload_module_default())["modal-actions"],
    onClickNegative: onClose,
    onClickPositive: function onClickPositive() {
      var books = [];

      if (book && isDownloadBook) {
        books.push(book);
      }

      if (sgBook && isDownloadSG) {
        books.push(sgBook);
      }

      if (bookBaseBible && isDownloadBible) {
        books.push(bookBaseBible);
      }

      var audioChapters = toc.filter(function (c) {
        return audioChaptersIds.includes(c.para_id);
      });
      onClickDownload(books, audioChapters);
    },
    positiveText: t("download")
  }));
};

var ModalDownload = function ModalDownload(_ref3) {
  var bookId = _ref3.bookId;

  var _useTranslation3 = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation3.t;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      onClose = _useModalContext.onClose,
      showDialog = _useModalContext.showDialog;

  var handleDownload = (0,react.useCallback)(function (books, audioChapters) {
    if (books.length) {
      dispatch(actions/* swActions.downloadDataBookData */.s1.downloadDataBookData(books));
    }

    if (audioChapters.length) {
      dispatch(actions/* swActions.downloadDataAudio */.s1.downloadDataAudio(audioChapters));
    }

    onClose();
  }, [onClose]);
  var handleRemove = (0,react.useCallback)(function (book) {
    showDialog(t("confirmation"), t("sw:confirmationRemove", {
      book: book.title ? "\"".concat(book.title, "\"") : t("book")
    }), function () {
      (0,sw_sw/* postSWMessageRemoveBook */.eJ)(book.book_id);
      return true;
    });
  }, [t]);
  var handleRemoveAudio = (0,react.useCallback)(function (chapter) {
    showDialog(t("confirmation"), t("sw:confirmationRemove", {
      book: "\"".concat(chapter.title, "\"")
    }), function () {
      (0,sw_sw/* postSWMessageRemoveAudio */.fP)(chapter.para_id);
      (0,sw_sw/* postSWMessageRemoveWaveform */.bV)(chapter.para_id);
      return true;
    });
  }, [t]);
  return /*#__PURE__*/react.createElement(ViewDownloadBook, {
    bookId: bookId,
    onClickDownload: handleDownload,
    onClickRemove: handleRemove,
    onRemoveAudio: handleRemoveAudio,
    onClose: onClose
  });
};

var useModalDownload = function useModalDownload() {
  var _useTranslation4 = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation4.t;

  var _useModalContext2 = (0,modal/* useModalContext */.v)(),
      showModal = _useModalContext2.showModal;

  return (0,react.useCallback)(function (bookId) {
    showModal( /*#__PURE__*/react.createElement(ModalDownload, {
      bookId: bookId
    }), {
      title: t("sw:downloadForOfflineUse"),
      className: (ModalDownload_module_default()).modal
    });
  }, [t, showModal]);
};
// EXTERNAL MODULE: ../shared/api/content/common.js + 1 modules
var common = __webpack_require__(11034);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.constants.js
var IconView_constants = __webpack_require__(4128);
// EXTERNAL MODULE: ./src/next/components/Header/HeaderLanding.constants.js
var HeaderLanding_constants = __webpack_require__(72612);
// EXTERNAL MODULE: ../shared/store/library/selectors.js
var library_selectors = __webpack_require__(35589);
// EXTERNAL MODULE: ../shared/components/reader/IconButtonsSettings.js + 3 modules
var IconButtonsSettings = __webpack_require__(70977);
;// CONCATENATED MODULE: ../shared/hooks/useKeyboard.js


var useHotKey = function useHotKey(hotkeyData, action) {
  var actionRef = (0,react.useRef)();
  actionRef.current = action;
  (0,react.useEffect)(function () {
    var onDocumentKeyDown = function onDocumentKeyDown(e) {
      if ((0,dom/* isHotKey */.E7)(e, hotkeyData)) {
        actionRef.current(e);
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", onDocumentKeyDown);
    return function () {
      document.removeEventListener("keydown", onDocumentKeyDown);
    };
  }, [hotkeyData]);
};
;// CONCATENATED MODULE: ../shared/hooks/reader/useReaderLinksNavigation.js
function useReaderLinksNavigation_typeof(obj) { "@babel/helpers - typeof"; return useReaderLinksNavigation_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, useReaderLinksNavigation_typeof(obj); }

function useReaderLinksNavigation_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ useReaderLinksNavigation_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == useReaderLinksNavigation_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function useReaderLinksNavigation_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function useReaderLinksNavigation_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { useReaderLinksNavigation_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { useReaderLinksNavigation_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





var useReaderLinksNavigation = function useReaderLinksNavigation(_ref) {
  var idPara = _ref.idPara,
      linkActive = _ref.linkActive,
      indexPanel = _ref.indexPanel,
      onNewLink = _ref.onNewLink,
      isOpenFirstIfNoLinkActive = _ref.isOpenFirstIfNoLinkActive;

  // Implement to {linkFocused} instead, if problems with the immediate link opening.
  var handleHotKeyReaderLink = /*#__PURE__*/function () {
    var _ref2 = useReaderLinksNavigation_asyncToGenerator( /*#__PURE__*/useReaderLinksNavigation_regeneratorRuntime().mark(function _callee(event) {
      var newLink;
      return useReaderLinksNavigation_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newLink = (0,reader/* findNearLink */.V)((0,dom/* isEventKey */.WV)(event, dom/* KeyCode.rightArrow */.VD.rightArrow), linkActive, idPara, indexPanel, isOpenFirstIfNoLinkActive);

            if (newLink) {
              onNewLink(newLink);
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function handleHotKeyReaderLink(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useHotKey(dom/* Hotkey.readerLinkPrev.keyCode */.qm.readerLinkPrev.keyCode, handleHotKeyReaderLink);
  useHotKey(dom/* Hotkey.readerLinkNext.keyCode */.qm.readerLinkNext.keyCode, handleHotKeyReaderLink);
};

/* harmony default export */ var reader_useReaderLinksNavigation = (useReaderLinksNavigation);
// EXTERNAL MODULE: ../shared/components/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(75448);
;// CONCATENATED MODULE: ../shared/hooks/reader/useListenReaderCustomEventTypes.js



var useListenReaderCustomEventTypes = function useListenReaderCustomEventTypes(handlers) {
  var refHandlers = (0,react.useRef)();
  refHandlers.current = handlers;
  (0,react.useEffect)(function () {
    var listenerPlay = function listenerPlay() {
      if (refHandlers.current.playEventHandler) {
        refHandlers.current.playEventHandler();
      }
    };

    var listenerAction = function listenerAction(e) {
      if (refHandlers.current.actionEventHandler) {
        refHandlers.current.actionEventHandler(e.detail.action, e.detail.value);
      }
    }; // Listens for custom event type, that implements the access to {handleAction} method.
    // Is used in the "system.saga.js".


    window.addEventListener(reader_constants/* CUSTOM_EVENT_TYPE_READER_ACTION */.rJ, listenerAction); // Listens for the global event, that calls {handlePlayClick}.
    // Is done so, because this hook is used in the "Reader" context only.
    // But "Header" has the play button, that should behave the way same as the Reader play btn.
    // PS: Another approach could be to "portal" (React Portals) play button to Header.

    window.addEventListener(reader_constants/* CUSTOM_EVENT_TYPE_READER_PLAY */.XE, listenerPlay);
    return function () {
      window.removeEventListener(reader_constants/* CUSTOM_EVENT_TYPE_READER_PLAY */.XE, listenerPlay);
      window.removeEventListener(reader_constants/* CUSTOM_EVENT_TYPE_READER_ACTION */.rJ, listenerAction);
    };
  }, []);
};

/* harmony default export */ var reader_useListenReaderCustomEventTypes = (useListenReaderCustomEventTypes);
// EXTERNAL MODULE: ../shared/store/library/actions.js
var library_actions = __webpack_require__(82900);
;// CONCATENATED MODULE: ../shared/hooks/reader/useReaderSaveHistory.js









var useReaderSaveHistory = function useReaderSaveHistory(activeId, saveML, activeChapterId, isInPlayerAnotherBook) {
  var isEnabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var isUseSingleEndPoint = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dispatch = (0,es/* useDispatch */.I0)();
  var refSaveHistoryParams = (0,react.useRef)({});

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      getPlayerCurrentTime = _useAudioContext.getPlayerCurrentTime,
      playerChapterId = _useAudioContext.chapterId,
      isPlaying = _useAudioContext.isPlaying;

  var syncPlayerAndReader = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id));
  var waveformsDictionary = (0,es/* useSelector */.v9)(player_selectors/* selectorPlayerWaveformsDictionary */.cc);

  var saveRead = function saveRead(chapterId, paraId, saveML) {
    var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    refSaveHistoryParams.current = {
      lastReadChapterId: activeChapterId,
      lastReadId: activeId
    };

    if (isUseSingleEndPoint) {
      var playingParaInformation = (0,player/* findWaveformsDictionaryParaById */.Mp)(waveformsDictionary, chapterId, paraId);
      var position = (playingParaInformation === null || playingParaInformation === void 0 ? void 0 : playingParaInformation.start) || 0;
      dispatch(library_actions/* _sharedActionsLibrary.saveAll */.C.saveAll(chapterId, paraId, position, saveML, delay));
      return;
    }

    dispatch(library_actions/* _sharedActionsLibrary.saveRead */.C.saveRead(chapterId, paraId, saveML, delay));
  };

  var saveListen = function saveListen(chapterId, position, saveML) {
    var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    if (!chapterId) {
      return;
    }

    refSaveHistoryParams.current = {
      lastPlayedChapterId: chapterId
    };

    if (isUseSingleEndPoint) {
      var playingParaInformation = (0,player/* findWaveformsDictionaryParaByPosition */.h$)(waveformsDictionary, chapterId, position);
      dispatch(library_actions/* _sharedActionsLibrary.saveAll */.C.saveAll(chapterId, (playingParaInformation === null || playingParaInformation === void 0 ? void 0 : playingParaInformation.id) || chapterId, position, saveML, delay));
      return;
    }

    dispatch(library_actions/* _sharedActionsLibrary.saveListen */.C.saveListen(chapterId, position, saveML, delay));
  }; // read checkpoint


  (0,react.useEffect)(function () {
    if ( // Listen priority over Reading when sync Reader & Player.
    isPlaying && playerChapterId && syncPlayerAndReader && !isInPlayerAnotherBook || !activeChapterId || !isEnabled) {
      return;
    }

    saveRead(activeChapterId, activeId, saveML, 1000);
  }, [activeChapterId, activeId, saveML, isEnabled]); // listen checkpoint

  (0,react.useEffect)(function () {
    if (!playerChapterId || isInPlayerAnotherBook || !isPlaying || !isEnabled, isPlaying) {
      return;
    }

    saveListen(playerChapterId, getPlayerCurrentTime(), saveML, 1000);
  }, [isEnabled, syncPlayerAndReader, playerChapterId, isInPlayerAnotherBook, isPlaying]); // unmount

  (0,react.useEffect)(function () {
    if (!isEnabled) {
      return undefined;
    }

    return function () {
      var _refSaveHistoryParams = refSaveHistoryParams.current,
          lastReadChapterId = _refSaveHistoryParams.lastReadChapterId,
          lastReadId = _refSaveHistoryParams.lastReadId,
          lastPlayedChapterId = _refSaveHistoryParams.lastPlayedChapterId;

      if (isUseSingleEndPoint) {
        var _waveforms2;

        var position, waveforms;

        if (lastPlayedChapterId) {
          position = getPlayerCurrentTime();
          waveforms = (0,player/* findWaveformsDictionaryParaByPosition */.h$)(waveformsDictionary, lastPlayedChapterId, position);
        } else {
          var _waveforms;

          waveforms = (0,player/* findWaveformsDictionaryParaById */.Mp)(waveformsDictionary, lastPlayedChapterId, lastReadId);
          position = ((_waveforms = waveforms) === null || _waveforms === void 0 ? void 0 : _waveforms.start) || 0;
        }

        dispatch(library_actions/* _sharedActionsLibrary.saveAll */.C.saveAll(lastReadChapterId || lastPlayedChapterId, lastReadId || ((_waveforms2 = waveforms) === null || _waveforms2 === void 0 ? void 0 : _waveforms2.id) || lastPlayedChapterId, position, saveML, 0));
        return;
      }

      if (lastPlayedChapterId) {
        dispatch(library_actions/* _sharedActionsLibrary.saveListen */.C.saveListen(lastPlayedChapterId, getPlayerCurrentTime(), saveML, 0));
      } else if (lastReadChapterId) {
        dispatch(library_actions/* _sharedActionsLibrary.saveRead */.C.saveRead(lastReadChapterId, lastReadId, saveML, 0));
      }
    };
  }, [saveML, isEnabled, waveformsDictionary]);
  return {
    saveRead: saveRead,
    saveListen: saveListen,
    refSaveHistoryParams: refSaveHistoryParams
  };
};

/* harmony default export */ var reader_useReaderSaveHistory = (useReaderSaveHistory);
// EXTERNAL MODULE: ./src/next/components/Reader/ReaderTopPanel/reader-top-panel.module.scss
var reader_top_panel_module = __webpack_require__(83536);
var reader_top_panel_module_default = /*#__PURE__*/__webpack_require__.n(reader_top_panel_module);
;// CONCATENATED MODULE: ./src/next/components/Reader/ReaderTopPanel/ReaderTopPanelLoader.js




var ReaderTopPanelLoader = function ReaderTopPanelLoader() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/react.createElement("div", {
    className: (reader_top_panel_module_default())["reader-top-panel"]
  }, t("loading"), "\u2026");
};

/* harmony default export */ var ReaderTopPanel_ReaderTopPanelLoader = (ReaderTopPanelLoader);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.constants.js
var routes_constants = __webpack_require__(46072);
;// CONCATENATED MODULE: ./src/next/components/Reader/Reader.js
function Reader_typeof(obj) { "@babel/helpers - typeof"; return Reader_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Reader_typeof(obj); }

function Reader_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = Reader_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function Reader_toConsumableArray(arr) { return Reader_arrayWithoutHoles(arr) || Reader_iterableToArray(arr) || Reader_unsupportedIterableToArray(arr) || Reader_nonIterableSpread(); }

function Reader_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function Reader_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function Reader_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return Reader_arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { Reader_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Reader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Reader_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ Reader_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == Reader_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function Reader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function Reader_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { Reader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { Reader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function Reader_slicedToArray(arr, i) { return Reader_arrayWithHoles(arr) || Reader_iterableToArrayLimit(arr, i) || Reader_unsupportedIterableToArray(arr, i) || Reader_nonIterableRest(); }

function Reader_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function Reader_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Reader_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Reader_arrayLikeToArray(o, minLen); }

function Reader_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function Reader_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function Reader_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


















































var ReaderTopPanel = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 628).then(__webpack_require__.bind(__webpack_require__, 90628));
}, {
  ssr: false,
  loading: ReaderTopPanel_ReaderTopPanelLoader
});
var AvailableLangPanel = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 643).then(__webpack_require__.bind(__webpack_require__, 4643));
}, {
  ssr: false
});
var SearchPanel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(349), __webpack_require__.e(867)]).then(__webpack_require__.bind(__webpack_require__, 49867));
}, {
  ssr: false
});
var ShareSelectionModal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 959).then(__webpack_require__.bind(__webpack_require__, 65959));
}, {
  ssr: false
});
var PanelBookContents = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 555).then(__webpack_require__.bind(__webpack_require__, 10555));
}, {
  ssr: false
});
var Portal = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64976));
}, {
  ssr: false
});
var ReaderContext = /*#__PURE__*/react.createContext({});
var jsClassNamePanel = "next-reader-panel";

var Reader = function Reader(_ref) {
  var _book$book_id;

  var isMLHistoryChecked = _ref.isMLHistoryChecked,
      panelsIds = _ref.panelsIds,
      panels = _ref.panels,
      indexPanelActive = _ref.indexPanelActive,
      fontSizeReaderSSR = _ref.fontSizeReaderSSR;

  var _ref2 = panels[indexPanelActive] || {},
      book = _ref2.book,
      toc = _ref2.toc,
      paraList = _ref2.paraList,
      prevChapter = _ref2.prevChapter,
      nextChapter = _ref2.nextChapter,
      isLoading = _ref2.isLoading;

  var paraListParasIds = (0,react.useMemo)(function () {
    var _paraList$paras;

    return paraList === null || paraList === void 0 ? void 0 : (_paraList$paras = paraList.paras) === null || _paraList$paras === void 0 ? void 0 : _paraList$paras.map(function (p) {
      return p.para_id;
    });
  }, [paraList]);

  var _usePagePropsContext = (0,pageProps/* usePagePropsContext */.b)(),
      isLanding = _usePagePropsContext.isLanding,
      isSetCONFLICT = _usePagePropsContext.isSetCONFLICT,
      isSetTESTIMONIES = _usePagePropsContext.isSetTESTIMONIES,
      isSetRPRAC = _usePagePropsContext.isSetRPRAC,
      isSetLanding = _usePagePropsContext.isSetLanding,
      bookTitles = _usePagePropsContext.bookTitles,
      landingBookId = _usePagePropsContext.landingBookId;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var panelsRef = (0,react.useRef)();
  var refPromiseFnUpdatePanels = (0,react.useRef)();
  var router = (0,next_router.useRouter)();
  var isLastInputMouse = (0,useWhatInput/* useWhatInputIsLastPointerMouse */.a)();

  var _useCookiesWithOption = (0,useCookiesWithOptions/* default */.Z)([theme/* COOKIE_KEY_READER_FONT_SIZE */.Es]),
      _useCookiesWithOption2 = Reader_slicedToArray(_useCookiesWithOption, 2),
      cookie = _useCookiesWithOption2[0],
      setCookie = _useCookiesWithOption2[1];

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      chapterId = _useAudioContext.chapterId,
      isPlaying = _useAudioContext.isPlaying,
      playChapterAndShowPlayer = _useAudioContext.playChapterAndShowPlayer,
      getPlayerCurrentTime = _useAudioContext.getPlayerCurrentTime,
      paragraphsAudioPositions = _useAudioContext.paragraphsAudioPositions;

  var openModalDownload = useModalDownload();
  var isMobile = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.untilTablet */.q.untilTablet);
  var isMobileOrTablet = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.untilDesktopAndDesktop */.q.untilDesktopAndDesktop);
  var baseBible = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.baseBible.id */.Fy.baseBible.id));
  var onLine = (0,es/* useSelector */.v9)(selectors/* selectorSystemOnLine */.JU);
  var layoutRedux = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.layout.id */.Fy.layout.id));
  var isTopPanelVisible = (0,es/* useSelector */.v9)(selectors/* selectorSystemIsTopPanelVisible */.eq);
  var currentLayout = panelsIds.length > 1 ? isMobile ? Panel_constants/* layoutIds.l2h */.sO.l2h : layoutRedux || Panel_constants/* layoutIds.l2h */.sO.l2h : Panel_constants/* layoutIds.l1 */.sO.l1;
  var downloadedBooksIds = (0,es/* useSelector */.v9)(selectorDownloadedBooksIds/* selectorDownloadedBooksIds */.F);
  var allHistory = (0,es/* useSelector */.v9)(library_selectors/* selectorHistoryAllHistory */.uV);
  var syncPlayerAndReader = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id));
  var syncByTranslations = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.showTranslations.id */.Fy.showTranslations.id));
  var syncReader = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.syncReader.id */.Fy.syncReader.id));
  var bibles = (0,es/* useSelector */.v9)(mainTree_selectors/* selectorMainTreeBibleVersions */.Q5);
  var biblesIds = (0,react.useMemo)(function () {
    return bibles.map(function (b) {
      return (0,content/* getBookIdWithPrefix */.NR)(b.id);
    });
  }, [bibles]);
  var bookHistory = (0,react.useMemo)(function () {
    return (book === null || book === void 0 ? void 0 : book.id) && allHistory.find(function (bookDataItem) {
      return bookDataItem.id === book.id;
    });
  }, [book === null || book === void 0 ? void 0 : book.id, allHistory]);
  var idPanelMain = panelsIds[0];
  var idPanelSecond = panelsIds[1];
  var idPanelActive = panelsIds[indexPanelActive];
  var activeChapterId = (0,react.useMemo)(function () {
    var _paraList$paras2;

    if (!toc || !paraList) {
      return undefined;
    }

    var paraSuitable = (_paraList$paras2 = paraList.paras) === null || _paraList$paras2 === void 0 ? void 0 : _paraList$paras2.find(function (p) {
      return p.para_id === idPanelActive;
    });
    return paraSuitable ? (0,reader/* findTargetId */.uE)(paraSuitable, toc) : undefined;
  }, [paraList, toc, idPanelActive]);
  var readerPlayerHookInstance = reader_useReaderPlayer({
    bookHistory: bookHistory,
    book: book,
    toc: toc,
    index: indexPanelActive,
    activeChapterId: activeChapterId,
    activeId: idPanelActive,
    fromML: true,
    isIgnoreSettings: true,
    updateActivePanel: function () {
      var _updateActivePanel = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee(idActiveNew) {
        return Reader_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return refPromiseFnUpdatePanels.current;

            case 2:
              _context.next = 4;
              return updatePanel(indexPanelActive, idActiveNew);

            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));

      function updateActivePanel(_x) {
        return _updateActivePanel.apply(this, arguments);
      }

      return updateActivePanel;
    }()
  });
  var handlePlayClick = readerPlayerHookInstance.handlePlayClick,
      currentPlayingPara = readerPlayerHookInstance.currentPlayingPara;

  var handleSearchClick = function handleSearchClick() {
    router.push({
      pathname: routes_constants/* NEXT_URLS.searchLocal */.h.searchLocal
    });
  };

  var _useState = (0,react.useState)(""),
      _useState2 = Reader_slicedToArray(_useState, 2),
      shareSelection = _useState2[0],
      setShareSelection = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      _useState4 = Reader_slicedToArray(_useState3, 2),
      linksActive = _useState4[0],
      setLinksActive = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      _useState6 = Reader_slicedToArray(_useState5, 2),
      showShareModal = _useState6[0],
      setShowShareModal = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      _useState8 = Reader_slicedToArray(_useState7, 2),
      shareUrl = _useState8[0],
      setShareUrl = _useState8[1];

  var setLinkActive = (0,react.useCallback)(function (index, link) {
    setLinksActive(function (valueOld) {
      return _objectSpread(_objectSpread({}, valueOld), {}, Reader_defineProperty({}, index, link));
    });
  }, []);
  var cookieFontSize = parseInt(cookie[theme/* COOKIE_KEY_READER_FONT_SIZE */.Es]);
  var fontSizeFinal = theme/* ReaderFontSizes.default */.Rb["default"];

  if (cookieFontSize && !isNaN(cookieFontSize)) {
    fontSizeFinal = cookieFontSize;
  } else if (fontSizeReaderSSR && !isNaN(fontSizeReaderSSR)) {
    fontSizeFinal = fontSizeReaderSSR;
  }

  var inLibrary = (bookHistory === null || bookHistory === void 0 ? void 0 : bookHistory.inLibrary) || false;
  var isPlayingCurrentBook = isPlaying && (0,content/* getBookIdWithPrefix */.NR)(chapterId) === (book === null || book === void 0 ? void 0 : book.id);
  var isDownloaded = book && downloadedBooksIds.includes((_book$book_id = book.book_id) === null || _book$book_id === void 0 ? void 0 : _book$book_id.toString());

  var _useReaderSaveHistory = reader_useReaderSaveHistory(idPanelActive, inLibrary, activeChapterId, readerPlayerHookInstance.isInPlayerAnotherBook, isMLHistoryChecked, isLanding),
      saveRead = _useReaderSaveHistory.saveRead,
      saveListen = _useReaderSaveHistory.saveListen;

  var refData = (0,useRefData/* default */.Z)({
    router: router,
    isLanding: isLanding,
    panelsIds: panelsIds,
    indexPanelActive: indexPanelActive,
    book: book,
    toc: toc,
    panels: panels,
    paraList: paraList,
    activeChapterId: activeChapterId,
    baseBible: baseBible,
    downloadedBooksIds: downloadedBooksIds,
    onLine: onLine,
    fontSizeFinal: fontSizeFinal,
    syncReader: syncReader,
    isTopPanelVisible: isTopPanelVisible,
    currentLayout: currentLayout,
    syncPlayerAndReader: syncPlayerAndReader,
    inLibrary: inLibrary,
    isPlaying: isPlaying,
    chapterId: chapterId,
    isPlayingCurrentBook: isPlayingCurrentBook,
    paragraphsAudioPositions: paragraphsAudioPositions,
    currentPlayingPara: currentPlayingPara,
    biblesIds: biblesIds
  });

  var getElPanelByIndex = function getElPanelByIndex(indexPanel) {
    return document.querySelector("[".concat(reader_constants/* DATA_ATTR_PANEL_INDEX */.qg, "=\"").concat(indexPanel, "\"]"));
  };

  var scrollParaIntoView = function scrollParaIntoView(indexPanel, idPara) {
    var elPanel = getElPanelByIndex(indexPanel);

    if (elPanel) {
      var elPara = elPanel.querySelector("[".concat(reader_constants/* DATA_ATTR_PARA_ID */.vl, "=\"").concat(idPara, "\"]"));

      if (elPara) {
        elPara.scrollIntoView();
      }
    }
  };

  var getElementPanelActive = function getElementPanelActive() {
    return getElPanelByIndex(indexPanelActive);
  };

  var getReaderSelection = function getReaderSelection() {
    var _windowSelection$anch, _windowSelection$anch2;

    var windowSelection = getSelectionCrossBrowser();

    if (windowSelection !== null && windowSelection !== void 0 && (_windowSelection$anch = windowSelection.anchorNode) !== null && _windowSelection$anch !== void 0 && (_windowSelection$anch2 = _windowSelection$anch.parentNode) !== null && _windowSelection$anch2 !== void 0 && _windowSelection$anch2.closest(".".concat(content_constants/* CONTENT_CLASSES.PARAGRAPH */.J8.PARAGRAPH))) {
      var selectionText = windowSelection.toString().trim();

      if (selectionText) {
        return selectionText;
      }
    }

    return null;
  };

  var getActivePanelElementToCopyOrPrint = function getActivePanelElementToCopyOrPrint() {
    var elActivePanel = getElementPanelActive();

    if (elActivePanel) {
      var elPanelClone = elActivePanel.cloneNode(true);
      var elNoteReaderMode = elPanelClone.querySelector("." + Panel_constants/* CN_EL_READER_MODE */.i);

      if (elNoteReaderMode) {
        elNoteReaderMode.remove();
      }

      var elArrowPlayer = elPanelClone.querySelector("." + Panel_constants/* CN_EL_ARROW_PLAYER */.rn);

      if (elArrowPlayer) {
        elArrowPlayer.remove();
      }

      var elSwipeArrows = elPanelClone.querySelector("." + Panel_constants/* CN_EL_SWIPE_ARROWS */.Jc);

      if (elSwipeArrows) {
        elSwipeArrows.remove();
      }

      var elsIcons = elPanelClone.querySelectorAll("." + IconView_constants/* CN_ICON_VIEW */.B);

      if (elsIcons) {
        elsIcons.forEach(function (i) {
          return i.remove();
        });
      }

      return elPanelClone;
    }

    return "";
  };

  var getPrintSelection = function getPrintSelection() {
    var readerSelection = getReaderSelection();

    if (readerSelection) {
      return readerSelection;
    }

    var elActivePanel = getActivePanelElementToCopyOrPrint();

    if (elActivePanel) {
      return elActivePanel.innerHTML;
    }

    return "";
  };

  var getCopySelection = function getCopySelection(useFallback) {
    var readerSelection = getReaderSelection();

    if (readerSelection) {
      return readerSelection;
    }

    if (useFallback) {
      var elActivePanel = getActivePanelElementToCopyOrPrint();

      if (elActivePanel) {
        return elActivePanel.outerText;
      }
    }

    return "";
  };

  var copy = function copy() {
    var useFallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var event = arguments.length > 1 ? arguments[1] : undefined;
    var copySelection = getCopySelection(useFallback);

    if (copySelection) {
      dispatch(actions/* systemActions.actionCopy */.nm.actionCopy(copySelection, event ? {
        copyEvent: event
      } : undefined));
    }
  };

  var print = function print() {
    var _paraList$paras3;

    var paraFirst = paraList === null || paraList === void 0 ? void 0 : (_paraList$paras3 = paraList.paras) === null || _paraList$paras3 === void 0 ? void 0 : _paraList$paras3[0];
    (0,utils_print/* createPrintWindow */.vX)(getPrintSelection(), (0,utils_print/* makeReaderPrintTitle */.A0)({
      refcode_short: paraFirst.refcode_short,
      title: paraFirst.content
    }));
  };

  var updatePanels = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee2(idsPanels, indexPanelActiveNew) {
      var queryParamsAdditional,
          _refData$current,
          indexPanelActive,
          router,
          queryNew,
          indexPanelActiveFinal,
          panelLinkFinal,
          _args2 = arguments;

      return Reader_regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            queryParamsAdditional = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : undefined;
            _refData$current = refData.current, indexPanelActive = _refData$current.indexPanelActive, router = _refData$current.router;
            clearSelection();
            queryNew = _objectSpread(_objectSpread({}, router.query), {}, Reader_defineProperty({}, Panel_constants/* ReaderQueryParam.panelFirst */.Fd.panelFirst, idsPanels[0]), queryParamsAdditional);
            indexPanelActiveFinal = indexPanelActiveNew !== null && indexPanelActiveNew !== void 0 ? indexPanelActiveNew : indexPanelActive;

            if (indexPanelActiveFinal) {
              queryNew[Panel_constants/* ReaderQueryParam.indexPanelActive */.Fd.indexPanelActive] = indexPanelActiveFinal;
            } else {
              delete queryNew[Panel_constants/* ReaderQueryParam.indexPanelActive */.Fd.indexPanelActive];
            }

            panelLinkFinal = idsPanels[1];

            if (panelLinkFinal) {
              queryNew[Panel_constants/* ReaderQueryParam.panelSecond */.Fd.panelSecond] = panelLinkFinal;
            } else {
              delete queryNew[Panel_constants/* ReaderQueryParam.panelSecond */.Fd.panelSecond];
            }

            if (!(!queryNew[Panel_constants/* ReaderQueryParam.indexPanelActive */.Fd.indexPanelActive] || queryNew[Panel_constants/* ReaderQueryParam.indexPanelActive */.Fd.indexPanelActive] !== indexPanelActive || !queryNew[Panel_constants/* ReaderQueryParam.panelFirst */.Fd.panelFirst] || queryNew[Panel_constants/* ReaderQueryParam.panelFirst */.Fd.panelFirst] !== idPanelMain || !queryNew[Panel_constants/* ReaderQueryParam.panelSecond */.Fd.panelSecond] || queryNew[Panel_constants/* ReaderQueryParam.panelSecond */.Fd.panelSecond] !== idPanelSecond)) {
              _context2.next = 12;
              break;
            }

            refPromiseFnUpdatePanels.current = router.push({
              query: queryNew
            }, undefined, {
              shallow: true
            });
            _context2.next = 12;
            return refPromiseFnUpdatePanels.current;

          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var updateIndexPanelActive = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref4 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee3(indexPanelActiveNew) {
      return Reader_regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return updatePanels(refData.current.panelsIds, indexPanelActiveNew);

          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }(), [updatePanels]);
  var openSecondPanel = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref5 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee4(id, indexPanelActiveNew) {
      var _refData$current2, onLine, downloadedBooksIds, currentLayout, _panelsIds;

      return Reader_regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _refData$current2 = refData.current, onLine = _refData$current2.onLine, downloadedBooksIds = _refData$current2.downloadedBooksIds, currentLayout = _refData$current2.currentLayout;

            if (!(onLine || downloadedBooksIds.includes((0,content/* getBookIdNumber */.o8)(id).toString()))) {
              _context4.next = 10;
              break;
            }

            if (currentLayout === Panel_constants/* layoutIds.l1 */.sO.l1) {
              dispatch(actions/* settingsActions.updateSettings */.ff.updateSettings(Reader_defineProperty({}, settings_constants/* SETTING.layout.id */.Fy.layout.id, Panel_constants/* layoutIds.l2h */.sO.l2h)));
            }

            _context4.next = 5;
            return refPromiseFnUpdatePanels.current;

          case 5:
            _panelsIds = refData.current.panelsIds;
            _context4.next = 8;
            return updatePanels([_panelsIds[0], id], indexPanelActiveNew);

          case 8:
            _context4.next = 11;
            break;

          case 10:
            dispatch(actions/* systemActions.toast */.nm.toast("@sw:bookNotAvailableOffline"));

          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));

    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }(), [updatePanels]);
  var openLink = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref6 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee5(id, idPara, isLinkTypeBible) {
      var skipChangeActive,
          _refData$current3,
          baseBible,
          downloadedBooksIds,
          indexPanelActive,
          onLine,
          syncReader,
          currentLayout,
          panelsIds,
          biblesIds,
          idFinal,
          id2ndSplit,
          isBibleIn2ndSplit,
          targetBible,
          _idFinal$split3,
          _idFinal$split4,
          bookId,
          paraId,
          bibleContent,
          newLinkData,
          newActiveLink,
          _args5 = arguments;

      return Reader_regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            skipChangeActive = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : refData.current.panelsIds.length > 1;
            _refData$current3 = refData.current, baseBible = _refData$current3.baseBible, downloadedBooksIds = _refData$current3.downloadedBooksIds, indexPanelActive = _refData$current3.indexPanelActive, onLine = _refData$current3.onLine, syncReader = _refData$current3.syncReader, currentLayout = _refData$current3.currentLayout, panelsIds = _refData$current3.panelsIds, biblesIds = _refData$current3.biblesIds;
            idFinal = id;
            id2ndSplit = (0,content/* getBookIdWithPrefix */.NR)(panelsIds[1]);
            isBibleIn2ndSplit = biblesIds.some(function (id) {
              return (0,content/* isSameBook */.fr)(id, id2ndSplit);
            });
            targetBible = isBibleIn2ndSplit ? id2ndSplit : baseBible; // Fetch bible link concordance, based on user's {baseBible}.

            if (!(onLine && isLinkTypeBible && !(0,content/* isSameBook */.fr)(idFinal, targetBible))) {
              _context5.next = 12;
              break;
            }

            _idFinal$split3 = idFinal.split("."), _idFinal$split4 = Reader_slicedToArray(_idFinal$split3, 2), bookId = _idFinal$split4[0], paraId = _idFinal$split4[1];
            _context5.next = 10;
            return (0,common/* getContentPreviewBible */.FV)(bookId, [targetBible], [paraId]);

          case 10:
            bibleContent = _context5.sent;

            if (bibleContent !== null && bibleContent !== void 0 && bibleContent[0]) {
              idFinal = bibleContent[0].para_id;
            }

          case 12:
            if (!(onLine || downloadedBooksIds.includes((0,content/* getBookIdNumber */.o8)(idFinal).toString()))) {
              _context5.next = 22;
              break;
            }

            _context5.next = 15;
            return openSecondPanel(idFinal, skipChangeActive ? indexPanelActive : 1);

          case 15:
            if (!syncReader) {
              dispatch(actions/* settingsActions.updateSettings */.ff.updateSettings(settings_constants/* SETTING.syncReader.id */.Fy.syncReader.id, true));
            }

            newLinkData = (0,reader/* findContentLinkById */.rO)(idPara, 0, id);

            if (newLinkData) {
              newActiveLink = (0,reader/* createReaderActiveLink */.hY)(newLinkData.isBible ? content_constants/* CONTENT_CLASSES.EGW_LINK_BIBLE */.J8.EGW_LINK_BIBLE : content_constants/* CONTENT_CLASSES.EGW_LINK_BOOK */.J8.EGW_LINK_BOOK, newLinkData.id, newLinkData.index, newLinkData.paraId);
            } else {
              newActiveLink = null;
            }

            setLinkActive(0, newActiveLink);

            if (currentLayout === Panel_constants/* layoutIds.l1 */.sO.l1) {
              dispatch(actions/* settingsActions.updateSettings */.ff.updateSettings(Reader_defineProperty({}, settings_constants/* SETTING.layout.id */.Fy.layout.id, Panel_constants/* layoutIds.l2h */.sO.l2h)));
            }

            _context5.next = 23;
            break;

          case 22:
            dispatch(actions/* systemActions.toast */.nm.toast("@sw:bookNotAvailableOffline"));

          case 23:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));

    return function (_x7, _x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }(), [setLinkActive, openSecondPanel]);
  var updatePanel = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref7 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee6(indexPanel, id, options) {
      var updatePlayerChapterToo, skipChangeIndexPanelActive, queryParamsAdditional, _refData$current4, panelsIds, toc, paragraphsAudioPositions, indexPanelActive, positionsChapterNew, idsPanelsNew;

      return Reader_regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (options) {
              updatePlayerChapterToo = options.updatePlayerChapterToo;
              skipChangeIndexPanelActive = options.skipChangeIndexPanelActive;
              queryParamsAdditional = options.queryParamsAdditional;
            }

            _refData$current4 = refData.current, panelsIds = _refData$current4.panelsIds, toc = _refData$current4.toc, paragraphsAudioPositions = _refData$current4.paragraphsAudioPositions, indexPanelActive = _refData$current4.indexPanelActive;

            if (updatePlayerChapterToo) {
              if (refData.current.isPlaying && refData.current.syncPlayerAndReader && (0,content/* getBookIdWithPrefix */.NR)(id) === (0,content/* getBookIdWithPrefix */.NR)(refData.current.chapterId) && (0,player/* getAudioChapterByChapterId */.jW)(toc, id)) {
                positionsChapterNew = paragraphsAudioPositions === null || paragraphsAudioPositions === void 0 ? void 0 : paragraphsAudioPositions.find(function (p) {
                  return p.id === id;
                });
                playChapterAndShowPlayer(id, positionsChapterNew ? positionsChapterNew.start : 0);
              }
            }

            idsPanelsNew = Reader_toConsumableArray(panelsIds);
            idsPanelsNew[indexPanel] = id;
            _context6.next = 7;
            return updatePanels(idsPanelsNew, skipChangeIndexPanelActive ? indexPanelActive : indexPanel, queryParamsAdditional);

          case 7:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));

    return function (_x10, _x11, _x12) {
      return _ref7.apply(this, arguments);
    };
  }(), [updatePanels]);

  var toggleLayout = function toggleLayout() {
    var newLayout = currentLayout === Panel_constants/* layoutIds.l2h */.sO.l2h ? Panel_constants/* layoutIds.l2v */.sO.l2v : Panel_constants/* layoutIds.l2h */.sO.l2h;
    dispatch(actions/* settingsActions.updateSettings */.ff.updateSettings(Reader_defineProperty({}, settings_constants/* SETTING.layout.id */.Fy.layout.id, newLayout)));
  };

  var closePanel = (0,react.useCallback)(function (indexPanel) {
    if (indexPanel === undefined) {
      var _refData$current6 = refData.current,
          _router = _refData$current6.router,
          _indexPanelActive = _refData$current6.indexPanelActive,
          _isLanding = _refData$current6.isLanding;

      var newQuery = _objectSpread({}, _router.query);

      if (!_isLanding) {
        if (_indexPanelActive === 0) {
          newQuery[Panel_constants/* ReaderQueryParam.panelFirst */.Fd.panelFirst] = newQuery[Panel_constants/* ReaderQueryParam.panelSecond */.Fd.panelSecond];
        }
      }

      delete newQuery[Panel_constants/* ReaderQueryParam.panelSecond */.Fd.panelSecond];
      delete newQuery[Panel_constants/* ReaderQueryParam.indexPanelActive */.Fd.indexPanelActive];

      _router.push({
        pathname: _router.pathname,
        query: newQuery
      }, undefined, {
        shallow: true
      });
    } else {
      var _refData$current8 = refData.current,
          _router2 = _refData$current8.router,
          _panelsIds2 = _refData$current8.panelsIds;

      var routerQueryNew = _objectSpread(_objectSpread({}, _router2.query), {}, Reader_defineProperty({}, Panel_constants/* ReaderQueryParam.panelFirst */.Fd.panelFirst, indexPanel === 0 ? _panelsIds2[1] : _panelsIds2[0]));

      delete routerQueryNew[Panel_constants/* ReaderQueryParam.panelSecond */.Fd.panelSecond];
      delete routerQueryNew[Panel_constants/* ReaderQueryParam.indexPanelActive */.Fd.indexPanelActive];

      _router2.push({
        query: routerQueryNew
      }, undefined, {
        shallow: true
      });
    }

    setLinkActive(0, null);
  }, [setLinkActive]);

  var openModalDownloadActiveBook = function openModalDownloadActiveBook() {
    openModalDownload(book.book_id);
  };

  var openPanelTranslationsActiveBook = function openPanelTranslationsActiveBook() {
    dispatch(actions/* systemActions.setShowPanelBookTranslations */.nm.setShowPanelBookTranslations(true));
  };

  var handleToggleBookInMLSuccess = function handleToggleBookInMLSuccess(isInLibraryNew) {
    if (isInLibraryNew) {
      saveRead(activeChapterId, idPanelActive, true);

      if (isPlayingCurrentBook) {
        saveListen(chapterId, getPlayerCurrentTime(), true);
      }
    }
  };

  var handleClickBtnContent = function handleClickBtnContent() {
    dispatch(actions/* systemActions.setShowPanelBookContents */.nm.setShowPanelBookContents(true));
  }; // Updates share selection in the state.
  // Replaces browsers copying with Readers copying.


  (0,react.useEffect)(function () {
    var touchStartCoords = null;

    var touchStartListener = function touchStartListener(e) {
      touchStartCoords = (0,dom/* getEventCoordinates */.DC)(e);
    };

    var touchEndListener = function touchEndListener(e) {
      var _e$target;

      if (lib/* isEdge */.un) {
        e.preventDefault(); // Prevent showing `edge mini menus`
      }

      var isDoubleClick = e.detail === 2;

      if ((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.closest("." + jsClassNamePanel) && !isDoubleClick) {
        var coords = (0,dom/* getEventCoordinates */.DC)(e);
        var isRegularClick = touchStartCoords && coords.x === touchStartCoords.x && coords.y === touchStartCoords.y;

        if (!isRegularClick) {
          setShareSelection(getCopySelection(true)); // add share selected text

          if (document.body.classList.contains("selection-mode")) {
            var selectedText = getReaderSelection();

            if (selectedText) {
              // create link
              var currentUrl = new URL(window.location.href);
              currentUrl.searchParams.set("text", encodeURIComponent(selectedText));
              setShareUrl(currentUrl.toString()); // Clear selection before showing modal to prevent jumping on mobile

              clearSelection();
              setShowShareModal(true);
              document.body.style.cursor = "";
              document.body.classList.remove("selection-mode");
            } else {
              // If no text selected, show toast and keep selection mode
              document.body.style.cursor = "text";
            }
          } else {
            copy(false);
          }
        }
      }
    };

    var copyListener = function copyListener(e) {
      // Prevent copy if the cursor is in a text field.
      if ((0,dom/* isFocusTextInput */.hy)()) {
        return;
      }

      copy(true, e);
    }; // Add touch listeners always for mobile support


    document.addEventListener("touchstart", touchStartListener);
    document.addEventListener("touchend", touchEndListener); // Add mouse listeners only when mouse is being used

    if (isLastInputMouse) {
      document.addEventListener("mousedown", touchStartListener);
      document.addEventListener("mouseup", touchEndListener);
    }

    document.addEventListener("copy", copyListener);
    setShareSelection(getCopySelection(true));
    return function () {
      document.removeEventListener("touchstart", touchStartListener);
      document.removeEventListener("touchend", touchEndListener);

      if (isLastInputMouse) {
        document.removeEventListener("mousedown", touchStartListener);
        document.removeEventListener("mouseup", touchEndListener);
      }

      document.removeEventListener("copy", copyListener);
    };
  }, [isLastInputMouse, getCopySelection, copy]); // Resets active link if there is no link panel.

  var panelsCount = panelsIds.length;
  (0,react.useEffect)(function () {
    if (panelsCount < 2) {
      setLinkActive(0, null);
    }
  }, [panelsCount, setLinkActive]);
  (0,react.useEffect)(function () {
    if (refData.current.router.query.playOnLoad) {
      playChapterAndShowPlayer(activeChapterId, refData.current.router.query.pos || 0);
    }
  }, []); // Open link with selected text

  (0,react.useEffect)(function () {
    var urlParams = new URLSearchParams(window.location.search);
    var textParam = urlParams.get("text");

    if (textParam) {
      var decodedText = decodeURIComponent(textParam);
      setTimeout(function () {
        var elPanel = getElementPanelActive();

        if (elPanel) {
          var walker = document.createTreeWalker(elPanel, NodeFilter.SHOW_TEXT, null, false);
          var node;

          while (node = walker.nextNode()) {
            var text = node.textContent;
            var index = text.indexOf(decodedText);

            if (index !== -1) {
              var range = document.createRange();
              range.setStart(node, index);
              range.setEnd(node, index + decodedText.length);
              var selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
              var rect = range.getBoundingClientRect();
              window.scrollTo({
                top: window.scrollY + rect.top - window.innerHeight / 2,
                behavior: "smooth"
              });
              break;
            }
          }
        }
      }, 500);
    }
  }, [getElementPanelActive, router.query]);

  var syncLinkPanelToMainPanel = /*#__PURE__*/function () {
    var _ref8 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee7(idToSearchLinksIn) {
      var newLinkData;
      return Reader_regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!(syncReader && panels.length > 1 && indexPanelActive === 0)) {
              _context7.next = 5;
              break;
            }

            newLinkData = (0,reader/* findFirstVisibleLinkInActiveParaOrJustFirstVisible */.QT)(idToSearchLinksIn, 0);

            if (!newLinkData) {
              _context7.next = 5;
              break;
            }

            _context7.next = 5;
            return openLink(newLinkData.id, newLinkData.paraId, newLinkData.isBible, true);

          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));

    return function syncLinkPanelToMainPanel(_x13) {
      return _ref8.apply(this, arguments);
    };
  }();

  var syncPanelsByTranslations = /*#__PURE__*/function () {
    var _ref9 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee8() {
      var _paraList$paras4, indexPanelToUpdate, idNew, paraActiveIndex, paraToSearchTranslationIn, bookIdPanelToUpdate, translateSuitable;

      return Reader_regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!((syncByTranslations || isLanding) && panels.length > 1)) {
              _context8.next = 8;
              break;
            }

            indexPanelToUpdate = indexPanelActive === 0 ? 1 : 0;

            if (paraList !== null && paraList !== void 0 && (_paraList$paras4 = paraList.paras) !== null && _paraList$paras4 !== void 0 && _paraList$paras4.length) {
              paraActiveIndex = paraList.paras.findIndex(function (p) {
                return p.para_id === idPanelActive;
              });

              if (paraActiveIndex === -1) {
                paraActiveIndex = 0;
              }

              paraToSearchTranslationIn = paraList === null || paraList === void 0 ? void 0 : paraList.paras[paraActiveIndex];

              if (!paraToSearchTranslationIn.translations.length) {
                paraToSearchTranslationIn = paraList.paras.find(function (p) {
                  return p.translations.length;
                });
              }

              if (paraToSearchTranslationIn) {
                bookIdPanelToUpdate = (0,content/* getBookIdNumber */.o8)(panelsIds[indexPanelToUpdate]);
                translateSuitable = paraToSearchTranslationIn.translations.find(function (p) {
                  return (0,content/* isSameBook */.fr)(p.para_id, bookIdPanelToUpdate);
                });

                if (translateSuitable) {
                  idNew = translateSuitable.para_id;
                }
              }
            }

            if (!idNew) {
              _context8.next = 8;
              break;
            }

            _context8.next = 6;
            return refPromiseFnUpdatePanels.current;

          case 6:
            updatePanel(indexPanelToUpdate, idNew, {
              skipChangeIndexPanelActive: true
            });
            return _context8.abrupt("return", true);

          case 8:
            return _context8.abrupt("return", false);

          case 9:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));

    return function syncPanelsByTranslations() {
      return _ref9.apply(this, arguments);
    };
  }();

  var syncPanels = /*#__PURE__*/function () {
    var _ref10 = Reader_asyncToGenerator( /*#__PURE__*/Reader_regeneratorRuntime().mark(function _callee9(firstVisiblePara) {
      var success;
      return Reader_regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return syncPanelsByTranslations();

          case 2:
            success = _context9.sent;

            if (success) {
              _context9.next = 6;
              break;
            }

            _context9.next = 6;
            return syncLinkPanelToMainPanel(firstVisiblePara);

          case 6:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));

    return function syncPanels(_x14) {
      return _ref10.apply(this, arguments);
    };
  }();

  var handleNewLink = function handleNewLink(newLink) {
    openLink(newLink.id, newLink.paraId, newLink.isBible, true);
  };

  reader_useReaderLinksNavigation({
    idPara: idPanelMain,
    indexPanel: indexPanelActive,
    isOpenFirstIfNoLinkActive: panelsIds.length > 1,
    linkActive: linksActive[indexPanelActive],
    onNewLink: handleNewLink
  });
  var readerBooks = panels.map(function (p) {
    return p.book;
  }).filter(function (b) {
    return !!b;
  });
  var nBookIdFirst = (0,content/* getBookIdNumber */.o8)(panelsIds[0]);
  var optionsFilterBooks = (0,react.useMemo)(function () {
    var booksIdsOpened = [];
    var booksLangsOpened = [];
    var options = []; // Include each opened book.

    var _iterator = Reader_createForOfIteratorHelper(readerBooks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var b = _step.value;

        if (!booksIdsOpened.includes(b.book_id)) {
          booksIdsOpened.push(b.book_id);
          booksLangsOpened.push(b.lang);
          options.push((0,utils_select/* makeOption */.D)(b.book_id, b.title));
        }
      } // ========================================
      // Include rest books from the related set of each opened book.

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (isSetLanding && bookTitles) {
      var _iterator2 = Reader_createForOfIteratorHelper(bookTitles),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _book = _step2.value;

          if (booksLangsOpened.includes(_book.lang) && !booksIdsOpened.includes(_book.book_id)) {
            options.push((0,utils_select/* makeOption */.D)(_book.book_id, _book.title));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } // ========================================


    return options;
  }, [isSetLanding, bookTitles, readerBooks]);
  reader_useListenReaderCustomEventTypes({
    playEventHandler: handlePlayClick
  });
  var jsxTopPanel = /*#__PURE__*/react.createElement(ReaderTopPanel, {
    isPanelLoading: isLoading,
    className: (reader_module_default())["reader-top-panel"],
    isDownloaded: isDownloaded,
    isPlaying: isPlaying,
    inLibrary: inLibrary,
    isLanding: isLanding,
    landingBookId: landingBookId,
    currentLayout: currentLayout,
    shareSelection: shareSelection,
    paraList: paraList,
    book: book,
    toc: toc,
    prevChapter: prevChapter,
    nextChapter: nextChapter,
    indexPanelActive: indexPanelActive,
    bookTitles: bookTitles
  });
  return /*#__PURE__*/react.createElement(ReaderContext.Provider, {
    value: {
      indexPanelActive: indexPanelActive,
      idPanelMain: panelsIds[0],
      idPanelLink: panelsIds[1],
      idPanelActive: idPanelActive,
      panelsIds: panelsIds,
      fontSizeFinal: fontSizeFinal,
      book: book,
      paraListParasIds: paraListParasIds,
      copy: copy,
      print: print,
      openSecondPanel: openSecondPanel,
      openLink: openLink,
      updatePanel: updatePanel,
      updateIndexPanelActive: updateIndexPanelActive,
      scrollParaIntoView: scrollParaIntoView,
      initOrPlayOrPauseAudio: handlePlayClick,
      toggleLayout: toggleLayout,
      closePanel: closePanel,
      openModalDownloadActiveBook: openModalDownloadActiveBook,
      openPanelTranslationsActiveBook: openPanelTranslationsActiveBook,
      handleToggleBookInMLSuccess: handleToggleBookInMLSuccess,
      linksActive: linksActive,
      syncPanels: syncPanels,
      readerPlayerHookInstance: readerPlayerHookInstance
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((reader_module_default()).reader, "reader", book === null || book === void 0 ? void 0 : book.realType)
  }, isMobileOrTablet ? /*#__PURE__*/react.createElement(Portal, {
    id: TopPanel_constants/* EL_ID_TOP_PANEL */.d
  }, isMobile && /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    className: (reader_module_default())["btn-content"],
    title: t("content"),
    icon: EgwWebFont/* default.content */.Z.content,
    onClick: handleClickBtnContent
  }), jsxTopPanel) : jsxTopPanel, /*#__PURE__*/react.createElement("div", {
    id: "panelSplit",
    className: classnames_default()((reader_module_default())["panel-split"], (reader_module_default())["layout".concat(panelsIds.length)], (reader_module_default())[currentLayout]),
    ref: panelsRef
  }, panels.map(function (panelData, index) {
    if (!panelData) {
      return /*#__PURE__*/react.createElement("div", {
        key: index
      });
    }

    return /*#__PURE__*/react.createElement(Reader_Panel, {
      key: index,
      currentLayout: currentLayout,
      className: classnames_default()(jsClassNamePanel, (reader_module_default())["wrap-scroller"]),
      index: index,
      data: panelData,
      linkActive: linksActive[index],
      active: indexPanelActive === index,
      fontSize: fontSizeFinal,
      prevChapter: prevChapter,
      nextChapter: nextChapter
    });
  }))), /*#__PURE__*/react.createElement(SearchPanel, {
    nBookIdFirst: isLanding ? nBookIdFirst : undefined,
    optionsFilterBooks: isLanding ? optionsFilterBooks : undefined
  }), /*#__PURE__*/react.createElement(AvailableLangPanel, null), /*#__PURE__*/react.createElement(PanelBookContents, null), showShareModal && /*#__PURE__*/react.createElement(ShareSelectionModal, {
    url: shareUrl,
    onClose: function onClose() {
      setShowShareModal(false);
      setShareUrl("");
    }
  }), /*#__PURE__*/react.createElement(Portal, {
    id: HeaderLanding_constants/* EL_ID_PORTAL_HEADER_ACTIONS */.T
  }, /*#__PURE__*/react.createElement("div", {
    className: (reader_module_default())["header-actions"]
  }, isMobile && /*#__PURE__*/react.createElement(react.Fragment, null, !isSetCONFLICT && !isSetRPRAC && !isSetTESTIMONIES && /*#__PURE__*/react.createElement(IconButtonsSettings/* IconButtonSettingToggleInML */.kU, {
    isVariantBookmark: true,
    color: IconButton/* default.color.headerItem */.Z.color.headerItem,
    book: book,
    onToggleInMLSuccess: handleToggleBookInMLSuccess
  }), /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    className: (reader_module_default())["btn-play"],
    title: t("player"),
    icon: isPlaying ? EgwWebFont/* default.pause-circle */.Z["pause-circle"] : EgwWebFont/* default.play-header */.Z["play-header"],
    color: IconButton/* default.color.headerItem */.Z.color.headerItem,
    onClick: handlePlayClick
  }), (isSetCONFLICT || isSetRPRAC || isSetTESTIMONIES) && /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    className: classnames_default()((reader_module_default())["btn-search"], {
      invisible: isSetTESTIMONIES
    }),
    title: t("search"),
    icon: EgwWebFont/* default.search */.Z.search,
    color: IconButton/* default.color.headerItem */.Z.color.headerItem,
    onClick: handleSearchClick
  })))), /*#__PURE__*/react.createElement(Portal, {
    id: HeaderLanding_constants/* EL_ID_PORTAL_HEADER_ACTIONS_LEFT */.O
  }, isMobile && (isSetCONFLICT || isSetRPRAC || isSetTESTIMONIES) && /*#__PURE__*/react.createElement(IconButtonsSettings/* IconButtonSettingToggleInML */.kU, {
    isVariantBookmark: true,
    color: IconButton/* default.color.headerItem */.Z.color.headerItem,
    book: book,
    onToggleInMLSuccess: handleToggleBookInMLSuccess
  })));
};

Reader.propTypes = {
  panels: (prop_types_default()).array,
  panelsIds: (prop_types_default()).array,
  indexPanelActive: (prop_types_default()).number,
  urlOrigin: (prop_types_default()).string,
  landingBookId: (prop_types_default()).string,
  fontSizeReaderSSR: (prop_types_default()).number,
  isLanding: (prop_types_default()).bool,
  isMLHistoryChecked: (prop_types_default()).bool,
  bookTitles: (prop_types_default()).array
};
/**
 *
 * @returns {{
 *       indexPanelActive: number,
 *       idActive: string,
 *       idPanelMain: string,
 *       idPanelLink: string,
 *       idPanelActive: string,
 *       panelsIds: string[],

 *       fontSizeFinal: number,

 *       book: {}|null,
 *       paraListParasIds: number[]|undefined|null,

 *       copy: function,
 *       print: function,

 *       openSecondPanel: function,
 *       openLink: function,
 *       updatePanel: function,
 *       updateIndexPanelActive: function,
 *       scrollParaIntoView: function,

 *       initOrPlayOrPauseAudio: handlePlayClick: function,
 *       toggleLayout: function,
 *       closePanel: function,
 *       openModalDownloadActiveBook: function,
 *       handleToggleBookInMLSuccess: function,

 *       linksActive: {},

 *       syncPanels: function,

 *       readerPlayerHookInstance: ReaderPlayerHook,
 * }}
 */

var useReaderContext = function useReaderContext() {
  return (0,react.useContext)(ReaderContext);
};
/* harmony default export */ var Reader_Reader = (Reader);

/***/ }),

/***/ 66158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48081);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _SelectBodyTypeRadioButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26930);
/* harmony import */ var _DropDown_DropDownVariantIconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26976);
/* harmony import */ var _utils_select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48018);
/* harmony import */ var _utils_multilang_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54354);







var TRANSLATE_OPTIONS = {
  translateOptions: {
    nsSeparator: false
  }
};

var SelectVariantIconButton = function SelectVariantIconButton(_ref) {
  var _ref$isHideOnSelect = _ref.isHideOnSelect,
      isHideOnSelect = _ref$isHideOnSelect === void 0 ? true : _ref$isHideOnSelect,
      icon = _ref.icon,
      disabled = _ref.disabled,
      active = _ref.active,
      iconTitle = _ref.iconTitle,
      className = _ref.className,
      dropDownClassName = _ref.dropDownClassName,
      options = _ref.options,
      value = _ref.value,
      labels = _ref.labels,
      slotsAfterOptions = _ref.slotsAfterOptions,
      onChange = _ref.onChange,
      _ref$withRadio = _ref.withRadio,
      withRadio = _ref$withRadio === void 0 ? false : _ref$withRadio,
      toggleOnMouseOverLeave = _ref.toggleOnMouseOverLeave,
      id = _ref.id,
      style = _ref.style,
      popupProps = _ref.popupProps;
  var isValueArray = Array.isArray(value);
  var isMoreThanOneSetOfOptions = !!(options !== null && options !== void 0 && options[0] && options.some(function (o) {
    return Array.isArray(o);
  }));
  var isDisabled = !options.length;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var handleChange = function handleChange(valueNew, indexOptionNew, indexGroupOptionNew) {
    if (onChange && valueNew) {
      var valueNewNormalized = (Array.isArray(valueNew) ? valueNew : [valueNew]).map(function (option) {
        return (0,_utils_select__WEBPACK_IMPORTED_MODULE_6__/* .getOptionKey */ ._)(option);
      }); // if value was an array then return as an array of keys.
      // if value was a primitive then return as a primitive key.

      onChange(isValueArray ? valueNewNormalized : valueNewNormalized[0], indexOptionNew, indexGroupOptionNew);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropDown_DropDownVariantIconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    disabled: disabled || isDisabled,
    iconTitle: iconTitle,
    icon: icon,
    className: className,
    active: active,
    toggleOnMouseOverLeave: toggleOnMouseOverLeave,
    id: id,
    style: style,
    popupProps: popupProps
  }, function (_ref2) {
    var hide = _ref2.hide;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SelectBodyTypeRadioButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      className: dropDownClassName,
      withRadio: withRadio,
      value: value,
      slotsAfterOptions: slotsAfterOptions,
      labels: labels,
      options: isMoreThanOneSetOfOptions ? options.map(function (o) {
        return (0,_utils_multilang_i18n__WEBPACK_IMPORTED_MODULE_5__/* .translateObjectsArray */ .iH)(o, t, TRANSLATE_OPTIONS);
      }) : (0,_utils_multilang_i18n__WEBPACK_IMPORTED_MODULE_5__/* .translateObjectsArray */ .iH)(options, t, TRANSLATE_OPTIONS),
      onSelect: function onSelect(valueNew, indexOptionNew, indexGroupOptionNew, e) {
        handleChange(valueNew, indexOptionNew, indexGroupOptionNew);

        if (isHideOnSelect) {
          hide(e);
        }
      }
    });
  });
};

SelectVariantIconButton.defaultProps = {
  withToggleDelayRestriction: true
};
SelectVariantIconButton.propTypes = {
  isHideOnSelect: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().func), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)]),
  iconTitle: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  dropDownClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  options: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array),
  labels: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array),
  value: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)]),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  active: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  maxHeight: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),
  withRadio: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  toggleOnMouseOverLeave: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  id: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectVariantIconButton);

/***/ }),

/***/ 70977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ IconButtonSettingChangeReaderFontSize; },
  "yf": function() { return /* binding */ IconButtonSettingShowRefCodes; },
  "zG": function() { return /* binding */ IconButtonSettingSyncLinks; },
  "JF": function() { return /* binding */ IconButtonSettingSyncPlayerAndReader; },
  "gY": function() { return /* binding */ IconButtonSettingSyncTranslations; },
  "kU": function() { return /* binding */ IconButtonSettingToggleInML; }
});

// UNUSED EXPORTS: IconButtonSettingPageNumbers, IconButtonSettingShowHeaders, IconButtonSettingShowPageBreaks, IconButtonSettingShowSCEntriesInReader, IconButtonSettingSyncReaderAndSearch

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../shared/components/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(75448);
// EXTERNAL MODULE: ../shared/components/Popup/popup.constants.js
var popup_constants = __webpack_require__(29467);
// EXTERNAL MODULE: ../main/src/redux/settings/actions.js
var actions = __webpack_require__(33174);
// EXTERNAL MODULE: ../shared/store/settings/selectors.js
var selectors = __webpack_require__(4787);
// EXTERNAL MODULE: ../shared/api/analitics.js
var analitics = __webpack_require__(82287);
;// CONCATENATED MODULE: ../shared/components/IconButton/IconButtonToggleSetting.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var PROPS_CONTROL_BTN_HIDE_POPUP_ON_CLICK = _defineProperty({}, popup_constants/* DATA_ATTR_HIDE_POPUP_ON_CLICK */.S, true);

var IconButtonToggleSetting_IconButtonToggleSetting = function IconButtonToggleSetting(_ref) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      setting = _ref.setting,
      onContextMenu = _ref.onContextMenu,
      titleEnable = _ref.titleEnable,
      titleDisable = _ref.titleDisable;
  var id = setting.id;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var isEnabled = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(id));
  var title = isEnabled ? titleDisable : titleEnable;
  return /*#__PURE__*/react.createElement(IconButton/* default */.Z, _extends({
    disabled: disabled,
    icon: icon,
    active: isEnabled,
    title: t(title),
    onContextMenu: onContextMenu,
    onClick: function onClick() {
      var isEnabledNew = !isEnabled;
      (0,analitics/* logOtherEvent */.iW)(analitics/* OtherLogEvents.READER_ACTION */.b$.READER_ACTION, {
        id: id,
        value: isEnabledNew
      });
      dispatch(actions/* settingsActions.updateSettings */.f.updateSettings(id, isEnabledNew));
    }
  }, PROPS_CONTROL_BTN_HIDE_POPUP_ON_CLICK));
};

/* harmony default export */ var IconButton_IconButtonToggleSetting = (IconButtonToggleSetting_IconButtonToggleSetting);
// EXTERNAL MODULE: ../node_modules/react-i18next/dist/es/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(29223);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/components/modal/ModalActions.js
var ModalActions = __webpack_require__(35727);
// EXTERNAL MODULE: ../shared/components/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(66636);
// EXTERNAL MODULE: ../shared/components/modal/Modal.constants.js
var Modal_constants = __webpack_require__(91817);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
// EXTERNAL MODULE: ../shared/components/MyLibrary/ToggleInLibraryDialog.module.scss
var ToggleInLibraryDialog_module = __webpack_require__(66145);
var ToggleInLibraryDialog_module_default = /*#__PURE__*/__webpack_require__.n(ToggleInLibraryDialog_module);
;// CONCATENATED MODULE: ../shared/components/MyLibrary/ToggleInLibraryDialog.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }











var ToggleInLibraryDialog = function ToggleInLibraryDialog(_ref) {
  var isRemoveCoupleBooks = _ref.isRemoveCoupleBooks,
      message = _ref.message,
      onConfirm = _ref.onConfirm;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      hideDialog = _useModalContext.hideDialog;

  var _useState = (0,react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      doNotAskAgain = _useState2[0],
      setDoNotAskAgain = _useState2[1];

  return /*#__PURE__*/react.createElement("div", {
    className: (ToggleInLibraryDialog_module_default()).root
  }, /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: Modal_constants/* modalMessageClassName */.B
  }, message), !isRemoveCoupleBooks && /*#__PURE__*/react.createElement(Checkbox/* default */.Z, {
    className: (ToggleInLibraryDialog_module_default()).checkbox,
    title: t("doNotAskAgain"),
    checked: doNotAskAgain,
    onChange: function onChange() {
      setDoNotAskAgain(!doNotAskAgain);
    }
  }), /*#__PURE__*/react.createElement(ModalActions/* default */.Z, {
    onClickNegative: hideDialog,
    onClickPositive: function onClickPositive() {
      onConfirm(doNotAskAgain);
      hideDialog();
    }
  }));
};

ToggleInLibraryDialog.propTypes = {
  message: (prop_types_default()).string,
  onConfirm: (prop_types_default()).func
};
/* harmony default export */ var MyLibrary_ToggleInLibraryDialog = (ToggleInLibraryDialog);
// EXTERNAL MODULE: ../shared/hooks/useLogin.js
var useLogin = __webpack_require__(60370);
// EXTERNAL MODULE: ../shared/store/system/selectors.js
var system_selectors = __webpack_require__(91809);
// EXTERNAL MODULE: ../shared/constants.js
var constants = __webpack_require__(75573);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var settings_constants = __webpack_require__(20467);
// EXTERNAL MODULE: ../shared/store/settings/actions.js
var settings_actions = __webpack_require__(58538);
// EXTERNAL MODULE: ../shared/store/library/actions.js
var library_actions = __webpack_require__(82900);
;// CONCATENATED MODULE: ../shared/hooks/useToggleInLibrary.js













var useToggleInLibrary = function useToggleInLibrary() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      showModal = _useModalContext.showModal;

  var _useLogin = (0,useLogin/* default */.Z)(),
      showLoginConfirm = _useLogin.showLoginConfirm;

  var isLogin = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemIsLogin */.wN);
  var toggleInLibraryBehaviour = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(settings_constants/* SETTING.toggleInLibraryBehaviour.id */.Fy.toggleInLibraryBehaviour.id));

  var _toggle = function _toggle(inLibrary, bookIds, onSuccess) {
    dispatch(library_actions/* _sharedActionsLibrary.toggleBookInMLById */.C.toggleBookInMLById(bookIds));

    if (onSuccess) {
      onSuccess();
    }
  };

  var showToggleInLibraryDialog = function showToggleInLibraryDialog(inLibrary, bookIds, onSuccess) {
    var isRemoveCoupleBooks = Array.isArray(bookIds) && bookIds.length;
    var message = isRemoveCoupleBooks ? t("removeCoupleFromML", {
      count: bookIds.length
    }) : t(inLibrary ? "removeFromML?" : "addToML?");
    var component = /*#__PURE__*/react.createElement(MyLibrary_ToggleInLibraryDialog, {
      isRemoveCoupleBooks: isRemoveCoupleBooks,
      message: message,
      onConfirm: function onConfirm(doNotAskAgain) {
        if (doNotAskAgain) {
          dispatch(settings_actions/* _sharedActionsSettings.updateSettings */.a.updateSettings(settings_constants/* SETTING.toggleInLibraryBehaviour.id */.Fy.toggleInLibraryBehaviour.id, constants/* TOGGLE_IN_LIBRARY_BEHAVIOURS.DO_NOT_ASK */.to.DO_NOT_ASK));
        }

        _toggle(inLibrary, bookIds, onSuccess);
      }
    });
    showModal(component, {
      title: "confirmation"
    });
  };

  var toggleInLibrary = function toggleInLibrary(inLibrary, bookIds, onToggleSuccess) {
    var isRemoveCoupleBooks = Array.isArray(bookIds) && bookIds.length;

    if (isLogin) {
      if (toggleInLibraryBehaviour === constants/* TOGGLE_IN_LIBRARY_BEHAVIOURS.ASK */.to.ASK || isRemoveCoupleBooks) {
        showToggleInLibraryDialog(inLibrary, bookIds, onToggleSuccess);
      } else {
        _toggle(inLibrary, bookIds, onToggleSuccess);
      }
    } else {
      return new Promise(function (resolve) {
        showLoginConfirm(resolve, function () {
          return resolve({
            authWindowWasOpened: true
          });
        });
      });
    }
  };

  return toggleInLibrary;
};

/* harmony default export */ var hooks_useToggleInLibrary = (useToggleInLibrary);
// EXTERNAL MODULE: ../shared/store/system/actions.js
var system_actions = __webpack_require__(93893);
// EXTERNAL MODULE: ../shared/store/library/selectors.js
var library_selectors = __webpack_require__(35589);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var assets_EgwWebFont = __webpack_require__(59034);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/store/shop/selectors.js
var shop_selectors = __webpack_require__(47108);
// EXTERNAL MODULE: ../shared/components/reader/IconButtonsSettings.module.scss
var IconButtonsSettings_module = __webpack_require__(85295);
var IconButtonsSettings_module_default = /*#__PURE__*/__webpack_require__.n(IconButtonsSettings_module);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ../shared/utils/number/number.js
var number = __webpack_require__(50150);
;// CONCATENATED MODULE: ../shared/components/reader/IconButtonsSettings.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function IconButtonsSettings_extends() { IconButtonsSettings_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return IconButtonsSettings_extends.apply(this, arguments); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function IconButtonsSettings_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















var IconButtonSettingSyncLinks = function IconButtonSettingSyncLinks(_ref) {
  var disabled = _ref.disabled;
  return /*#__PURE__*/react.createElement(IconButton_IconButtonToggleSetting, {
    setting: settings_constants/* SETTING.syncReader */.Fy.syncReader,
    icon: assets_EgwWebFont/* default.sync */.Z.sync,
    titleEnable: "enableSync",
    titleDisable: "disableSync",
    disabled: disabled
  });
};
var IconButtonSettingSyncTranslations = function IconButtonSettingSyncTranslations(_ref2) {
  var disabled = _ref2.disabled;
  return /*#__PURE__*/react.createElement(IconButton_IconButtonToggleSetting, {
    setting: settings_constants/* SETTING.showTranslations */.Fy.showTranslations,
    icon: assets_EgwWebFont/* default.translation */.Z.translation,
    titleEnable: "Show translations",
    titleDisable: "Hide translations",
    disabled: disabled
  });
};
var IconButtonSettingSyncReaderAndSearch = function IconButtonSettingSyncReaderAndSearch(_ref3) {
  var disabled = _ref3.disabled;
  return /*#__PURE__*/React.createElement(IconButtonToggleSetting, {
    setting: SETTING.syncReaderAndSearch,
    icon: EgwWebFont["sync-with-feature-search"],
    titleEnable: "syncFeaturedSearchEnable",
    titleDisable: "syncFeaturedSearchDisable",
    disabled: disabled
  });
};
var IconButtonSettingSyncPlayerAndReader = function IconButtonSettingSyncPlayerAndReader(_ref4) {
  var disabled = _ref4.disabled,
      onContextMenu = _ref4.onContextMenu;
  return /*#__PURE__*/react.createElement(IconButton_IconButtonToggleSetting, {
    setting: settings_constants/* SETTING.syncPlayerAndReader */.Fy.syncPlayerAndReader,
    icon: assets_EgwWebFont/* default.sync-with-player */.Z["sync-with-player"],
    titleEnable: "enableSyncR&P",
    titleDisable: "disableSyncR&P",
    disabled: disabled,
    onContextMenu: onContextMenu
  });
};
var IconButtonSettingShowRefCodes = function IconButtonSettingShowRefCodes(_ref5) {
  var disabled = _ref5.disabled;
  return /*#__PURE__*/react.createElement(IconButton_IconButtonToggleSetting, {
    setting: settings_constants/* SETTING.showRefCodes */.Fy.showRefCodes,
    icon: assets_EgwWebFont/* default.bracers */.Z.bracers,
    titleEnable: "Show references",
    titleDisable: "Hide references",
    disabled: disabled
  });
};
var IconButtonSettingShowHeaders = function IconButtonSettingShowHeaders(_ref6) {
  var disabled = _ref6.disabled;
  return /*#__PURE__*/React.createElement(IconButtonToggleSetting, {
    setting: SETTING.showHeaders,
    icon: EgwWebFont["show-headers"],
    titleEnable: "Show headers",
    titleDisable: "Hide headers",
    disabled: disabled
  });
};
var IconButtonSettingPageNumbers = function IconButtonSettingPageNumbers(_ref7) {
  var disabled = _ref7.disabled;
  return /*#__PURE__*/React.createElement(IconButtonToggleSetting, {
    setting: SETTING.showPageNumbers,
    icon: EgwWebFont["page-numbers"],
    titleEnable: "Show page numbers",
    titleDisable: "Hide page numbers",
    disabled: disabled
  });
};
var IconButtonSettingShowPageBreaks = function IconButtonSettingShowPageBreaks(_ref8) {
  var disabled = _ref8.disabled;
  return /*#__PURE__*/React.createElement(IconButtonToggleSetting, {
    setting: SETTING.showPageBreaks,
    icon: EgwWebFont["page-breaks"],
    titleEnable: "Show page breaks",
    titleDisable: "Hide page breaks",
    disabled: disabled
  });
};
var IconButtonSettingShowSCEntriesInReader = function IconButtonSettingShowSCEntriesInReader(_ref9) {
  var disabled = _ref9.disabled;
  return /*#__PURE__*/React.createElement(IconButtonToggleSetting, {
    setting: SETTING.showSCEntriesInReader,
    icon: EgwWebFont["paper-study-center"],
    titleEnable: "Show Study Center elements",
    titleDisable: "Hide Study Center elements",
    disabled: disabled
  });
};
var IconButtonSettingChangeReaderFontSize = function IconButtonSettingChangeReaderFontSize(_ref10) {
  var isIncrease = _ref10.isIncrease,
      onClick = _ref10.onClick;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var value = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(settings_constants/* SETTING.readerFontSize.id */.Fy.readerFontSize.id));

  var handleFontSizeChange = function handleFontSizeChange() {
    var valueDeffer = value || theme/* ReaderFontSizes.default */.Rb["default"];
    var factor = theme/* ReaderFontSizes.factor */.Rb.factor,
        min = theme/* ReaderFontSizes.min */.Rb.min,
        max = theme/* ReaderFontSizes.max */.Rb.max;
    var valueNew = isIncrease ? valueDeffer + factor : valueDeffer - factor;
    dispatch(actions/* settingsActions.updateSettings */.f.updateSettings(settings_constants/* SETTING.readerFontSize.id */.Fy.readerFontSize.id, (0,number/* clutch */.Cz)(valueNew, min, max)));
    (0,analitics/* logOtherEvent */.iW)(analitics/* OtherLogEvents.READER_ACTION */.b$.READER_ACTION, {
      id: settings_constants/* SETTING.readerFontSize.id */.Fy.readerFontSize.id,
      value: valueNew
    });
  };

  return /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    icon: isIncrease ? assets_EgwWebFont/* default.text-increase */.Z["text-increase"] : assets_EgwWebFont/* default.text-decrease */.Z["text-decrease"],
    title: t(isIncrease ? "Larger font" : "Smaller font"),
    onClick: onClick !== null && onClick !== void 0 ? onClick : handleFontSizeChange
  });
};

var IconButtonsSettings_PROPS_CONTROL_BTN_HIDE_POPUP_ON_CLICK = IconButtonsSettings_defineProperty({}, popup_constants/* DATA_ATTR_HIDE_POPUP_ON_CLICK */.S, true);

var IconButtonSettingToggleInML = function IconButtonSettingToggleInML(_ref11) {
  var isVariantBookmark = _ref11.isVariantBookmark,
      className = _ref11.className,
      bordered = _ref11.bordered,
      book = _ref11.book,
      onToggleInMLSuccess = _ref11.onToggleInMLSuccess,
      color = _ref11.color;
  var bookIdNumber = book ? (0,content/* getBookIdNumber */.o8)(book.id) : undefined;

  var _useSharedTranslation2 = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation2.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var toggleInLibrary = hooks_useToggleInLibrary();
  var shopBooks = (0,es/* useSelector */.v9)(shop_selectors/* selectorShopBooks */.af);
  var allHistory = (0,es/* useSelector */.v9)(library_selectors/* selectorHistoryAllHistory */.uV);
  var allHistoryUserId = (0,es/* useSelector */.v9)(library_selectors/* selectorHistoryAllHistoryUserId */.Fr);
  var userInfo = (0,es/* useSelector */.v9)(system_selectors/* selectorUserInfo */.If);
  var userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id;
  var isBookInLibrary = (0,react.useMemo)(function () {
    var bookId = (0,content/* getBookIdWithPrefix */.NR)(bookIdNumber);
    var book = allHistory.find(function (item) {
      return item.id === bookId;
    });
    return !!(book !== null && book !== void 0 && book.inLibrary);
  }, [allHistory, bookIdNumber]);
  var shopBook = shopBooks[bookIdNumber];

  var toggleInML = function toggleInML() {
    return toggleInLibrary(isBookInLibrary, bookIdNumber, onToggleInMLSuccess ? function () {
      if (onToggleInMLSuccess) {
        onToggleInMLSuccess(!isBookInLibrary);
      }
    } : undefined);
  }; // ======== Add to ML on became login if pressed add to ML ==========


  var refIsAddBookToMLOnBecameAuthorized = (0,react.useRef)(false);
  var isLogin = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemIsLogin */.wN);
  var isAllHistoryRelatedToCurrentUser = allHistoryUserId === userId;
  (0,react.useEffect)(function () {
    if (isAllHistoryRelatedToCurrentUser && isLogin && refIsAddBookToMLOnBecameAuthorized.current) {
      if (!isBookInLibrary) {
        toggleInML();
      }

      refIsAddBookToMLOnBecameAuthorized.current = false;
    }
  }, [isLogin, isAllHistoryRelatedToCurrentUser]); // ================================================

  return /*#__PURE__*/react.createElement(IconButton/* default */.Z, IconButtonsSettings_extends({
    trottle: 500,
    bordered: bordered,
    className: className,
    classNameActive: isVariantBookmark ? undefined : (IconButtonsSettings_module_default())["icon-toggle-in-ml-active"],
    icon: isVariantBookmark ? isBookInLibrary ? assets_EgwWebFont/* default.bookmark */.Z.bookmark : assets_EgwWebFont/* default.bookmark-outline */.Z["bookmark-outline"] : assets_EgwWebFont/* default.heart-outline */.Z["heart-outline"],
    title: isBookInLibrary ? t("removeFromLibrary") : t("addToLibrary"),
    active: isBookInLibrary,
    disabled: !book,
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            (0,analitics/* logOtherEvent */.iW)(analitics/* OtherLogEvents.READER_ACTION */.b$.READER_ACTION, {
              id: "toggle in ML"
            }); // if this book is for sale its data from the shop should be fetched by now

            if (!(!shopBook || shopBook.is_purchased)) {
              _context.next = 8;
              break;
            }

            _context.next = 4;
            return toggleInML();

          case 4:
            res = _context.sent;

            if (res !== null && res !== void 0 && res.authWindowWasOpened) {
              refIsAddBookToMLOnBecameAuthorized.current = true;
            }

            _context.next = 9;
            break;

          case 8:
            dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast("@pleaseBuyThisBook"));

          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    color: color
  }, IconButtonsSettings_PROPS_CONTROL_BTN_HIDE_POPUP_ON_CLICK));
};

/***/ }),

/***/ 31427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ selectorBookBaseBible; }
/* harmony export */ });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80406);
/* harmony import */ var _mainTree_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47725);
/* harmony import */ var _settings_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4787);
/* harmony import */ var _utils_settings_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20467);
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69051);





var selectorBookBaseBible = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(_mainTree_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectorMainTreeBibleVersions */ .Q5, (0,_settings_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorSetting */ .K)(_utils_settings_constants__WEBPACK_IMPORTED_MODULE_2__/* .SETTING.baseBible.id */ .Fy.baseBible.id), function (bibles) {
  var baseBible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_settings_constants__WEBPACK_IMPORTED_MODULE_2__/* .SETTING.baseBible["default"] */ .Fy.baseBible["default"];
  var baseBibleId = (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_3__/* .getBookIdWithPrefix */ .NR)(baseBible);
  return bibles.find(function (b) {
    return b.id === baseBibleId;
  });
});

/***/ }),

/***/ 45884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ defaultContactTag; },
/* harmony export */   "LD": function() { return /* binding */ emailRegExp; },
/* harmony export */   "Tb": function() { return /* binding */ MAX_FILE_SIZE; },
/* harmony export */   "ae": function() { return /* binding */ initValues; },
/* harmony export */   "k6": function() { return /* binding */ fileFormatRegex; },
/* harmony export */   "kl": function() { return /* binding */ initErrors; },
/* harmony export */   "zn": function() { return /* binding */ paraPictureRegExp; }
/* harmony export */ });
var defaultContactTag = "egwweb";
var paraPictureRegExp = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
var emailRegExp = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/;
var fileFormatRegex = /(.*?)\.(docx|doc|pdf|xml|bmp|ppt|xls|txt|log|mp4|mov|wmv|flv|avi|mkv|jpeg|jpg|png)$/;
var MAX_FILE_SIZE = 10000000;
var initValues = {
  domain: "main",
  lang: "en",
  contact: "",
  name: "",
  email: "",
  message: ""
};
var initErrors = {
  contact: "",
  name: "",
  email: "",
  message: ""
};

/***/ }),

/***/ 77149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ makeReaderPrintTitle; },
/* harmony export */   "vX": function() { return /* binding */ createPrintWindow; }
/* harmony export */ });
/* unused harmony exports makeSearchPrintTitle, createPrintWindowFile */
/* harmony import */ var _theme_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93752);


var createStyles = function createStyles() {
  return "\n      <style>\n        body {\n          font-size: 16px;\n          padding: 1em;\n          font-family: sans-serif;\n        }\n\n        .egwwritings {\n          color: var(--category-egw);\n          fill: var(--category-egw);\n        }\n\n        .egwwritings.mark {\n          background: var(--category-egw);\n          color: white;\n        }\n\n        .search-item-wrap {\n          font-family: \"Roboto Condensed\", sans-serif;\n          cursor: pointer;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          border-bottom: 1px solid var(--icon-color);\n          padding: 14px;\n          box-sizing: border-box;\n        }\n\n        .search-item-title {\n          font-family: \"Roboto Condensed\", sans-serif;\n          font-style: normal;\n          font-weight: bold;\n          white-space: nowrap;\n          height: 25px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-size: 16px;\n          text-transform: uppercase;\n          line-height: 32px;\n        }\n\n        .search-item-snippet {\n          font-family: \"Roboto Condensed\", sans-serif;\n          color: var(--text-default);\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 1.25;\n          max-height: calc(100% - 35px);\n        }\n\n        .search-item-wrap.egwwritings .search-item-snippet,\n        .search-item-wrap.reference .search-item-snippet,\n        .search-item-wrap.bible .search-item-snippet,\n        .search-item-wrap.apl .search-item-snippet {\n          color: var(--text-default);\n        }\n      </style>\n    ";
};

var makeSearchPrintTitle = function makeSearchPrintTitle(t, query, from, to) {
  return "".concat(t("searchResults"), " \"").concat(query, "\" (").concat(from, " - ").concat(to, ")");
};
var makeReaderPrintTitle = function makeReaderPrintTitle(chapter) {
  if (chapter) {
    return chapter.refcode_short + " — " + chapter.title;
  }

  return undefined;
};
var createPrintWindow = function createPrintWindow(html) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Print";
  var win = window.open(undefined, "_blank");

  if (win && win.document) {
    win.document.write("<title>" + title + "</title>");
    win.document.write("<link rel=\"stylesheet\" href=\"".concat(window.location.origin, "/styles/").concat(_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .DefaultThemeId */ .fy, ".css\"/>"));
    win.document.write(createStyles());
    win.document.write(html);
    win.focus();
    win.print();
  } else {
    alert("Your browser prevented the window from opening Please allow to open a new window.");
  }
};
var createPrintWindowFile = function createPrintWindowFile(url) {
  var win = window.open(url, "_blank");

  if (win && win.document) {
    win.focus(); // win.print();
  } else {
    alert("Your browser prevented the window from opening Please allow to open a new window.");
  }
};

/***/ }),

/***/ 87592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","dictionary-popup-wrap":"dictionary-popup_dictionary-popup-wrap__4TzlB","dictionary-popup":"dictionary-popup_dictionary-popup__FBu0p","popup-header":"dictionary-popup_popup-header__7aCty","header-input":"dictionary-popup_header-input__9n9Ai","input-title":"dictionary-popup_input-title__bkSn3","content-wrap":"dictionary-popup_content-wrap__YuKDl","dictionary-list":"dictionary-popup_dictionary-list__UG_xz","active":"dictionary-popup_active__N9Lf2","dictionary-item-title":"dictionary-popup_dictionary-item-title__QJ53L","dictionary-item-wrap":"dictionary-popup_dictionary-item-wrap__A47YY","list":"dictionary-popup_list__lxpyV","indent1":"dictionary-popup_indent1__lZuQM","indent2":"dictionary-popup_indent2__7uyko","selected":"dictionary-popup_selected__9Mp3A"};

/***/ }),

/***/ 48928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","para":"para-list_para__sC_ov","right":"para-list_right__rI1eY","refCode":"para-list_refCode__Wik0T","info-bookDesc":"para-list_info-bookDesc__kSdAj","book-info":"para-list_book-info__E03E4","info-buttons":"para-list_info-buttons__FunvC","para-picture":"para-list_para-picture__TjcW3"};

/***/ }),

/***/ 83536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","readerTranslationsPopupHeight":"7.1","reader-top-panel":"reader-top-panel_reader-top-panel__gZRDG","reader-top-panel__controls":"reader-top-panel_reader-top-panel__controls__Y0qQl","btn-para-control":"reader-top-panel_btn-para-control__KO5fs","btn-prev-para":"reader-top-panel_btn-prev-para__IUT8c","btn-next-para":"reader-top-panel_btn-next-para__6wYmw","reader-nav-link":"reader-top-panel_reader-nav-link__ZuX2o","reader-top-panel__search-controls":"reader-top-panel_reader-top-panel__search-controls__2FO1N","reader-top-panel__search-nav":"reader-top-panel_reader-top-panel__search-nav__RFNbk","reader-nav-link-icon":"reader-top-panel_reader-nav-link-icon__x_rpg","hidden":"reader-top-panel_hidden__sjGhM","is-last-input-mouse":"reader-top-panel_is-last-input-mouse__b1ymH"};

/***/ }),

/***/ 69254:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","readerTranslationsPopupHeight":"7.1","root":"reader_root__MxpJE","btn-content":"reader_btn-content__GRmpC","reader":"reader_reader__AXzTU","reader-list":"reader_reader-list__qAAgG","is-loading":"reader_is-loading__JyvvT","disable-interaction":"reader_disable-interaction__9AyFj","passive-reader":"reader_passive-reader__6TI_J","bible-number":"reader_bible-number__nMVwr","arrow-player":"reader_arrow-player__qbHH0","live-reading":"reader_live-reading__jdAb_","ready-syncing-with-player":"reader_ready-syncing-with-player__I0y_R","arrow-loading":"reader_arrow-loading__y5L18","syncing-with-player":"reader_syncing-with-player___QXxk","standard-indented":"reader_standard-indented__hLj1r","reader-panel-hide-marks":"reader_reader-panel-hide-marks__r_s25","reader__popup-translations__inner":"reader_reader__popup-translations__inner__Msqs7","reader-buy-book":"reader_reader-buy-book__4u_nM","show-search-icon":"reader_show-search-icon__lAYyX","reader-top-panel":"reader_reader-top-panel__eExvm","search-clear-icon":"reader_search-clear-icon__l4bu6","wrap-scroller":"reader_wrap-scroller__dYNNc","panel-split":"reader_panel-split__GElXO","l2v":"reader_l2v__J_YPR","l2h":"reader_l2h__nqEGP","header-actions":"reader_header-actions__r40yQ","mode-blind":"reader_mode-blind__87vCB","swipe-arrows":"reader_swipe-arrows__YG1It","animationSlideInLeft":"reader_animationSlideInLeft__Rb_SF","animationSlideInRight":"reader_animationSlideInRight__UCc9v","animationFadeIn":"reader_animationFadeIn__Z8dP4","animationFade":"reader_animationFade__poyPO"};

/***/ }),

/***/ 68431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","modal":"ModalDownload_modal__ssHLF","modal_body":"ModalDownload_modal_body__JuSi9","modal-actions":"ModalDownload_modal-actions__vUL13","note":"ModalDownload_note__Zo0p_","book-item":"ModalDownload_book-item__6EOHm","book-item_wrap":"ModalDownload_book-item_wrap__yicng","book-item_cover":"ModalDownload_book-item_cover__khwub","book-item_book-content":"ModalDownload_book-item_book-content__RBQAc","book-item_right":"ModalDownload_book-item_right__ed_d5","accordion-head_mp3":"ModalDownload_accordion-head_mp3__AYza3","table-mp3":"ModalDownload_table-mp3__heG7f","audio-chapter-item":"ModalDownload_audio-chapter-item__Y6rjj","audio-chapter_actions":"ModalDownload_audio-chapter_actions__60d3Y"};

/***/ }),

/***/ 25136:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readerTranslationsPopupHeight":"7.1"};

/***/ }),

/***/ 66145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleInLibraryDialog_root__dZtGS","checkbox":"ToggleInLibraryDialog_checkbox__6k2Q0"};

/***/ }),

/***/ 37741:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ReaderModeOnlyElement_root__6Qn2e"};

/***/ }),

/***/ 85295:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","icon-toggle-in-ml-active":"IconButtonsSettings_icon-toggle-in-ml-active__xTQze","is-last-input-mouse":"IconButtonsSettings_is-last-input-mouse__Rz_vu"};

/***/ })

}]);